import { ScenarioScript } from "@/lib/scenarioScript";

// ========== 场景一：职场 (Office) ==========

// 1. 无妄之灾（背锅） (Office 01)
export const officeBlameScript: ScenarioScript = {
  id: "office_01",
  title: "无妄之灾",
  titleKey: "gameplay.sceneTitles.office_01",
  sceneImage: "/scenarios/office_01.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "周一早晨的例会，空气中弥漫着压抑的低气压。老板黑着脸，将一份打印出来的月度报告重重摔在会议桌上，纸张散落的声音在死寂的房间里显得格外刺耳。",
      textKey: "gameplay.dialogues.office_01.opening.1"
    },
    {
      type: "npc",
      speaker: "老板",
      speakerKey: "gameplay.characters.boss",
      text: "谁能给我解释一下，为什么上周五发给核心客户的数据全是错的？百分之三的误差！你们知道这会让公司显得多不专业吗？",
      textKey: "gameplay.dialogues.office_01.opening.2"
    },
    {
      type: "npc",
      speaker: "老张",
      speakerKey: "gameplay.characters.laozhang",
      text: "（眼神闪躲了一下，随即立刻指向你）老板，这部分数据汇总……是小李（你）负责整理的。我当时发给他的时候就提醒过要复核，看来他还是没太上心……",
      textKey: "gameplay.dialogues.office_01.opening.3"
    },
    {
      type: "narrator",
      text: "你的大脑“嗡”的一声。那份原始数据明明是老张周五临下班前才丢给你的，而且错误就在他的源文件中。你只是负责格式汇总。此刻，他竟然脸不红心不跳地当众把黑锅全扣在了你头上。",
      textKey: "gameplay.dialogues.office_01.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "victim_choice",
        label: "忍气吞声（低头认错）",
        labelKey: "gameplay.options.office_01.invisible",
        archetype: "隐形人",
        visualEffect: "dark", 
        followUp: [
          {
            type: "narrator",
            text: "巨大的羞耻感瞬间淹没了你。你的喉咙发紧，仿佛有一双无形的大手掐住了你的脖子。你不敢看老板的眼睛，只想让这场审判快点结束。",
            textKey: "gameplay.dialogues.office_01.survival.invisible.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（声音如蚊呐）对不起老板……是我没检查好……下次不会了。",
            textKey: "gameplay.dialogues.office_01.survival.invisible.2"
          },
          {
            type: "failure",
            text: "你背下了这口黑锅。老板失望地摇摇头，给你贴上了“能力不足”的标签。老张在桌下暗自松了口气。你感到一种深深的无力感，仿佛自己正在从这个世界消失。",
            textKey: "gameplay.dialogues.office_01.survival.invisible.3"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "愤怒回击（当场对质）",
        labelKey: "gameplay.options.office_01.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "一股灼热的怒火直冲天灵盖。这一刻，你觉得自己被全世界背叛了。你想都没想，猛地拍案而起。",
            textKey: "gameplay.dialogues.office_01.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "老张你还要脸吗？！这数据明明是你发邮件给我的！源文件就在我电脑里，你要不要现在就对质？！自己做错了事想赖我？门都没有！",
            textKey: "gameplay.dialogues.office_01.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "会议室瞬间变成了菜市场。老板厌烦地摔门而去：“都给我出去吵！”你虽然赢了口舌，却输了体面，被整个部门贴上了“情绪不稳定、难合作”的标签。",
            textKey: "gameplay.dialogues.office_01.survival.tyrant.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：职场不是法庭，而是解决问题的工场",
      titleKey: "gameplay.directorNote.office_01.title",
      contentKey: "gameplay.directorNote.office_01.content",
      content: `亲爱的导演，欢迎来到你人生剧本的第一场重头戏。

面对突如其来的“背锅”和“指责”，我们的爬行脑（Reptilian Brain）会瞬间接管身体，启动最原始的生存本能：战斗或逃跑。这就是为什么刚才那两个选项如此诱人，因为它们是自动化的、无意识的反应。

第一位抢麦的演员，是那个蜷缩在阴影里的**“隐形人”（Energy 20: Shame）**。
当你选择忍气吞声时，你其实是在对自己说：“请别看我。我搞砸了。我的存在本身就是一个错误。” 隐形人相信，一旦被看见，就意味着被审判。所以你选择认错，不是因为你真的错了，而是因为你试图通过自我攻击来换取一种“我不反抗，你就不会再打我”的虚假安全感。但代价是，你亲手把那个“无能”的标签贴在了自己脑门上，你的能量极度萎缩，你在向宇宙宣告：“我不配被公正对待。”

第二位冲上来的演员，是那个身穿红色盔甲的**“暴君”（Energy 150: Anger）**。
当你选择愤怒回击时，你的核心台词是：“这太不公平了！是他们挡了我的路！”你把会议室变成了一个战场，把同事变成了必须消灭的敌人。你试图用更大的声音来证明“我是对的，你是错的”。虽然这让你感觉暂时有力量，但这是一种虚假的力量。正如书中所说，你成为了一个剑拔弩张的人，镜子自然也会回敬你一个充满敌意的世界。而且，老板需要的不是一个“我是对的”的辩论冠军，而是一个能解决问题的战友。

但这只是一场戏。
你不是那个无助的受害者，也不是那个愤怒的斗士。你，是这出戏唯一的导演。

现在，请按下【暂停的锚点】。
深呼吸。感受空气进入肺部，感受脚底踩在地板上的坚实感。
看着那个焦虑的老板，看着那个滑头的老张，对自己说：“这只是一场戏。他们不是针对我，他们只是在演他们自己的恐惧。老板恐惧失控，老张恐惧担责。”

当你不再与他们的恐惧共振，你就赢得了切换频道的机会。
请邀请**“实干家”（Energy 250/310: Neutrality & Willingness）**登场。

在实干家眼里，世界不是战场，而是一个“工作坊”。
所谓的“被冤枉”、“进度条红色”，不再是攻击你尊严的武器，它们仅仅是摆在工作台上需要处理的“素材”和“数据”。
实干家的台词是：“事情就是这样了。抱怨没有用。现在最重要的问题是：我们能做些什么？”

不要去纠结过去是谁的错（那是“罪人”的剧本），也不要试图去证明自己是对的（那是“演员”的剧本）。
将聚光灯打在“解决方案”上。当你放下防御，只谈事实和下一步时，你就拿回了真正的力量。

试试看，用这种能量说话，看看剧本会如何改写：`
    },
    creativeOption: {
      id: "doer_choice",
      label: "理智应对（聚焦解决）",
      labelKey: "gameplay.options.office_01.doer",
      archetype: "实干家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你做了一次深长的呼吸，那股冲上头顶的怒火，被你温柔地看见，然后慢慢降温，转化成了一种冷静、锋利的动力。你从“受害者”的角色中抽离，成为了局面的掌控者。",
          textKey: "gameplay.dialogues.office_01.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（眼神平静地看着老板，语气平稳，不带一丝情绪）老板，我非常理解您对进度的焦虑，客户那边的压力的确很大。现在去纠结上周五的信息差，无法解决当下的红灯问题。",
          textKey: "gameplay.dialogues.office_01.creative.2"
        },
        {
          type: "narrator",
          text: "老板准备好的训斥被你这种不带情绪的陈述堵了回去，他愣了一下，眼神里的攻击性消退了一些，似乎在等待你的下文。",
          textKey: "gameplay.dialogues.office_01.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "目前的卡点非常明确，就在法务材料的合规性上。为了在今天下班前把进度抢回来，我建议分两步走：第一，我现在会议结束后立刻带着老张去法务部现场办公，把材料当场补齐；第二，我们需要建立一个48小时预警机制，避免下次再出现这种临期沟通。",
          textKey: "gameplay.dialogues.office_01.creative.4"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（转头看向老张，微笑着，眼神却不容置疑）老张，为了赶进度，今天上午可能要辛苦你专门腾出时间配合我一下了，没问题吧？",
          textKey: "gameplay.dialogues.office_01.creative.5"
        },
        {
          type: "narrator",
          text: "老张被你这种“既往不咎但必须干活”的态度架住了，你的高维能量让他原本准备好的推脱之词无法出口，只好尴尬地点头：“啊……行，行，项目要紧。”",
          textKey: "gameplay.dialogues.office_01.creative.6"
        },
        {
          type: "npc",
          speaker: "老板",
          speakerKey: "gameplay.characters.boss",
          text: "（脸色缓和，甚至露出一丝赞许）……行。要的就是这个执行力。那就这么定，今天下班前我要看到结果。",
          textKey: "gameplay.dialogues.office_01.creative.7"
        },
        {
          type: "success",
          text: "空气重新开始流动。你没有把自己当成受害者，也没有把同事当成敌人，而是把“冲突”转化为了“任务”。你感到一种掌控局面的、踏实的力量感。这就是“实干家”的魅力：不在此刻纠缠，只为结果负责。",
          textKey: "gameplay.dialogues.office_01.creative.8"
        }
      ]
    }
  }
};

// 2. 薪资谈判 (Office 02)
export const officeSalaryScript: ScenarioScript = {
  id: "office_02",
  title: "薪资谈判",
  titleKey: "gameplay.sceneTitles.office_02",
  sceneImage: "/scenarios/office_02.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "你站在老板办公室的门前，手里紧紧攥着那份打印好的业绩报告。这已经是你连续第三个季度超额完成KPI，甚至还主动承担了额外的项目管理工作。理智告诉你，现在是谈涨薪的最佳时机。",
      textKey: "gameplay.dialogues.office_02.opening.1"
    },
    {
      type: "narrator",
      text: "但是，你的身体却在背叛你。心跳快得像擂鼓，手心全是冷汗。透过百叶窗的缝隙，你看到老板正严肃地盯着电脑屏幕，眉头紧锁。",
      textKey: "gameplay.dialogues.office_02.opening.2"
    },
    {
      type: "inner_monologue",
      text: "（心中的声音）“他看起来心情不好……现在进去会不会撞枪口上？万一被拒绝了多尴尬？以后还怎么相处？”",
      textKey: "gameplay.dialogues.office_02.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "coward_choice",
        label: "退缩逃避（找借口离开）",
        labelKey: "gameplay.options.office_02.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "恐惧瞬间占据了上风。你的脑海里上演了一万种被拒绝、被嘲讽、甚至被解雇的灾难片。你的手在门把手上悬停了半天，最终无力地垂下。",
            textKey: "gameplay.dialogues.office_02.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "老板",
            speakerKey: "gameplay.characters.boss",
            text: "（突然抬头看到门口的影子）谁在那？有事吗？",
            textKey: "gameplay.dialogues.office_02.survival.coward.2"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（慌乱地）啊……没事老板，我就是路过，顺便看看那份周报您收到了没。",
            textKey: "gameplay.dialogues.office_02.survival.coward.3"
          },
          {
            type: "failure",
            text: "你像逃兵一样快步回到了工位。那一刻，你恨透了自己的软弱。你保住了所谓的“安全”，却再一次背叛了自己的价值。",
            textKey: "gameplay.dialogues.office_02.survival.coward.4"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "愤愤不平（等待被施舍）",
        labelKey: "gameplay.options.office_02.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "一股酸涩的委屈涌上心头。你觉得既然自己做得这么好，老板理应主动看到并给你加薪。如果还要自己去“乞求”，那这份认可就太廉价了。",
            textKey: "gameplay.dialogues.office_02.survival.victim.1"
          },
          {
            type: "inner_monologue",
            text: "（转身离开，心里生着闷气）“算了吧。既然他眼瞎看不到我的付出，我又何必去自取其辱？这破公司，根本不值得我卖命。”",
            textKey: "gameplay.dialogues.office_02.survival.victim.2"
          },
          {
            type: "failure",
            text: "你带着满腹的怨气回到了座位，开始在那份原本完美的PPT上敷衍了事。你以为你在惩罚公司，其实你只是在用“受害者”的剧本，一点点熄灭自己的职业热情。",
            textKey: "gameplay.dialogues.office_02.survival.victim.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：勇气不是没有恐惧，而是带着恐惧前行",
      titleKey: "gameplay.directorNote.office_02.title",
      contentKey: "gameplay.directorNote.office_02.content",
      content: `亲爱的导演，这一幕戏名为“价值的谈判”，但实际上，这是一场关于“自我确认”的内在战争。

我想请你看着门口那个瑟瑟发抖的自己。你的手心为什么出汗？因为你的爬行脑在尖叫：“危险！”
在远古时代，被部落首领拒绝可能意味着死亡。而在现代职场，这种对生存的恐惧被投射到了金钱和权威上。

第一位登场的**“懦夫”（Energy 100: Fear）**，是一个灾难片的编剧。
他极其擅长编写“万一”的故事：“万一老板觉得我贪心怎么办？”“万一他不仅不给，还对我印象变差怎么办？”懦夫试图通过“不行动”来规避所有风险，但他忘记了，最大的风险，是你永远无法兑现你的潜力。当你听信懦夫的台词时，你就在向宇宙宣告：“我很渺小，我不配拥有更多。”

第二位登场的**“受害者”（Energy 75: Grief）**，则是一个悲情剧的主角。
他的逻辑是：“如果他爱我（认可我），他就应该能读懂我的心。”这是一种巨婴式的全能自恋。受害者拒绝承担“主动沟通”的成人责任，而试图通过“生闷气”来被动攻击。但这在职场是行不通的。老板不是你的父母，他没有义务去猜你的心思。

现在，请按下【暂停的锚点】。
把手放在那颗狂跳的心脏上。不要试图去压抑那份恐惧，也不要责怪自己的软弱。
对自己说：“我看见你了，恐惧。谢谢你试图保护我免受拒绝。但现在，我要去做的，不是一场生死的审判，而是一次成人的商业对话。”

请邀请**“探险家”（Energy 200: Courage）**登场。
探险家并非无所畏惧。真正的勇气，是双腿发抖，但依然迈出脚步。
探险家知道：
1. **价值是客观的**：你的业绩数据是真实的，这不是吹牛，是事实陈述。
2. **拒绝是允许的**：即使老板拒绝，也不代表你整个人被否定，只代表当下的预算或时机不匹配。
3. **行动即胜利**：敲门进去的那一刻，你就已经赢了。因为你战胜了内在的“渺小感”。

把这次谈判看作一次探索可能性的“冒险”，而不是一次乞求施舍的“任务”。深呼吸，敲门。你的价值，需要你自己大声宣告。`
    },
    creativeOption: {
      id: "explorer_choice",
      label: "勇敢敲门（带着恐惧前行）",
      labelKey: "gameplay.options.office_02.explorer",
      archetype: "探险家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你承认了自己的恐惧，那是真实的生理反应。但你没有让恐惧握住方向盘。你做了一个深呼吸，感受着心脏的跳动，把它转化为推进的燃料。",
          textKey: "gameplay.dialogues.office_02.creative.1"
        },
        {
          type: "action",
          text: "“咚、咚、咚”。你敲响了门。声音比你想象的要坚定。",
          textKey: "gameplay.dialogues.office_02.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（走进办公室，直视老板的眼睛）老板，打扰五分钟。我想跟您聊聊我这几个季度的项目复盘，以及……我对未来薪资架构的一些想法。",
          textKey: "gameplay.dialogues.office_02.creative.3"
        },
        {
          type: "narrator",
          text: "你没有卑微地乞求，也没有情绪化地抱怨。你拿出了那份沉甸甸的数据报告，像展示战利品一样，不卑不亢地展示了你的价值。你把谈判变成了一场平等的商业价值交换。",
          textKey: "gameplay.dialogues.office_02.creative.4"
        },
        {
          type: "npc",
          speaker: "老板",
          speakerKey: "gameplay.characters.boss",
          text: "（放下手里的工作，认真地翻看你的报告）……说实话，如果你不提，我最近太忙还真没注意到Project Alpha是你一个人扛下来的。你的数据很有说服力。",
          textKey: "gameplay.dialogues.office_02.creative.5"
        },
        {
          type: "success",
          text: "无论最终涨薪的数字是多少，当你走出办公室那一刻，你感到前所未有的轻盈。因为你知道，你刚刚不仅谈了一笔生意，更重要的是，你哪怕带着恐惧，也坚定地站在了自己这一边。这就是“探险家”的奖赏。",
          textKey: "gameplay.dialogues.office_02.creative.6"
        }
      ]
    }
  }
};

// 3. 甚至不敢请假 (Office 03)
export const officeSickLeaveScript: ScenarioScript = {
  id: "office_03",
  title: "甚至不敢请假",
  titleKey: "gameplay.sceneTitles.office_03",
  sceneImage: "/scenarios/office_03.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "早晨醒来，你感觉头重脚轻，体温计显示39度。浑身的关节像生锈了一样酸痛，喉咙像吞了刀片。",
      textKey: "gameplay.dialogues.office_03.opening.1"
    },
    {
      type: "narrator",
      text: "理智告诉你，现在的状态根本无法工作，必须去医院或卧床休息。但当你拿起手机准备请假时，手指却悬停在屏幕上方。",
      textKey: "gameplay.dialogues.office_03.opening.2"
    },
    {
      type: "inner_monologue",
      text: "（心中的焦虑）“今天还有项目例会……如果我不在，大家会很忙乱吧？老板会不会觉得我娇气？这才刚忙完一个大项目就请假，会不会被误会是偷懒？”",
      textKey: "gameplay.dialogues.office_03.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "硬撑上班（不敢开口）",
        labelKey: "gameplay.options.office_03.invisible",
        archetype: "隐形人",
        visualEffect: "dark",
        followUp: [
          {
            type: "narrator",
            text: "羞耻感告诉你：“你的需求不重要，给别人添麻烦是可耻的。”于是你吞了两片退烧药，拖着沉重的身体去了公司。",
            textKey: "gameplay.dialogues.office_03.survival.invisible.1"
          },
          {
            type: "action",
            text: "你在工位上昏昏沉沉，盯着屏幕半小时也没写出一行字。哪怕想咳嗽，都拼命忍住，生怕引起注意。",
            textKey: "gameplay.dialogues.office_03.survival.invisible.2"
          },
          {
            type: "failure",
            text: "结果是灾难性的。你因为精神恍惚发错了一个重要数据，而且你的病毒成功传染了坐在对面的同事。下班时你彻底虚脱，不仅没效率，还成了团队的“健康隐患”。",
            textKey: "gameplay.dialogues.office_03.survival.invisible.3"
          }
        ]
      },
      {
        id: "sinner_choice",
        label: "卑微请假（充满罪恶感）",
        labelKey: "gameplay.options.office_03.sinner",
        archetype: "罪人",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你最终还是发了请假信息，但内疚感像一块巨石压在胸口。你觉得自己像个逃兵，犯下了不可饶恕的罪行。",
            textKey: "gameplay.dialogues.office_03.survival.sinner.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（在群里发消息）真的非常非常对不起大家！在这个节骨眼上掉链子，全是我的错。任何急事随时打我电话，我24小时在线……",
            textKey: "gameplay.dialogues.office_03.survival.sinner.2"
          },
          {
            type: "failure",
            text: "虽然老板批了假，但你躺在床上每隔五分钟就看一次钉钉，稍微有点风吹草动就立刻跳起来回复。你的身体在休息，但你的精神在服苦役。这一天假，比上班还累。",
            textKey: "gameplay.dialogues.office_03.survival.sinner.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：你不是工作的机器，你是被爱的生命",
      titleKey: "gameplay.directorNote.office_03.title",
      contentKey: "gameplay.directorNote.office_03.content",
      content: `亲爱的导演，这一幕戏虽然只有短短的几分钟，却深刻地揭示了我们与自己身体的关系。

为什么生病这件如此自然的生理现象，会让你感到如此巨大的心理负担？

看看那个不想让你请假的**“隐形人”（Energy 20: Shame）**。
他的核心信念是“我不重要”。他认为自己的价值完全取决于“功能性”。如果我不工作，我就没有价值，我就是累赘。为了维持这种虚幻的“有用感”，他不惜透支甚至摧毁自己的身体。这是一种对自己生命的深度暴力。

再看看那个即便请了假也无法安宁的**“罪人”（Energy 30: Guilt）**。
在罪人的剧本里，“休息”等同于“偷懒”，而“受苦”才是“赎罪”。他潜意识里觉得，只有通过不断地道歉和带病工作这种“自我惩罚”，才能平息因为“照顾自己”而产生的罪恶感。他把职场变成了一个修道院，而自己是一个永远在赎罪的苦行僧。

但这真的是真相吗？
公司会因为你休息一天就倒闭吗？团队会因为你一次生病就崩溃吗？
当然不会。

现在，请按下【暂停的锚点】。
把手放在你滚烫的额头上，感受那份真实的温度。那是你的身体在向你求救，它在说：“我累了，请爱我。”
深呼吸，感受那份灼烧感。不要抗拒它，也不要因为它的存在而责怪自己。

请邀请**“疗愈者”（Energy 500: Love）**登场。
疗愈者知道一个最简单的真理：**爱自己，是高效工作的前提，而不是对立面。**
你不是一台冷冰冰的机器，你是一个有血有肉的生命。机器坏了可以换零件，你的身体垮了，谁来替你活？

真正的敬业，不是带病硬撑（那是不负责任的低效），而是管理好自己的能量，确保持续、健康地输出。
疗愈者会告诉你：
1. **你的需求是正当的**：生病休息是基本人权，不需要歉意。
2. **信任团队**：相信你的同事有能力在你缺席时处理好工作，就像你也会支持他们一样。地球离了谁都照样转。
3. **慈悲的允许**：允许自己脆弱，允许自己停机。只有当你对自己温柔时，世界才会对你温柔。

试着放下手机，闭上眼睛，对自己说：“我允许自己彻底休息。我值得被照顾。” 看看会发生什么。`
    },
    creativeOption: {
      id: "healer_choice",
      label: "温和请假（慈悲自爱）",
      labelKey: "gameplay.options.office_03.healer",
      archetype: "疗愈者",
      visualEffect: "indigo",
      followUp: [
        {
          type: "narrator",
          text: "你闭上眼睛，做了一次充满慈悲的深呼吸。你看见了那个因为发烧而瑟瑟发抖的内在小孩，你没有像严厉的监工一样驱赶他，而是温柔地抱住了他。",
          textKey: "gameplay.dialogues.office_03.creative.1"
        },
        {
          type: "inner_monologue",
          text: "（对自己说）“亲爱的身体，辛苦了。谢谢你一直以来的支持，今天我会好好照顾你。”",
          textKey: "gameplay.dialogues.office_03.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（拿起手机，语气平和而坚定地发语音）老板，我突发高烧，状态无法支持工作。今天需要请假去医院并休息。手头的急事我已经转交给小王暂代，文档都在共享盘。我会关闭通知安心休养，争取尽快满血回归。",
          textKey: "gameplay.dialogues.office_03.creative.3"
        },
        {
          type: "narrator",
          text: "发完消息，你果断关掉了工作软件的通知。你没有道歉，因为生病不是错误。你感受到一种深深的、对自己生命的尊重。",
          textKey: "gameplay.dialogues.office_03.creative.4"
        },
        {
          type: "success",
          text: "老板只回了一个字：“好，保重。” 你安心地睡了一整天。因为你放下了焦虑，身体的自愈力被充分激活。第二天醒来时，烧退了，你感到久违的清爽和能量满满。你用爱（Love）赢得了真正的效率。",
          textKey: "gameplay.dialogues.office_03.creative.5"
        }
      ]
    }
  }
};

// 4. 同事抢功劳 (Office 04)
export const officeCreditScript: ScenarioScript = {
  id: "office_04",
  title: "同事抢功劳",
  titleKey: "gameplay.sceneTitles.office_04",
  sceneImage: "/scenarios/office_04.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "季度项目复盘会上，PPT 翻到了核心创意那一页。这个创意是你熬了三个通宵才打磨出来的，但在你开口汇报之前，坐在对面的同事老刘抢先开了口。",
      textKey: "gameplay.dialogues.office_04.opening.1"
    },
    {
      type: "npc",
      speaker: "老刘",
      speakerKey: "gameplay.characters.laoliu",
      text: "（一脸自豪）老板，关于这个‘用户情绪共振’的点子，是我那天洗澡时突然来的灵感。我觉得它完美解决了咱们一直以来的痛点……",
      textKey: "gameplay.dialogues.office_04.opening.2"
    },
    {
      type: "npc",
      speaker: "老板",
      speakerKey: "gameplay.characters.boss",
      text: "（眼前一亮，打断了老刘）哎，这个切入点非常棒！老刘，你最近确实动脑子了，值得表扬！大家都要像老刘这样多思考。",
      textKey: "gameplay.dialogues.office_04.opening.3"
    },
    {
      type: "narrator",
      text: "你坐在旁边，看着平时总是摸鱼的老刘此时正享受着本该属于你的掌声。你的血液开始倒流，手指紧紧扣住了桌角。",
      textKey: "gameplay.dialogues.office_04.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "victim_choice",
        label: "委屈隐忍（背后抱怨）",
        labelKey: "gameplay.options.office_04.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "巨大的委屈感让你瞬间红了眼眶。你不敢当众反驳，怕被说斤斤计较，只能死死咬住嘴唇，强忍着泪水。",
            textKey: "gameplay.dialogues.office_04.survival.victim.1"
          },
          {
            type: "action",
            text: "散会后，你躲进洗手间偷偷抹泪。回到工位后，你拉着隔壁同事祥林嫂般地倾诉：“明明是我想出来的，他怎么能这样……”",
            textKey: "gameplay.dialogues.office_04.survival.victim.2"
          },
          {
            type: "failure",
            text: "同事们表面安慰你，心里却觉得你是个充满了负能量的“怨妇”。老刘依然享受着光环，而你除了一肚子的苦水和被削弱的职场形象，什么也没得到。",
            textKey: "gameplay.dialogues.office_04.survival.victim.3"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "当场拆穿（冷嘲热讽）",
        labelKey: "gameplay.options.office_04.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "“凭什么？！”怒火让你瞬间失去了理智。你冷笑一声，打断了老刘的表演。",
            textKey: "gameplay.dialogues.office_04.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（阴阳怪气地）哟，老刘，这时候成你的灵感了？上周我跟你讲这个idea的时候，你不是还说‘太虚了没法落地’吗？平时干活不见人，抢功劳倒是第一名啊。",
            textKey: "gameplay.dialogues.office_04.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "会议室瞬间死寂。老板的脸色沉了下来，老刘一脸尴尬却故作无辜。虽然你揭穿了他，但这种攻击性的姿态让老板觉得你“格局太小，不懂得团队团结”。你赢了道理，输了人心。",
            textKey: "gameplay.dialogues.office_04.survival.tyrant.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：专业细节是光，它能照穿一切黑暗",
      titleKey: "gameplay.directorNote.office_04.title",
      contentKey: "gameplay.directorNote.office_04.content",
      content: `亲爱的导演，这一幕名为“掠夺”，是职场中最考验心性的试炼场之一。

当属于你的果实被别人摘走时，你的内在剧组会瞬间炸锅。
看看那个躲在洗手间哭泣的**“受害者”（Energy 75: Grief）**。他把希望寄托在“包青天”身上，期待老板能拥有读心术，主动为你主持公道。这是一种极其幼稚的等待。在受害者的剧本里，世界是不公的，而你是无力的浮萍。

再看看那个拍案而起的**“暴君”（Energy 150: Anger）**。他像一只被侵犯领地的狮子，只想撕碎入侵者。但请注意，在职场这个特定的舞台上，情绪化的攻击往往会被解读为“不专业”和“破坏团结”。当你试图用愤怒去攻击黑暗时，你自己也变成了黑暗的一部分。

但是，真的只能在“忍气吞声”和“两败俱伤”中二选一吗？
当然不是。

现在，请按下【暂停的锚点】。
深呼吸。把目光从那个洋洋得意的老刘身上移开，收回到你自己身上。
试着去理解发生了什么：老刘为什么要抢功？因为他内在匮乏（Lack）。他没有创意，但他渴望光环（Pride/Desire）。他在“偷吃”，这说明他饿。

当你能看穿这一点，你就不会被激怒，而是会生出一种高维的**“智者”（Energy 350/400: Reason）**的视角。
智者知道：**小偷能偷走金子，但偷不走点金术；能偷走概念，但偷不走细节。**
创意的核心壁垒，永远在于执行的颗粒度。那是只有原创者才拥有的“源代码”。

你不需要去攻击他，你只需要“照亮”他。
不用争辩“这是谁的”，而是直接展示“这是怎么做的”。
当你以极高的专业度，展开这个创意的实施细节、数据测算、风险预案时，谁是真正的“父亲”，谁是“抱养者”，在老板眼里一目了然。

光不需要攻击黑暗，光只需要出现，黑暗自然无处遁形。
请邀请你的“智者”登场，用细节的颗粒度，优雅地拿回你的主场。`
    },
    creativeOption: {
      id: "sage_choice",
      label: "补充细节（降维打击）",
      labelKey: "gameplay.options.office_04.sage",
      archetype: "智者",
      visualEffect: "blue",
      followUp: [
        {
          type: "narrator",
          text: "你做了一次深呼吸，没有愤怒，只有一种洞若观火的冷静。你看着老刘，就像看着一个为了讨糖吃而撒谎的孩子。你没有打断他，而是等他说完。",
          textKey: "gameplay.dialogues.office_04.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（微笑着点头，语气专业且从容）正如老刘刚才提到的这个‘情绪共振’概念，这确实是我们这次方案的核心。为了让老板您更清楚这个概念如何落地，我补充几个关键的执行细节。",
          textKey: "gameplay.dialogues.office_04.creative.2"
        },
        {
          type: "action",
          text: "你打开了早已准备好的数据附录，从容不迫地展示。",
          textKey: "gameplay.dialogues.office_04.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "在这个创意的具体执行上，我们在A/B测试中发现，针对25-30岁女性用户，文案的情绪颗粒度需要精确到‘怀旧’维度才能将转化率提升15%。另外，为了配合这个概念，我这边已经预先沟通了三家符合调性的KOL……",
          textKey: "gameplay.dialogues.office_04.creative.4"
        },
        {
          type: "narrator",
          text: "你如数家珍地抛出了大量老刘根本不知道的细节、数据和执行路径。你的每一句话，都在无声地宣告：只有创造它的人，才懂它。",
          textKey: "gameplay.dialogues.office_04.creative.5"
        },
        {
          type: "npc",
          speaker: "老板",
          speakerKey: "gameplay.characters.boss",
          text: "（眼神从老刘身上移回你身上，频频点头）嗯……原来想得这么细了。这些数据很关键。看来这个案子还是你吃得最透。",
          textKey: "gameplay.dialogues.office_04.creative.6"
        },
        {
          type: "success",
          text: "老刘在一旁插不上话，只能尴尬地赔笑。你没有发火，也没有告状，只是用无法辩驳的专业细节，自然地拿回了属于你的荣耀。这就是“智者”的力量：不争之争，天下莫能与之争。",
          textKey: "gameplay.dialogues.office_04.creative.7"
        }
      ]
    }
  }
};

// 5. 拒绝加班 (Office 05)
export const officeOvertimeScript: ScenarioScript = {
  id: "office_05",
  title: "拒绝加班",
  titleKey: "gameplay.sceneTitles.office_05",
  sceneImage: "/scenarios/office_05.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "周五下午5点55分。你的电脑已经关机，包也收拾好了。今晚是你期待已久的朋友聚餐，那个很难约的餐厅位置你提前两周才订到。",
      textKey: "gameplay.dialogues.office_05.opening.1"
    },
    {
      type: "narrator",
      text: "就在你起身准备离开的一刹那，老板匆匆从办公室走出来，手里拿着几页文件，径直走向你。",
      textKey: "gameplay.dialogues.office_05.opening.2"
    },
    {
      type: "npc",
      speaker: "老板",
      speakerKey: "gameplay.characters.boss",
      text: "哎，小李，正好你还没走。这有个关于Q4预算的调整，客户刚发过来的，挺急的。你顺手改一下再走吧，应该很快，也就两三个小时。",
      textKey: "gameplay.dialogues.office_05.opening.3"
    },
    {
      type: "narrator",
      text: "“顺手”？“也就两三个小时”？你的脑子轰的一声。如果接下这个活，晚上的聚餐就彻底泡汤了。朋友们还在群里发着已经出发的消息。",
      textKey: "gameplay.dialogues.office_05.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "忍气吞声（习惯性讨好）",
        labelKey: "gameplay.options.office_05.invisible",
        archetype: "隐形人",
        visualEffect: "dark",
        followUp: [
          {
            type: "narrator",
            text: "一种熟悉的、令人窒息的服从感接管了你的身体。你甚至还没来得及思考，嘴巴就已经自动给出了“标准答案”。",
            textKey: "gameplay.dialogues.office_05.survival.invisible.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（脸上挂着僵硬的假笑）好的老板，没问题……那我做完再走。",
            textKey: "gameplay.dialogues.office_05.survival.invisible.2"
          },
          {
            type: "action",
            text: "老板满意地走了。你重新坐下，打开电脑，在朋友群里发这句：“对不起大家，又加班，你们先吃吧。”",
            textKey: "gameplay.dialogues.office_05.survival.invisible.3"
          },
          {
            type: "failure",
            text: "你一边做表一边在心里咒骂老板、咒骂这份工作，甚至咒骂软弱的自己。你完成了工作，但内心充满了怨毒和委屈。你再次为了别人的方便，牺牲了自己的生活。",
            textKey: "gameplay.dialogues.office_05.survival.invisible.4"
          }
        ]
      },
      {
        id: "coward_choice",
        label: "撒谎逃避（编造理由）",
        labelKey: "gameplay.options.office_05.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "恐惧让你心跳加速。你不敢直接拒绝，怕被老板认为“不敬业”、“没有奉献精神”，于是你的大脑飞速运转，寻找一个无法被反驳的借口。",
            textKey: "gameplay.dialogues.office_05.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（眼神闪躲，神色慌张）哎呀老板，真不巧……家里刚打电话说水管爆了，发大水了，我得赶紧回去救火……真的不行，太急了！",
            textKey: "gameplay.dialogues.office_05.survival.coward.2"
          },
          {
            type: "failure",
            text: "老板愣了一下，只好说：“哦……那你先走吧。”你抓起包逃出了公司，但一路上都提心吊胆，生怕穿帮。吃晚饭时也不敢发朋友圈，整晚都在焦虑中度过。",
            textKey: "gameplay.dialogues.office_05.survival.coward.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：边界不是为了拒绝别人，而是为了尊重自己",
      titleKey: "gameplay.directorNote.office_05.title",
      contentKey: "gameplay.directorNote.office_05.content",
      content: `亲爱的导演，这一幕名为“周五的试炼”，是职场中最经典的边界测试。

面对老板临下班前的“突袭”，为什么说一个简单的“不”字，会如此艰难？

看看那个第一时间滑跪的**“隐形人”（Energy 20: Shame）**。
在隐形人的潜意识里，有一条深刻的等式：**我的需求 < 别人的需求**。他不仅害怕冲突，更深层的是害怕如果不顺从，自己就会被定义为“坏员工”、“不合群”甚至“自私”。这种讨好型人格（People Pleaser）的本质是极度的自我价值匮乏。你以为你在通过牺牲换取认可，实际上你只是在告诉老板：“我的时间不值钱，你可以随时践踏我的边界。”

再看看那个慌不择路的**“懦夫”（Energy 100: Fear）**。
他把“拒绝工作”灾难化成了“职业生涯的终结”。为了逃避这个想象中的灾难，他不得不编造谎言。谎言虽然暂时帮他逃脱了任务，但却让他背负了沉重的心理包袱，并让他失去了建立真实、坦诚职场关系的机会。

但是，真正的专业是什么？是随叫随到的奴仆吗？
不。真正的专业是**预期管理**和**结果交付**。

现在，请按下【暂停的锚点】。
深呼吸。看着老板手里的文件，那不是圣旨，那只是一项工作任务。
问自己：“这项任务真的需要在今晚完成吗？如果我今晚不做，公司会倒闭吗？”（通常答案是否定的）。
再问自己：“我有权利拥有自己的生活吗？”（答案是绝对的肯定）。

请邀请**“探险家”（Energy 200: Courage）**登场。
探险家知道，设立边界（Boundaries）需要勇气，但这恰恰是赢得尊重的开始。
每一次你不敢说“不”，都是在向“隐形人”低头。而每一次你温和而坚定地守住底线，你都在教会别人如何尊重你。

你可以诚实。你可以坚定。
你不需要撒谎，也不需要道歉。你只需要陈述事实，并提供替代方案。
这种“不卑不亢”的能量，比唯唯诺诺的顺从，更让人感到可靠。`
    },
    creativeOption: {
      id: "explorer_choice",
      label: "坦诚边界（管理预期）",
      labelKey: "gameplay.options.office_05.explorer",
      archetype: "探险家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你停顿了一秒，做了一个深呼吸。你没有因为要拒绝而感到抱歉，也没有因为被打扰而感到愤怒。你只是平静地接纳了当下的事实：你有重要的安排。",
          textKey: "gameplay.dialogues.office_05.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（直视老板，语气诚恳但坚定）老板，我看了一下，这个调整虽然不算大，但要保证准确率至少需要3个小时。今晚我有非常重要的私人安排，朋友们已经在等我了，所以我现在必须得走了。",
          textKey: "gameplay.dialogues.office_05.creative.2"
        },
        {
          type: "narrator",
          text: "老板显得有点意外，正准备说什么，你紧接着给出了解决方案。",
          textKey: "gameplay.dialogues.office_05.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "不过您放心，这个任务我会作为最高优先级。周一早上我早到一小时，保证在上午10点前把改好的版本发到您邮箱，绝不耽误您后续发给客户。您看这样可以吗？",
          textKey: "gameplay.dialogues.office_05.creative.4"
        },
        {
          type: "npc",
          speaker: "老板",
          speakerKey: "gameplay.characters.boss",
          text: "（犹豫了一下，看了看表，随后点了点头）……嗯，行吧。既然你有事就先去忙。但周一早上一定要给到我，客户那边不能拖。",
          textKey: "gameplay.dialogues.office_05.creative.5"
        },
        {
          type: "success",
          text: "你背上包走出公司，脚步轻快。你没有牺牲晚餐，也没有得罪老板，更没有撒谎。你用勇气划出了一条清晰的线：工作是工作，生活是生活。你赢得了朋友的欢聚，也赢得了自尊。",
          textKey: "gameplay.dialogues.office_05.creative.6"
        }
      ]
    }
  }
};

// 6. 重大失误 (Office 06)
export const officeMistakeScript: ScenarioScript = {
  id: "office_06",
  title: "重大失误",
  titleKey: "gameplay.sceneTitles.office_06",
  sceneImage: "/scenarios/office_06.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "下午三点，当你习惯性地检查刚发出的邮件时，血液瞬间凝固了。那封发给重要客户的报价单邮件里，附件竟然是公司内部的底价成本表。",
      textKey: "gameplay.dialogues.office_06.opening.1"
    },
    {
      type: "narrator",
      text: "你的大脑一片空白，手脚冰凉。撤回已经来不及了，对方可能已经看到了。这是一个足以导致谈判崩盘、甚至让公司蒙受巨大损失的致命失误。",
      textKey: "gameplay.dialogues.office_06.opening.2"
    },
    {
      type: "inner_monologue",
      text: "（心中的恐慌）“完了，全完了。这种低级错误怎么会发生在我身上？老板会杀了我，我会为此丢了工作，甚至在这个行业混不下去……”",
      textKey: "gameplay.dialogues.office_06.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "sinner_choice",
        label: "自我审判（陷入崩溃）",
        labelKey: "gameplay.options.office_06.sinner",
        archetype: "罪人",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "巨大的内疚感像海啸一样将你吞没。你瘫坐在椅子上，双手抱头，陷入了无休止的自我攻击。",
            textKey: "gameplay.dialogues.office_06.survival.sinner.1"
          },
          {
            type: "inner_monologue",
            text: "“我真是个废物！我怎么这么蠢！我不配坐在这个位置上。我是公司的罪人，我毁了一切。我不如果不辞职谢罪，都不足以弥补我的过错。”",
            textKey: "gameplay.dialogues.office_06.survival.sinner.2"
          },
          {
            type: "failure",
            text: "你沉浸在情绪的泥潭里完全无法行动，直到一小时后老板接到客户愤怒的电话冲出办公室，看到还在发呆流泪的你。你不仅犯了错，更表现得像个无法承担责任的懦夫，彻底失去了信任。",
            textKey: "gameplay.dialogues.office_06.survival.sinner.3"
          }
        ]
      },
      {
        id: "invisible_choice",
        label: "掩盖隐瞒（鸵鸟心态）",
        labelKey: "gameplay.options.office_06.invisible",
        archetype: "隐形人",
        visualEffect: "dark",
        followUp: [
          {
            type: "narrator",
            text: "羞耻感让你本能地想要躲藏。你想：“也许客户还没看？也许他们没注意？”",
            textKey: "gameplay.dialogues.office_06.survival.invisible.1"
          },
          {
            type: "inner_monologue",
            text: "“只要我不说，老板就不知道。只要我假装没事发生，这事也许就混过去了。求求老天保佑，千万别被发现……”",
            textKey: "gameplay.dialogues.office_06.survival.invisible.2"
          },
          {
            type: "failure",
            text: "你像把头埋进沙子的鸵鸟，错过了最佳的补救窗口。第二天，客户拿着那份底价表直接向老板压价。被动得知真相的老板暴跳如雷，你的隐瞒性质比错误本身更恶劣，你被当场开除。",
            textKey: "gameplay.dialogues.office_06.survival.invisible.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：错误是成长的肥料，不是审判的刑具",
      titleKey: "gameplay.directorNote.office_06.title",
      contentKey: "gameplay.directorNote.office_06.content",
      content: `亲爱的导演，这是极其艰难的一幕。当现实的打击（错误造成的结果）真实发生时，我们最容易迷失。

面对无可挽回的失误，你的内在剧组会陷入极度的混乱。
看看那个瘫痪在椅子上的**“罪人”（Energy 30: Guilt）**。
他沉迷于一种名为“内疚”的毒药。他以为痛骂自己、折磨自己是在“负责”，其实这是一种极其自私的自我沉溺。当你把所有精力都用来攻击自己是“废物”时，你就没有一丝精力去解决现实的问题了。内疚不仅于事无补，反而会让事情变得更糟，因为它让你从一个“犯错的员工”变成了一个“无用的员工”。

再看看那个试图掩耳盗铃的**“隐形人”（Energy 20: Shame）**。
羞耻感让他觉得“我这个人坏掉了”，为了保护自我形象，他选择牺牲诚实。这种鸵鸟心态是职场的大忌。错误本身可能是能力问题或疏忽，但掩盖错误就是品格问题。

现在，请按下【暂停的锚点】。
深呼吸。是的，心还在狂跳，手还在发抖。允许这种生理反应存在。
看着那个发出去的邮件，承认这个事实：“是的，我发错了。这是事实。”
不要给这个事实贴上“我是废物”的标签。事实只是事实。

请邀请**“实干家”（Energy 250/310: Neutrality & Willingness）**登场。
在实干家眼里，错误已经发生，它就变成了“过去式”。
对于过去，我们无法改变；但对于未来（哪怕是下一秒），我们拥有绝对的掌控权。
现在的重点不再是“为什么会发生”，而是“现在怎么止损”。

你需要做一个快速的手术：将**“我”**和**“我的行为”**剥离。
行为错了，不代表“我”是个坏人。只有当你原谅了那个犯错的自己，你才有力量站起来去修正错误。

实干家的行动公式是：**接纳事实 -> 评估后果 -> 制定方案 -> 坦诚汇报**。
带着方案去见老板，而不是带着眼泪。告诉他发生了什么，后果可能是什么，以及你准备怎么做。
哪怕结果依然糟糕，至少你展现了一个成熟职场人应有的担当。这就是把“事故”转化为“故事”的能力。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "即刻止损（带着方案汇报）",
      labelKey: "gameplay.options.office_06.doer",
      archetype: "实干家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你猛地吸了一口冷气，强行切断了大脑中自我攻击的回路。你告诉自己：“哭没用，骂也没用。现在唯一能做的就是止损。”",
          textKey: "gameplay.dialogues.office_06.creative.1"
        },
        {
          type: "action",
          text: "你用极快的速度评估了局势：客户看到底价是大概率事件。现在的关键是解释口径和备选方案。",
          textKey: "gameplay.dialogues.office_06.creative.2"
        },
        {
          type: "narrator",
          text: "你花了三分钟，草拟了两套应对方案，然后拿起笔记本，没有一丝犹豫，径直走进了老板办公室。你的脸色苍白，但眼神坚定。",
          textKey: "gameplay.dialogues.office_06.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（开门见山）老板，我有重要急事汇报。刚才我不慎将内部成本表发给了客户。这是严重的失误，我负全责。但在来之前，我整理了两个补救方案。",
          textKey: "gameplay.dialogues.office_06.creative.4"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "第一，我已经联系了法务准备撤回声明，虽然技术上很难，但态度要做到位；第二，我们可以立刻致电客户，解释那份表格是“模拟的最坏情况成本推演”，而非实际执行成本，借此重新开启价格谈判。我现在就在您面前给客户打电话，您看可以吗？",
          textKey: "gameplay.dialogues.office_06.creative.5"
        },
        {
          type: "narrator",
          text: "老板听完，震惊之余，眼中的怒火被你的冷静和方案压了下去。他没时间骂你，因为被你的行动节奏带着进入了解决问题的模式。",
          textKey: "gameplay.dialogues.office_06.creative.6"
        },
        {
          type: "success",
          text: "危机并没有完全解除，但你避免了最坏的结果（失去信任）。你用行动证明了：即使在犯错的时候，你依然是一个靠谱的战友。老板事后虽然扣了你的奖金，但也记住了你临危不乱的担当。你从这次跌倒中，学会了真正的坚韧。",
          textKey: "gameplay.dialogues.office_06.creative.7"
        }
      ]
    }
  }
};

// 7. 被排挤/八卦 (Office 07)
export const officeGossipScript: ScenarioScript = {
  id: "office_07",
  title: "被排挤/八卦",
  titleKey: "gameplay.sceneTitles.office_07",
  sceneImage: "/scenarios/office_07.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "午休时间，你拿着水杯走向茶水间，想去倒杯咖啡。隔着虚掩的门，你听到里面传来了几位同事压低的笑声和议论声。",
      textKey: "gameplay.dialogues.office_07.opening.1"
    },
    {
      type: "npc",
      speaker: "同事A",
      speakerKey: "gameplay.characters.colleague_a",
      text: "……就是啊，你看他那天穿的那件衣服，土得掉渣。而且听说他上次那个项目也是抱大腿才过的……",
      textKey: "gameplay.dialogues.office_07.opening.2"
    },
    {
      type: "narrator",
      text: "你的手僵在了门把手上。他们在议论你。当你推开门的一瞬间，空气突然凝固了。三双眼睛尴尬地看向别处，茶水间里死一般的寂静。",
      textKey: "gameplay.dialogues.office_07.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "羞耻躲避（自我攻击）",
        labelKey: "gameplay.options.office_07.invisible",
        archetype: "隐形人",
        visualEffect: "dark",
        followUp: [
          {
            type: "narrator",
            text: "那一刻，你恨不得自己能当场蒸发。巨大的羞耻感让你觉得他们说得对——你就是那个糟糕、不合群、令人讨厌的人。",
            textKey: "gameplay.dialogues.office_07.survival.invisible.1"
          },
          {
            type: "action",
            text: "你低着头，假装没听见，匆匆倒了点冷水就逃回了工位。你的脸烫得吓人，心里想：“只要我不说话，只要我躲着他们走，就不会再被伤害了。”",
            textKey: "gameplay.dialogues.office_07.survival.invisible.2"
          },
          {
            type: "failure",
            text: "从此以后，你变得更加社恐，走路贴着墙根，甚至不敢去公共区域。你把自己变成了一个真正的“隐形人”，而这种畏缩的气场，反而招致了更多的轻视。",
            textKey: "gameplay.dialogues.office_07.survival.invisible.3"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "愤怒反击（制造对立）",
        labelKey: "gameplay.options.office_07.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "被羞辱的痛苦瞬间转化为了攻击的怒火。你猛地把门推到底，杯子重重地磕在桌面上。",
            textKey: "gameplay.dialogues.office_07.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（怒目圆睁）刚才谁在说话？有本事当着我面说啊！整天在背后嚼舌根，你们也不看看自己那点业绩！",
            textKey: "gameplay.dialogues.office_07.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "同事们面面相觑，然后作鸟兽散。虽然你发泄了怒火，但你很快发现自己被彻底孤立了。他们在背后把你描绘成一个“开不起玩笑”、“情绪失控”的疯子。你在办公室里树立了无数敌人。",
            textKey: "gameplay.dialogues.office_07.survival.tyrant.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：他人的评价是镜子，映照的是他们自己",
      titleKey: "gameplay.directorNote.office_07.title",
      contentKey: "gameplay.directorNote.office_07.content",
      content: `亲爱的导演，这一幕名为“审判”，但其实是一场关于“投射”的心理剧。

当我们听到别人的负面评价时，为什么会那么痛？
因为**“隐形人”（Energy 20: Shame）**相信那是真的。他觉得：“如果他们这么说，那一定是因为我不够好。”隐形人认同了外界的审判，并把它变成了自我攻击的利刃。
而**“暴君”（Energy 150: Anger）**则试图打碎镜子。他认为：“只要我让你们闭嘴，我就安全了。”但他不知道，攻击只会制造更多的反作用力。

但真相是什么？
心理学有一个著名的投射法则：**一个人对他人的评价，往往是他内心世界的投射。**
他们嘲笑你的穿着，是因为他们自己对形象充满焦虑；他们贬低你的能力，是因为他们嫉妒你的机会。他们的议论，其实与真实的“你”毫无关系，那是他们为了缓解自己内在焦虑而演的一出戏。

现在，请按下【暂停的锚点】。
深呼吸。看着那几个尴尬的同事。
不要认同他们的话（那是他们的剧本），也不要攻击他们（那会让你入戏）。
试着向上切换频道，邀请**“和平的观察者”（Energy 600: Peace）**登场。

在观察者眼里，这一切就像一群孩子在玩过家家。
你不需要证明自己，因为天空不需要向云证明它的广阔。
当你内心“如如不动”时，他们的言语就像射向虚空的箭，根本无法触碰到你。

你可以选择微笑。
那个微笑不是为了讨好，而是源于一种深层的悲悯和超脱——“我看见了你们的恐惧，但我选择不参与。”
当你安住在和平之中，任何言语的箭都无法穿透你。`
    },
    creativeOption: {
      id: "observer_choice",
      label: "如如不动（微笑破局）",
      labelKey: "gameplay.options.office_07.observer",
      archetype: "和平的观察者",
      visualEffect: "violet",
      followUp: [
        {
          type: "narrator",
          text: "你停顿了一秒，做了一个深长的呼吸。你感觉那股刺耳的议论声穿过了你的身体，却没有留下任何伤痕。你看着他们，就像看着一场与你无关的默片。",
          textKey: "gameplay.dialogues.office_07.creative.1"
        },
        {
          type: "inner_monologue",
          text: "（内心平静如水）“这是他们内心的投射，不是我的真相。我可以选择不接受这份‘礼物’。”",
          textKey: "gameplay.dialogues.office_07.creative.2"
        },
        {
          type: "action",
          text: "你走进茶水间，神色自若，甚至带着一丝淡淡的微笑。空气虽然尴尬，但你没有被那份尴尬所裹挟。",
          textKey: "gameplay.dialogues.office_07.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（一边接水一边自然地打招呼）嗨，都在啊。今天中午的外卖好像来得挺快。",
          textKey: "gameplay.dialogues.office_07.creative.4"
        },
        {
          type: "narrator",
          text: "你的平静彻底击碎了他们的防御。同事A尴尬地回应：“啊……是啊。”你接完水，点点头，转身离开，步伐轻盈。",
          textKey: "gameplay.dialogues.office_07.creative.5"
        },
        {
          type: "success",
          text: "当你走出那扇门时，你感到一种前所未有的自由。你没有为了合群而讨好，也没有为了自尊而战斗。你只是做你自己。你发现，当你不在意时，那些声音就失去了所有的力量。你成为了自己世界里，那片宁静的天空。",
          textKey: "gameplay.dialogues.office_07.creative.6"
        }
      ]
    }
  }
};

// 8. 当众演讲恐惧 (Office 08)
export const officePublicSpeakingScript: ScenarioScript = {
  id: "office_08",
  title: "当众演讲恐惧",
  titleKey: "gameplay.sceneTitles.office_08",
  sceneImage: "/scenarios/office_08.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "年度汇报的聚光灯打在舞台中央，台下是公司几百双眼睛，甚至还有总部的VP。再过一分钟，就轮到你上台了。",
      textKey: "gameplay.dialogues.office_08.opening.1"
    },
    {
      type: "narrator",
      text: "你的胃部开始痉挛，手心全是冷汗。刚才背得滚瓜烂熟的开场白，此刻像被橡皮擦擦掉了一样，大脑一片空白。你能清晰地听到自己如雷的心跳声。",
      textKey: "gameplay.dialogues.office_08.opening.2"
    },
    {
      type: "inner_monologue",
      text: "（心中的恐慌）“完了，我要忘词了。这么多人看着，如果卡壳了，我这辈子就毁了。他们肯定在等着看我笑话……”",
      textKey: "gameplay.dialogues.office_08.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "coward_choice",
        label: "极度恐慌（照本宣科）",
        labelKey: "gameplay.options.office_08.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "恐惧彻底击穿了你的心理防线。你甚至产生了一种想要当场晕倒来逃避上台的冲动。走上台时，你的腿像灌了铅一样沉重。",
            textKey: "gameplay.dialogues.office_08.survival.coward.1"
          },
          {
            type: "action",
            text: "你全程低头不敢看观众，双手死死抓住讲台边缘，声音颤抖地、机械地念着PPT上的每一个字，甚至连标点符号都念了出来。",
            textKey: "gameplay.dialogues.office_08.survival.coward.2"
          },
          {
            type: "failure",
            text: "台下的观众开始玩手机、打哈欠。你终于熬过了这漫长的15分钟，虽然没有出大错，但你的汇报像白开水一样乏味，完全被遗忘。你觉得自己像个透明的失败者。",
            textKey: "gameplay.dialogues.office_08.survival.coward.3"
          }
        ]
      },
      {
        id: "performer_choice",
        label: "故作高深（僵硬表演）",
        labelKey: "gameplay.options.office_08.performer",
        archetype: "演员",
        visualEffect: "yellow",
        followUp: [
          {
            type: "narrator",
            text: "骄傲的自尊心让你绝不允许自己露怯。你戴上了一副“我很专业”的假面具，试图用演技来掩盖内心的慌张。",
            textKey: "gameplay.dialogues.office_08.survival.performer.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（声音僵硬，堆砌辞藻）基于底层逻辑的赋能，我们要打通闭环，形成抓手……",
            textKey: "gameplay.dialogues.office_08.survival.performer.2"
          },
          {
            type: "failure",
            text: "你用力过猛，肢体语言像机器人一样不自然。虽然你表现得很“完美”，但观众感受到了你的紧绷和傲慢，产生了一种疏离感。你赢得了掌声，却没赢得人心。下台后，你感到一种深深的空虚和疲惫。",
            textKey: "gameplay.dialogues.office_08.survival.performer.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：这不是审判，这是一次礼物的分享",
      titleKey: "gameplay.directorNote.office_08.title",
      contentKey: "gameplay.directorNote.office_08.content",
      content: `亲爱的导演，这一幕名为“聚光灯下的恐惧”。

为什么你会如此害怕？
科学告诉我们，当众演讲是仅次于死亡的人类第二大恐惧。
看看那个想逃跑的**“懦夫”（Energy 100: Fear）**。在他的原始大脑里，几百双眼睛盯着你看，意味着“被捕食者锁定了”。如果表现不好，就会被部落驱逐，这在远古时代等同于死亡。懦夫把观众当成了审判官，把演讲当成了刑场。

再看看那个极度紧绷的**“演员”（Energy 175: Pride）**。
他渴望掌声，更恐惧嘘声。他的核心关注点依然是“我”——“我看起来专业吗？”“我表现完美吗？”当一个人的注意力全部在自己身上时，他的能量是内缩的，自然会感到僵硬和焦虑。因为他要把自己变成一座完美的雕像，而雕像是没有生命的。

但真相是什么？
观众不是来审判你的，他们是来听故事、学知识、找价值的。
他们不在乎你是否发抖，他们只在乎你讲的东西对他们有没有用。

现在，请按下【暂停的锚点】。
深呼吸。看着台下那些模糊的脸，他们不是怪兽，他们是你的同事，你的朋友，是有血有肉的人。
把关注点从“我表现得好不好”（Ego），移向“我能给他们带来什么”（Service）。

请邀请**“庆祝者”（Energy 540: Joy）**登场。
在庆祝者眼里，这哪里是考试？这是一场庆典！
你辛苦准备了一年的成果，就像你精心挑选的一份礼物。现在，你有机会把它亲手送给在座的每一个人。
当你去送礼物时，你会在意自己的发型乱不乱吗？你只会期待对方拆开礼物时开心的表情。

对自己说：“我有一份很棒的礼物（内容）要分享给你们。我迫不及待想让你们知道我们团队做成了什么！”
当你带着“给予”和“分享”的喜悦上台时，紧张会转化为兴奋。
把观众当朋友，哪怕忘词了，也是真实的可爱。
享受舞台，享受连接。因为在喜悦的频率里，你是不可战胜的。`
    },
    creativeOption: {
      id: "celebrator_choice",
      label: "享受分享（喜悦庆典）",
      labelKey: "gameplay.options.office_08.celebrator",
      archetype: "庆祝者",
      visualEffect: "indigo",
      followUp: [
        {
          type: "narrator",
          text: "你闭上眼，做了一个深呼吸，嘴角不自觉地上扬。你告诉自己：“这不是考试，这是我展示团队心血的庆功宴！”",
          textKey: "gameplay.dialogues.office_08.creative.1"
        },
        {
          type: "action",
          text: "你大步走上台，没有急着念PPT，而是先微笑着环视了一圈观众，甚至和前排的同事做了一个眼神交流。你的身体放松了下来。",
          textKey: "gameplay.dialogues.office_08.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（语气轻松，充满感染力）大家下午好！在开始看枯燥的数据前，我想先跟分享一个我们在项目初期遇到的趣事……",
          textKey: "gameplay.dialogues.office_08.creative.3"
        },
        {
          type: "narrator",
          text: "你脱稿了，但你讲得更生动了。你不再关注自己是否完美，而是关注大家听懂了没有，开心了没有。台下开始有了笑声，有了点头，这种能量的回流让你越讲越兴奋。",
          textKey: "gameplay.dialogues.office_08.creative.4"
        },
        {
          type: "success",
          text: "演讲结束时，掌声是热烈而真诚的。VP甚至专门走过来拍了拍你的肩膀说：“讲得真好，很有激情！”你发现，当你忘记了“表演”，只是纯粹地“分享”时，你就是舞台上最亮的那束光。",
          textKey: "gameplay.dialogues.office_08.creative.5"
        }
      ]
    }
  }
};

// 9. 微管理狂老板 (Office 09)
export const officeMicromanageScript: ScenarioScript = {
  id: "office_09",
  title: "微管理狂老板",
  titleKey: "gameplay.sceneTitles.office_09",
  sceneImage: "/scenarios/office_09.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "上午10点，你的钉钉响了第八次。又是那个熟悉头像——你的老板。",
      textKey: "gameplay.dialogues.office_09.opening.1"
    },
    {
      type: "npc",
      speaker: "老板",
      speakerKey: "gameplay.characters.boss",
      text: "那个方案写到哪了？截图发我看看。还有，昨晚让你改的PPT第15页那个标题，颜色是不是有点太深了？换个RGB值再发我确认一下。",
      textKey: "gameplay.dialogues.office_09.opening.2"
    },
    {
      type: "narrator",
      text: "一种强烈的窒息感扼住了你的喉咙。这是这周的常态：他不仅管进度，连标点符号、字体颜色、甚至邮件抄送顺序都要一一过问。你感觉自己不是在做项目，而是在做一个提线木偶。",
      textKey: "gameplay.dialogues.office_09.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "tyrant_choice",
        label: "消极对抗（内心咒骂）",
        labelKey: "gameplay.options.office_09.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "愤怒在胸腔里炸开。你在心里狠狠地骂了一句：“变态控制狂！这点破事也要管？你怎么不自己做？！”",
            textKey: "gameplay.dialogues.office_09.survival.tyrant.1"
          },
          {
            type: "action",
            text: "你决定不再秒回，故意拖延时间。他越催，你越慢。你甚至故意把颜色改得更丑，心里想着：“我就这样，看你能把我怎么样。”",
            textKey: "gameplay.dialogues.office_09.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "你的对抗姿态瞬间激起了老板更大的焦虑。他开始每隔10分钟就来站在你身后盯着你屏幕，甚至开始在周会上公开质疑你的工作态度。你以为你在反抗暴政，结果却招来了更严酷的监管。",
            textKey: "gameplay.dialogues.office_09.survival.tyrant.3"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "自怨自艾（感到窒息）",
        labelKey: "gameplay.options.office_09.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你感到一阵深深的无力。你觉得自己的才华被这个狭隘的老板扼杀了，觉得自己是全公司最倒霉的人。",
            textKey: "gameplay.dialogues.office_09.survival.victim.1"
          },
          {
            type: "inner_monologue",
            text: "“为什么我的命这么苦？遇到这种老板，我这辈子算是废了。怀才不遇，这就是我的宿命吧。”",
            textKey: "gameplay.dialogues.office_09.survival.victim.2"
          },
          {
            type: "failure",
            text: "你每天叹着气工作，眼神黯淡无光。这种受害者的气场让你在工作中频频出错，老板觉得你不仅态度消极而且能力不行，彻底把你边缘化。你依然在叹气，却没有任何改变。",
            textKey: "gameplay.dialogues.office_09.survival.victim.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：与其对抗黑暗，不如点亮灯光",
      titleKey: "gameplay.directorNote.office_09.title",
      contentKey: "gameplay.directorNote.office_09.content",
      content: `亲爱的导演，这一幕名为“权力的游戏”，实际上是一场关于“安全感”的博弈。

面对一个微管理狂（Micromanager），我们的本能反应往往是“反抗”或“逃离”。
看看那个咬牙切齿的**“暴君”（Energy 150: Anger）**。他把老板的行为解读为“对我的不信任”和“对我的羞辱”。于是他选择开战，用拖延和冷脸来捍卫自己的领地。但这只会让老板觉得“局面失控了”，从而引发更强的控制欲。这是一场没有赢家的恶性循环。

再看看那个哀叹命运的**“受害者”（Energy 75: Grief）**。他把老板的控制看作是命运的诅咒，把自己放在了无能为力的位置上。当你放弃了主观能动性，你就真的只能任人宰割。

但真相是什么？
老板为什么会控制？因为他**恐惧**。
他的控制欲源于他内在深层的不安全感。他害怕出错，害怕失控，害怕无法向他的上级交代。那个不断挑剔字体的行为背后，是一个瑟瑟发抖的灵魂在尖叫：“请给我一点确定性！”

现在，请按下【暂停的锚点】。
深呼吸。不要把他的行为看作对你个人的攻击。
试着开启**“智者”（Energy 350/400: Reason）**的X光眼，透过那个强势的暴君外壳，看到里面那个焦虑的小孩。

智者知道一个管理的秘密：**也是人，也需要被安抚。**
对抗黑暗（控制）的最好方式，不是制造更多的黑暗（反抗），而是点亮灯光（确定性）。
如果他的恐惧是“未知”，那么你的解药就是“信息”。
你不需要等待他来查岗，你可以主动出击。用高频、高质量的信息流，去填满他的不安全感。当你给足了他想要的“掌控感”，他自然就会松手。因为他控制的目的不是为了累死自己，而是为了确保安全。

当你用智慧去管理你的老板，而不是用情绪去对抗他时，你就掌握了通往自由的钥匙。`
    },
    creativeOption: {
      id: "sage_choice",
      label: "向下管理（主动赋予确定性）",
      labelKey: "gameplay.options.office_09.sage",
      archetype: "智者",
      visualEffect: "blue",
      followUp: [
        {
          type: "narrator",
          text: "你深吸一口气，平复了内心的烦躁。你意识到，老板的“找茬”是在求救，他在乞求“安全感”。你决定不再是被动的猎物，而是成为主动的猎人。",
          textKey: "gameplay.dialogues.office_09.creative.1"
        },
        {
          type: "action",
          text: "你没有回复那条关于颜色的消息，而是直接整理了一份《项目进度日报》和《关键节点预警表》，走进了他的办公室。",
          textKey: "gameplay.dialogues.office_09.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（语气平和且专业）老板，关于那个PPT的颜色我马上改。但我看您最近比较担心这个项目的进度，所以我梳理了一份详细的每日进度表。以后每天早晚9点，我会主动给您发一份简报，包含当天的完成情况、风险点和明天的计划。",
          textKey: "gameplay.dialogues.office_09.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "另外，对于关键决策点，我会提前给出ABC三个方案供您选择，保证都在您的掌控之中。您看这样可以减少您盯着细节的时间吗？",
          textKey: "gameplay.dialogues.office_09.creative.4"
        },
        {
          type: "narrator",
          text: "老板看着那份清晰的表格，紧绷的肩膀肉眼可见地松弛了下来。他眼中的焦虑消散了，取而代之的是一种被托底的安心。",
          textKey: "gameplay.dialogues.office_09.creative.5"
        },
        {
          type: "npc",
          speaker: "老板",
          speakerKey: "gameplay.characters.boss",
          text: "……哎，行。你能这么主动太好了。其实我也不是非要管那么细，就是怕出岔子。既然你有数，那以后你就自己把控，每周汇报一次就行。",
          textKey: "gameplay.dialogues.office_09.creative.6"
        },
        {
          type: "success",
          text: "你走出办公室，感到前所未有的轻松。你用“主动汇报”的锁链，换来了真正的“执行自由”。你没有改变老板的人格，但你用智慧改变了你们的关系模式。",
          textKey: "gameplay.dialogues.office_09.creative.7"
        }
      ]
    }
  }
};

// 10. 嫉妒同事晋升 (Office 10)
export const officePromotionJealousyScript: ScenarioScript = {
  id: "office_10",
  title: "嫉妒同事晋升",
  titleKey: "gameplay.sceneTitles.office_10",
  sceneImage: "/scenarios/office_10.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "周一上午，全员邮件弹出了一条人事任命通知。那个和你同期进公司、平时看起来能力也差不多的同事小赵，被正式提拔为部门主管，薪资职级连跳两级。",
      textKey: "gameplay.dialogues.office_10.opening.1"
    },
    {
      type: "narrator",
      text: "周围的同事纷纷围过去道喜，办公室里充满了欢声笑语。你坐在不远处的工位上，看着被人群簇拥、红光满面的小赵，感觉胸口像是被重锤狠狠砸了一下。",
      textKey: "gameplay.dialogues.office_10.opening.2"
    },
    {
      type: "inner_monologue",
      text: "（心中的酸楚）“凭什么？明明我资历更老，上个季度的业绩也不比他差。难道就因为他平时会跟老板喝咖啡？这太不公平了……”",
      textKey: "gameplay.dialogues.office_10.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "performer_choice",
        label: "虚假祝贺（背后贬低）",
        labelKey: "gameplay.options.office_10.performer",
        archetype: "演员",
        visualEffect: "yellow",
        followUp: [
          {
            type: "narrator",
            text: "骄傲的自尊心让你绝不允许自己表现出失落。你迅速戴上了一副完美的社交面具，挤出一个灿烂的笑容走了过去。",
            textKey: "gameplay.dialogues.office_10.survival.performer.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（声音高亢）哎呀小赵！恭喜恭喜啊！我就知道你肯定行，以后可得罩着我们啊！",
            textKey: "gameplay.dialogues.office_10.survival.performer.2"
          },
          {
            type: "action",
            text: "转身回到茶水间，你立刻换了一副嘴脸，跟要好的同事低声吐槽：“切，还不是因为他马屁拍得好。论业务能力，他哪点比得上我？等着看他笑话吧。”",
            textKey: "gameplay.dialogues.office_10.survival.performer.3"
          },
          {
            type: "failure",
            text: "你用贬低对方来维护自己摇摇欲坠的优越感，但心里的空虚和嫉妒却像毒蛇一样吞噬着你。你不仅没有从这次事件中学到任何东西，反而因为刻薄的言论，让周围人觉得你格局狭隘。",
            textKey: "gameplay.dialogues.office_10.survival.performer.4"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "自怜自艾（感到被弃）",
        labelKey: "gameplay.options.office_10.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "一种深深的被遗弃感将你淹没。你觉得公司的决定证明了你“毫无价值”，所有的努力都是徒劳的。",
            textKey: "gameplay.dialogues.office_10.survival.victim.1"
          },
          {
            type: "inner_monologue",
            text: "“看来老板根本就看不起我。我在这里没有未来了。为什么受伤的总是我？也许我真的不如别人……”",
            textKey: "gameplay.dialogues.office_10.survival.victim.2"
          },
          {
            type: "failure",
            text: "你甚至没有勇气去说一声恭喜。那天你早早下班回家，躲在被子里大哭了一场。第二天上班时，你像个泄了气的皮球，对工作失去了所有的热情。你用自我放弃，坐实了“失败者”的身份。",
            textKey: "gameplay.dialogues.office_10.survival.victim.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：嫉妒是匮乏的信号，祝福是丰盛的订单",
      titleKey: "gameplay.directorNote.office_10.title",
      contentKey: "gameplay.directorNote.office_10.content",
      content: `亲爱的导演，这一幕名为“酸葡萄”，是人性中最隐秘也最常见的心理战。

当嫉妒袭来时，就像吞下了一口酸涩的柠檬。
看看那个强颜欢笑的**“演员”（Energy 175: Pride）**。
他的优越感建立在“比别人强”之上。当别人超越他时，他的自我价值瞬间崩塌。为了重建平衡，他必须通过“贬低”对方（Devaluation）来让自己心里好受点：“他只是运气好/会拍马屁。”这种防御机制虽然保护了自尊，但也关闭了成长的眼睛。如果你认为成功只靠拍马屁，那你永远也学不会真正的成功之道。

再看看那个顾影自怜的**“受害者”（Energy 75: Grief）**。
他把别人的成功解读为对自己的羞辱和抛弃。他陷入了零和博弈的陷阱：“他赢了，就意味着我输了。”这是一种极度匮乏的心态。

但真相是什么？
**嫉妒是一张藏宝图。** 它精准地告诉你：“那个东西（晋升、认可、高薪），你也想要。”
而且，嫉妒还隐藏着一个积极的信号：既然你的同类（小赵）能做到，说明这不仅仅是梦想，而是可触及的现实。

现在，请按下【暂停的锚点】。
把手放在那个酸涩的胸口。承认它：“是的，我嫉妒了。因为我也想变得更好。”
这不丢人。这是上进心的扭曲表达。
然后，转换频率。

宇宙有一个基本的显化法则：**你无法吸引你所憎恨的东西。**
如果你憎恨别人的成功，你其实是在向潜意识发送信号：“成功是坏的/不公的。”于是你的潜意识会尽全力让你远离成功。
相反，如果你能发自内心地祝福他，你就是在对自己和宇宙说：“这很棒！我也喜欢这个！我已经准备好迎接这样的好事了！”

请邀请**“实干家”（Energy 250/310: Willingness）**登场。
实干家不搞情绪对抗，只看数据。
小赵的晋升是一个“成功案例”。与其在旁边发酸，不如把他当成免费的导师。
去研究他做对了什么？他补齐了哪块短板？
给予祝福，就是向宇宙下达“我也要来一份”的订单。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "真诚祝福（借力成长）",
      labelKey: "gameplay.options.office_10.doer",
      archetype: "实干家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你做了一个深呼吸，将那一瞬间的酸涩转化为了对自己渴望的确认。你意识到，小赵的成功不是对你的否定，而是对“可能性”的证明。",
          textKey: "gameplay.dialogues.office_10.creative.1"
        },
        {
          type: "action",
          text: "你站起来，整理了一下衣服，走到小赵面前。你的眼神是清澈的，笑容是真诚的。",
          textKey: "gameplay.dialogues.office_10.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（紧紧握住小赵的手）小赵，真诚地恭喜你！虽然我也很眼馋这个位置（幽默地自嘲），但说实话，回顾这半年，你在跨部门协调上确实比我们都做得好，实至名归。",
          textKey: "gameplay.dialogues.office_10.creative.3"
        },
        {
          type: "narrator",
          text: "小赵原本准备好的防御姿态（怕被嫉妒）瞬间卸下了，他感激地看着你：“谢谢你兄弟，其实我心里也慌，以后还得靠大家支持。”",
          textKey: "gameplay.dialogues.office_10.creative.4"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "那是必须的。对了，什么时候有空，想请你吃个饭，跟你请教一下你是怎么搞定那个难缠的客户B的？我也想取取经。",
          textKey: "gameplay.dialogues.office_10.creative.5"
        },
        {
          type: "success",
          text: "那顿饭你们聊得很开心，你学到了很多以前没注意到的细节。更重要的是，因为你的大气和支持，小赵把你视为了最核心的盟友。半年后，随着业务扩展，在小赵的强力推荐下，你也迎来了属于你的机会。你用祝福，为自己铺平了路。",
          textKey: "gameplay.dialogues.office_10.creative.6"
        }
      ]
    }
  }
};


// ========== 场景二：家庭/亲密关系 (Home) ==========

// 11. 家务战争（洗碗） (Home 01)
export const homeHouseworkScript: ScenarioScript = {
  id: "home_01",
  title: "家务战争",
  titleKey: "gameplay.sceneTitles.home_01",
  sceneImage: "/scenarios/home_01.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "拖着加班后像灌了铅一样的双腿，你终于回到了家。推开门，迎接你的不是热腾腾的饭菜，而是厨房水槽里堆得像小山一样、那是早上出门前就留下的脏碗筷。",
      textKey: "gameplay.dialogues.home_01.opening.1"
    },
    {
      type: "narrator",
      text: "油脂凝固的气味让你一阵反胃。你转头看向客厅，伴侣正瘫在沙发上刷着短视频，手机里传出刺耳的罐头笑声，而他正笑得前仰后合。",
      textKey: "gameplay.dialogues.home_01.opening.2"
    },
    {
      type: "inner_monologue",
      text: "（心中的怒火瞬间被点燃）“我在外面累死累活，他在家连个碗都不洗？他是不是觉得我就该伺候他？这个家是他旅馆吗？”",
      textKey: "gameplay.dialogues.home_01.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "tyrant_choice",
        label: "瞬间爆炸（愤怒指责）",
        labelKey: "gameplay.options.home_01.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "action",
            text: "你把包重重地摔在玄关柜上，发出巨大的声响。伴侣吓了一跳，还没反应过来，你的咆哮已经开始了。",
            textKey: "gameplay.dialogues.home_01.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（指着厨房）你整天就知道玩手机！眼睛瞎了吗？那一堆碗你看不到吗？简直自私透顶！我是你保姆吗？！",
            textKey: "gameplay.dialogues.home_01.survival.tyrant.2"
          },
          {
            type: "npc",
            speaker: "伴侣",
            speakerKey: "gameplay.characters.partner",
            text: "（被激怒，从沙发上跳起来）你发什么疯？我刚下班歇会儿怎么了？你就不能好好说话吗？",
            textKey: "gameplay.dialogues.home_01.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "原本渴望的休息变成了激烈的争吵。最后碗虽然洗了，但那是伴侣带着恨意摔摔打打洗完的。你们背对背睡了一晚，家里的空气冷得结冰。",
            textKey: "gameplay.dialogues.home_01.survival.tyrant.4"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "忍气吞声（悲情洗碗）",
        labelKey: "gameplay.options.home_01.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你没有说话，只是沉重地叹了口气，眼神里充满了失望和哀怨。你觉得自己命苦，找了个根本不懂体贴的人。",
            textKey: "gameplay.dialogues.home_01.survival.victim.1"
          },
          {
            type: "action",
            text: "你默默地走进厨房，打开水龙头，边洗碗边流泪。你故意把碗碟碰得叮当响，希望引起他的注意，但他似乎戴着耳机根本没听见。",
            textKey: "gameplay.dialogues.home_01.survival.victim.2"
          },
          {
            type: "inner_monologue",
            text: "“算了，这就是我的命。全家都指望我，累死我算了。反正也没人心疼。”",
            textKey: "gameplay.dialogues.home_01.survival.victim.3"
          },
          {
            type: "failure",
            text: "你洗完了碗，但心中的怨气像毒素一样积累。晚上他对你说话，你冷冷地回一句“没怎么”。你用冷暴力筑起了一道墙，虽然没有吵架，但爱被隔离了。",
            textKey: "gameplay.dialogues.home_01.survival.victim.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：碗只是碗，不是他不爱你的证据",
      titleKey: "gameplay.directorNote.home_01.title",
      contentKey: "gameplay.directorNote.home_01.content",
      content: `亲爱的导演，这一幕名为“也是最常见的家庭剧本”。

为什么几个脏碗能引发一场世界大战？
因为在那一刻，你看到的不是“碗”，而是“他不爱我/他不尊重我”的证据。

看看那个咆哮的**“暴君”（Energy 150: Anger）**。
暴君的逻辑是：“如果我在乎这个家，你也应该在乎。你没做，就是对我的攻击。”他试图用愤怒来控制对方的行为，用吼叫来索取关注。但愤怒只能换来防御和反击。当你把伴侣当成敌人时，家就变成了战场。

再看看那个流泪的**“受害者”（Energy 75: Grief）**。
受害者的逻辑是：“我很惨，以此来证明你很坏。”这是一种道德绑架。你通过让自己受苦，试图唤起对方的内疚。但内疚不是爱，内疚是关系中最沉重的枷锁。想让人在内疚中学会爱你，就像试图在盐碱地里种玫瑰。

现在，请按下【暂停的锚点】。
深呼吸。把目光从那一堆“罪证”（脏碗）上移开。
区分**“事实”**和**“故事”**。
事实是：碗没洗。他在看手机。
故事是：他是个自私的混蛋，他不爱我，我被当成了保姆。

是你头脑中的“故事”让你痛苦，而不是那几个碗。
他在看手机笑，也许只是因为他今天工作也很累，想通过这种方式解压，就像你需要一个拥抱一样。

请邀请**“和平的观察者”（Energy 600: Peace）**登场。
观察者拥有把“事实”从“情绪”中剥离的能力。
你不需要压抑你的疲惫，你只需要诚实地表达它，而不是把它包装成攻击的武器。
脆弱（Vulnerability）是连接的桥梁，而指责是切断连接的刀。
试着不去评判他（“你懒惰”），而是表达自己（“我累了”）。
当你放下武器，露出柔软的腹部时，你往往会惊讶地发现，对方其实一直都准备着爱你。`
    },
    creativeOption: {
      id: "observer_choice",
      label: "非暴力沟通（如实表达）",
      labelKey: "gameplay.options.home_01.observer",
      archetype: "和平的观察者",
      visualEffect: "violet",
      followUp: [
        {
          type: "narrator",
          text: "你停在客厅中央，做了一次深呼吸，觉察到那股想发火的冲动，然后温柔地对自己说：“我看见你了，愤怒。但我现在选择和平。”",
          textKey: "gameplay.dialogues.home_01.creative.1"
        },
        {
          type: "action",
          text: "你走到沙发旁，没有挡住他的视线，而是疲惫地在他身边坐下，把头轻轻靠在他的肩膀上。",
          textKey: "gameplay.dialogues.home_01.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（语气平和而脆弱）亲爱的，我今天加了一天班，现在感觉电量彻底耗尽了。刚进门看到水槽里的碗，我那一瞬间真有点崩溃，感觉压力好大。",
          textKey: "gameplay.dialogues.home_01.creative.3"
        },
        {
          type: "narrator",
          text: "听到你疲惫而非指责的声音，伴侣愣了一下，立刻放下了手机。他感受到的不是攻击，而是你需要他。",
          textKey: "gameplay.dialogues.home_01.creative.4"
        },
        {
          type: "npc",
          speaker: "伴侣",
          speakerKey: "gameplay.characters.partner",
          text: "（有些愧疚地搂住你）哎呀，对不起老婆，我回来也累瘫了，就想躺会儿，把碗给忘了。你别动，坐着休息，我这就去洗。",
          textKey: "gameplay.dialogues.home_01.creative.5"
        },
        {
          type: "success",
          text: "看着他在厨房忙碌的背影，你感到一阵温暖。你没有用争吵赢得胜利，你用示弱赢得了爱。碗洗干净了，你们的心也贴得更近了。这就是“和平”的力量。",
          textKey: "gameplay.dialogues.home_01.creative.6"
        }
      ]
    }
  }
};

// 12. 被遗忘的纪念日 (Home 02)
export const homeAnniversaryScript: ScenarioScript = {
  id: "home_02",
  title: "被遗忘的纪念日",
  titleKey: "gameplay.sceneTitles.home_02",
  sceneImage: "/scenarios/home_02.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "今天是你们结婚五周年的纪念日。为了这一天，你提前一周就在期待。",
      textKey: "gameplay.dialogues.home_02.opening.1"
    },
    {
      type: "narrator",
      text: "然而，从早上出门到晚上回家，虽然你们聊了家务、聊了孩子、聊了工作，但他似乎完全屏蔽了这个特殊的日子。没有任何礼物，没有鲜花，甚至连一句“快乐”都没有。",
      textKey: "gameplay.dialogues.home_02.opening.2"
    },
    {
      type: "narrator",
      text: "现在已经是晚上11点，他打着哈欠关了灯，准备睡觉。你的心一点点沉了下去，失望像潮水一样将你淹没。",
      textKey: "gameplay.dialogues.home_02.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "victim_choice",
        label: "独自流泪（哀悼爱情）",
        labelKey: "gameplay.options.home_02.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "巨大的悲伤袭来。你背对着他，身体蜷缩成一团，眼泪无声地滑落，浸湿了枕头。",
            textKey: "gameplay.dialogues.home_02.survival.victim.1"
          },
          {
            type: "inner_monologue",
            text: "“他彻底忘了。看来我在他心里已经一点位置都没有了。以前恋爱时他多殷勤，现在居然连这种日子都不记得。爱消失了，只剩下搭伙过日子。”",
            textKey: "gameplay.dialogues.home_02.survival.victim.2"
          },
          {
            type: "failure",
            text: "你细数着他过去所有的不好，越想越绝望。第二天醒来，你的眼睛肿得像桃子，而他还一脸茫然地问你“怎么了”。你用悲伤筑起了一道高墙，把自己关在了孤独的牢笼里。",
            textKey: "gameplay.dialogues.home_02.survival.victim.3"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "冷漠惩罚（蓄意报复）",
        labelKey: "gameplay.options.home_02.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "失望瞬间转化为了愤怒。你在黑暗中狠狠地瞪着他的背影，心里盘算着怎么让他付出代价。",
            textKey: "gameplay.dialogues.home_02.survival.tyrant.1"
          },
          {
            type: "inner_monologue",
            text: "“行，既然你不仁，别怪我不义。想睡觉？做梦吧。明天早上我绝对不会给你做早饭，你跟我说话我也不会理你。我要让你知道忽视我的下场！”",
            textKey: "gameplay.dialogues.home_02.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "接下来的几天，你开启了全面的“冷暴力”模式。他感到莫名其妙，问你哪里惹你了，你只冷冷地回一句“你自己心里清楚”。家里的气氛降至冰点，他不仅没记起纪念日，反而开始厌恶回家。",
            textKey: "gameplay.dialogues.home_02.survival.tyrant.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：你是快乐的创造者，不是等待施舍的乞丐",
      titleKey: "gameplay.directorNote.home_02.title",
      contentKey: "gameplay.directorNote.home_02.content",
      content: `亲爱的导演，这一幕名为“被遗忘的爱”。

为什么对方忘了纪念日，会让你如此痛苦？
因为在潜意识里，你把“纪念日”当成了一次对爱的**测试**。
**“受害者”（Energy 75: Grief）**相信：“如果他记得，说明他爱我；如果他忘了，说明我不重要。”你把自我价值的裁判权，完全交到了对方那糟糕的记性手里。这是一种极其危险的赌博，因为你注定会输。

而**“暴君”（Energy 150: Anger）**则选择用惩罚来索取爱。但这就像为了让花开得更艳而往上面泼开水一样愚蠢。冷暴力无法唤醒爱，只能唤醒防御和厌恶。

但真相是什么？
纪念日是为了什么？是为了**庆祝**你们的结合，是为了体验**喜悦**。
既然目的是喜悦，为什么非要等对方来发起？
如果你想庆祝，那就去庆祝！
你不是一个等待在路边祈求别人施舍快乐的乞丐。你是一个本自具足的**创造者**。

现在，请按下【暂停的锚点】。
深呼吸。把那个“受害者”的剧本撕掉。
看着身边那个熟睡的傻瓜，他可能只是太忙了，或者天生对日期不敏感（这是事实），但这并不代表他不爱你（这是故事）。

请邀请**“庆祝者”（Energy 540: Joy）**登场。
庆祝者不搞测试，只搞派对。
如果我想吃蛋糕，我就去买。如果我想听好听的话，我就先说给他听。
当你成为光源，你就不需要去寻找光。
试着把这次遗忘变成一个惊喜。你会发现，当你主动创造快乐时，那份快乐是双倍的，因为它完全掌握在你手中。`
    },
    creativeOption: {
      id: "celebrator_choice",
      label: "主动庆祝（创造惊喜）",
      labelKey: "gameplay.options.home_02.celebrator",
      archetype: "庆祝者",
      visualEffect: "indigo",
      followUp: [
        {
          type: "narrator",
          text: "你深吸一口气，突然觉得等待对方来证明爱是一件很无聊的事。你决定自己掌握快乐的主动权。",
          textKey: "gameplay.dialogues.home_02.creative.1"
        },
        {
          type: "action",
          text: "你悄悄拿起手机，订了一个明天早送达的精美蛋糕，并在外卖备注里写上“结婚五周年快乐”。然后，你转身抱住了他，在他耳边轻声说。",
          textKey: "gameplay.dialogues.home_02.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（带着调皮和爱意）亲爱的，五周年快乐！我知道你最近忙晕了，所以我替我们准备了惊喜，明天早上你就知道了！",
          textKey: "gameplay.dialogues.home_02.creative.3"
        },
        {
          type: "narrator",
          text: "他迷迷糊糊地醒来，愣了几秒，突然反应过来，猛地坐起。",
          textKey: "gameplay.dialogues.home_02.creative.4"
        },
        {
          type: "npc",
          speaker: "伴侣",
          speakerKey: "gameplay.characters.partner",
          text: "（一脸震惊和愧疚）天啊！今天是18号？我怎么忙得全忘了……老婆对不起！我真是该死！",
          textKey: "gameplay.dialogues.home_02.creative.5"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（笑着亲了他一下）没关系，罚你明天晚上带我去吃大餐补回来！现在，先给我一个五周年的抱抱。",
          textKey: "gameplay.dialogues.home_02.creative.6"
        },
        {
          type: "success",
          text: "那个晚上，你们在拥抱中入睡。他的愧疚转化为了对你深深的感激和爱意。你没有因为被遗忘而受伤，反而因为主动庆祝，让这个日子变得更加难忘。你成为了家庭快乐的发动机。",
          textKey: "gameplay.dialogues.home_02.creative.7"
        }
      ]
    }
  }
};

// 13. “你根本不听我说” (Home 03)
export const homeListeningScript: ScenarioScript = {
  id: "home_03",
  title: "你根本不听我说",
  titleKey: "gameplay.sceneTitles.home_03",
  sceneImage: "/scenarios/home_03.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "今天在公司受了一肚子委屈，那个难缠的客户无理取闹，老板还跟着甩锅。你带着满身的疲惫和寻求安慰的渴望回到家。",
      textKey: "gameplay.dialogues.home_03.opening.1"
    },
    {
      type: "npc",
      speaker: "你",
      speakerKey: "gameplay.characters.you",
      text: "（一边换鞋一边吐槽）亲爱的，你是不知道今天那个客户有多奇葩，明明是他自己确认的方案……",
      textKey: "gameplay.dialogues.home_03.opening.2"
    },
    {
      type: "narrator",
      text: "你刚开了个头，还没来得及宣泄情绪，坐在沙发上的伴侣就打断了你，一脸理性地分析起来。",
      textKey: "gameplay.dialogues.home_03.opening.3"
    },
    {
      type: "npc",
      speaker: "伴侣",
      speakerKey: "gameplay.characters.partner",
      text: "（放下手机，严肃地）哎，这件事其实你应该先反思一下自己的流程。如果你当时让他签了字，不就没这事了吗？下次你应该……",
      textKey: "gameplay.dialogues.home_03.opening.4"
    },
    {
      type: "narrator",
      text: "那句“你应该”像一根刺一样扎进你的耳朵。你想要的是拥抱，他给你的却是逻辑课。你的火气蹭地一下就上来了。",
      textKey: "gameplay.dialogues.home_03.opening.5"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "tyrant_choice",
        label: "愤怒打断（激烈争吵）",
        labelKey: "gameplay.options.home_03.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "action",
            text: "你猛地把手里的包摔在沙发上，声音提高了八度。",
            textKey: "gameplay.dialogues.home_03.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "你闭嘴行不行？！我不知道要签字吗？我不需要你来教我做事！你到底是哪头的？",
            textKey: "gameplay.dialogues.home_03.survival.tyrant.2"
          },
          {
            type: "npc",
            speaker: "伴侣",
            speakerKey: "gameplay.characters.partner",
            text: "（被吼得莫名其妙）我好心帮你分析问题，你发什么疯？简直不可理喻！",
            textKey: "gameplay.dialogues.home_03.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "原本的求安慰变成了一场激烈的争吵。你不仅没得到安慰，反而受了更多的气。两个人各自关在房间里，谁也不理谁。",
            textKey: "gameplay.dialogues.home_03.survival.tyrant.4"
          }
        ]
      },
      {
        id: "bystander_choice",
        label: "心灰意冷（冷漠隔离）",
        labelKey: "gameplay.options.home_03.bystander",
        archetype: "旁观者",
        visualEffect: "dark", // Energy 50, dark/red
        followUp: [
          {
            type: "narrator",
            text: "一种深深的疲惫感涌上心头。你觉得那是“鸡同鸭讲”，瞬间关闭了心门。",
            textKey: "gameplay.dialogues.home_03.survival.bystander.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（眼神变得空洞，语气冰冷）算了，跟你说也没用。你根本不懂。",
            textKey: "gameplay.dialogues.home_03.survival.bystander.2"
          },
          {
            type: "action",
            text: "你转身走进卧室，关上门，戴上耳机。伴侣在客厅里一头雾水，但也觉得没趣。",
            textKey: "gameplay.dialogues.home_03.survival.bystander.3"
          },
          {
            type: "failure",
            text: "你用冷漠保护了自己，但也切断了连接。你躺在床上刷着手机，感觉在这个家里像个孤独的租客。这种“说了也没用”的绝望感，正在一点点杀死你们的亲密。",
            textKey: "gameplay.dialogues.home_03.survival.bystander.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：没人天生会读心，请给他一份说明书",
      titleKey: "gameplay.directorNote.home_03.title",
      contentKey: "gameplay.directorNote.home_03.content",
      content: `亲爱的导演，这一幕名为“错位的爱”。

为什么你想求安慰，他却在讲道理？
并不是因为他冷漠（虽然**“受害者”**会这么想），也不是因为他爱说教（虽然**“暴君”**会这么看）。
真相是：**男性思维（解决问题）与女性思维（情感连接）的差异。**
当他听到你抱怨时，他的爬行脑判断你在“求助”，而他表达爱的方式就是“帮你解决问题”。他以为他在递给你一把剑（方法），而你其实只想要一个盾（拥抱）。

看看那个愤怒的**“暴君”（Energy 150: Anger）**。
他把对方的建议解读为“攻击”和“贬低”。“你教我做事”=“你觉得我蠢”。于是他发起反击。但这不仅伤害了关系，也打击了伴侣想要帮忙的积极性。

再看看那个绝望的**“旁观者”（Energy 50: Apathy）**。
他选择了放弃沟通，退缩到冷漠的壳里。他的潜台词是：“如果不被完全理解，那就彻底隔离。”这是一种慢性自杀。

但真相是什么？
**没有人天生会读心术。**
如果你不告诉他你需要什么，他只能用他认为对的方式来爱你。
指望伴侣“自动”懂你，是婴儿对母亲的期待，不是成年人的关系。

现在，请按下【暂停的锚点】。
深呼吸。看着那个正在滔滔不绝讲大道理的男人，看到他笨拙背后的善意——他真的想帮你把麻烦解决掉。
不要攻击他的善意，但要修正他的方向。

请邀请**“探险家”（Energy 200: Courage）**登场。
探险家敢于打破惯性，敢于直接表达需求。
你需要做的是递给他一份**“使用说明书”**。
清晰地告诉他：“此时此刻，这个版本的我需要怎么被对待。”
不是指责他做错了，而是教他怎么做是对的。
“亲爱的，我知道你想帮我。但我现在不需要建议，我只需要你借我十分钟耳朵，或者一个抱抱。”
这需要勇气，因为这显得很“矫情”或“脆弱”。但这份清晰的指引，是给直男最好的礼物。`
    },
    creativeOption: {
      id: "explorer_choice",
      label: "清晰指引（表达需求）",
      labelKey: "gameplay.options.home_03.explorer",
      archetype: "探险家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你深吸一口气，压下了心头的烦躁。你意识到他不是在找茬，他只是在用错误的方式帮忙。",
          textKey: "gameplay.dialogues.home_03.creative.1"
        },
        {
          type: "action",
          text: "你走过去，轻轻按住他的手，打断了他的长篇大论。你的眼神柔和但坚定。",
          textKey: "gameplay.dialogues.home_03.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "亲爱的，暂停一下。我知道你的建议很有道理，也是为了我好。但我现在脑子已经转不动了，听不进道理。",
          textKey: "gameplay.dialogues.home_03.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "我现在只需要一个垃圾桶让我倒倒苦水，或者你抱抱我，跟我说句‘那家伙真讨厌’就行。你能借我十分钟耳朵，只听不评判吗？",
          textKey: "gameplay.dialogues.home_03.creative.4"
        },
        {
          type: "narrator",
          text: "伴侣愣了一下，随即恍然大悟，有些不好意思地挠挠头。",
          textKey: "gameplay.dialogues.home_03.creative.5"
        },
        {
          type: "npc",
          speaker: "伴侣",
          speakerKey: "gameplay.characters.partner",
          text: "啊……懂了懂了。也就是现在是‘情绪发泄时间’，不是‘复盘时间’对吧？行，来，肩膀借你。",
          textKey: "gameplay.dialogues.home_03.creative.6"
        },
        {
          type: "success",
          text: "你靠在他怀里发泄了一通，他果然只在旁边附和“太过了”、“辛苦了”。发泄完后，你感觉心情好了大半，甚至主动问他：“那你刚才说的那个建议是什么？”你们在笑声中完成了真正的疗愈。你用一份“说明书”，换回了一个懂你的爱人。",
          textKey: "gameplay.dialogues.home_03.creative.7"
        }
      ]
    }
  }
};

// 14. 金钱观念分歧 (Home 04)
export const homeFinancialScript: ScenarioScript = {
  id: "home_04",
  title: "金钱观念分歧",
  titleKey: "gameplay.sceneTitles.home_04",
  sceneImage: "/scenarios/home_04.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "刚进家门，你就看到客厅茶几上摆着一个巨大的快递箱。伴侣正兴致勃勃地拆封，脸上洋溢着像孩子过年一样的兴奋。",
      textKey: "gameplay.dialogues.home_04.opening.1"
    },
    {
      type: "npc",
      speaker: "伴侣",
      speakerKey: "gameplay.characters.partner",
      text: "亲爱的快看！我心心念念的那套顶级钓鱼装备（或美容仪）终于到货了！这可是限量版，手感简直绝了！",
      textKey: "gameplay.dialogues.home_04.opening.2"
    },
    {
      type: "narrator",
      text: "你凑过去看了一眼价格标签，瞬间倒吸一口凉气——这个数字相当于你们家半个月的生活费。在你的价值观里，花这么多钱买在这个“没用”的东西上，简直是不可理喻。",
      textKey: "gameplay.dialogues.home_04.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "coward_choice",
        label: "焦虑恐慌（灾难联想）",
        labelKey: "gameplay.options.home_04.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "看着那个数字，你的脑海里瞬间弹出了无数个红色的警告窗口。匮乏感像一只冰冷的手攥住了你的心脏。",
            textKey: "gameplay.dialogues.home_04.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（声音颤抖，脸色发白）你怎么敢花这么多钱？你是不是疯了？下个月房贷怎么办？孩子补习班费怎么办？万一这个时候家里人生病急用钱怎么办？",
            textKey: "gameplay.dialogues.home_04.survival.coward.2"
          },
          {
            type: "failure",
            text: "你把这次消费灾难化成了家庭破产的前兆。伴侣的好心情瞬间被你的焦虑浇灭，他感到扫兴又压抑，觉得和你在一起生活充满了沉重感，毫无乐趣可言。",
            textKey: "gameplay.dialogues.home_04.survival.coward.3"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "严厉斥责（强制退货）",
        labelKey: "gameplay.options.home_04.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "怒火中烧。你觉得伴侣这种“先斩后奏”的行为是对你权威的挑战，也是极度不负责任的表现。你像一个严厉的家长面对犯错的孩子。",
            textKey: "gameplay.dialogues.home_04.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（指着东西怒吼）马上给我退掉！买这种垃圾有什么用？你脑子里装的是浆糊吗？在这个家没有我的允许，谁准你花这么大一笔钱的？",
            textKey: "gameplay.dialogues.home_04.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "伴侣的自尊心受到了极大的伤害，他梗着脖子跟你大吵：“我花自己的工资怎么了？我在这个家连这点自由都没有吗？”一场关于金钱的战争演变成了关于尊严的厮杀，两败俱伤。",
            textKey: "gameplay.dialogues.home_04.survival.tyrant.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：金钱是爱的流动，不是控制的锁链",
      titleKey: "gameplay.directorNote.home_04.title",
      contentKey: "gameplay.directorNote.home_04.content",
      content: `亲爱的导演，这一幕名为“账单的考验”。

这不仅仅是关于几千块钱的事，这是关于两个独立的灵魂，如何处理彼此价值观差异的深刻试炼。

看看那个瑟瑟发抖的**“懦夫”（Energy 100: Fear）**。
他的眼里没有“快乐”，只有“生存”。他活在深层的匮乏感中，认为金钱是防御灾难的最后一道防线。任何计划外的支出，对他来说都像是在城墙上凿开了一个洞。他用焦虑绑架了伴侣的快乐，潜台词是：“如果不痛苦地省钱，我们就会死。”

再看看那个暴跳如雷的**“暴君”（Energy 150: Anger）**。
他把金钱看作权力的象征。他认为自己的价值观才是唯一的真理——“我认为没用的东西，就是垃圾”。他试图通过控制对方的消费来确认自己的掌控感。但这在亲密关系中是致命的，因为你在把伴侣当成你的附属品或孩子。

但真相是什么？
金钱的本质是能量。它被创造出来，是为了服务于生命，而不是束缚生命。
对于伴侣来说，那个东西可能不仅仅是个物品，它是他辛苦工作后的奖赏，是他热爱生活的证明，是他情绪价值的载体。
智者知道：**关系 > 金钱**。如果为了省钱而伤了感情，那是世界上最赔本的买卖。

现在，请按下【暂停的锚点】。
深呼吸。看着那个昂贵的物品，再看看伴侣脸上原本兴奋、此刻却可能变得尴尬的表情。
把你对金钱的恐惧（没钱了）和评判（乱花钱）先放一边。

请邀请**“智者”（Energy 350/400: Reason）**登场。
智者拥有“兼容”的能力。
我不一定认同这个东西的实用价值，但我认同它带给你的快乐价值。
同时，智者也拥有“理性”的边界。
我们不需要通过吵架来解决分歧，我们可以通过“预算管理”来达成共识。
试着去理解他的快乐，同时坦诚你的压力。
“亲爱的，我看到你这么开心我也很高兴。只是这个价格确实超出了我们本月的预算……”
在尊重的前提下商量解决方案（比如削减其他开支，或者设立专门的‘快乐基金’），这才是成年人的金钱观。`
    },
    creativeOption: {
      id: "sage_choice",
      label: "理性沟通（尊重与边界）",
      labelKey: "gameplay.options.home_04.sage",
      archetype: "智者",
      visualEffect: "blue",
      followUp: [
        {
          type: "narrator",
          text: "你做了一个深呼吸，没有让那一瞬间的心疼变成伤人的话语。你提醒自己：他的快乐也是家庭财富的一部分。",
          textKey: "gameplay.dialogues.home_04.creative.1"
        },
        {
          type: "action",
          text: "你走过去，先拿起了那个东西，认真地看了看，而不是直接看发票。",
          textKey: "gameplay.dialogues.home_04.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（语气平和）虽然我对这个不太懂，但看这做工确实很精致，难怪你这么喜欢。看你这么开心，我也替你高兴。",
          textKey: "gameplay.dialogues.home_04.creative.3"
        },
        {
          type: "narrator",
          text: "伴侣原本紧绷的神经放松了，眼神里充满了感激。紧接着，你话锋一转，语气依然温柔但理性。",
          textKey: "gameplay.dialogues.home_04.creative.4"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "不过亲爱的，说实话，看到账单的时候我心里还是咯噔了一下的（诚实表达脆弱）。这笔支出确实超出了我们这个月的预算红线。你看这样行不行？既然买了就开心用，但下个月我们的外出就餐额度可能要减半来平衡一下，或者这算作你今年的生日礼物提前预支？",
          textKey: "gameplay.dialogues.home_04.creative.5"
        },
        {
          type: "npc",
          speaker: "伴侣",
          speakerKey: "gameplay.characters.partner",
          text: "（不好意思地挠挠头）哎，确实是我冲动了。行，听你的！下个月我负责做饭，咱们省回来。老婆/老公你真好！",
          textKey: "gameplay.dialogues.home_04.creative.6"
        },
        {
          type: "success",
          text: "一场潜在的家庭危机消弭于无形。你维护了伴侣的快乐，也守住了家庭财务的底线。更重要的是，你们学会了像合伙人一样去协商分歧，而不是像仇人一样互相指责。这不仅是理财的智慧，更是爱的智慧。",
          textKey: "gameplay.dialogues.home_04.creative.7"
        }
      ]
    }
  }
}; 

// 15. 查看手机（信任危机） (Home 05)
export const homeTrustScript: ScenarioScript = {
  id: "home_05",
  title: "信任危机",
  titleKey: "gameplay.sceneTitles.home_05",
  sceneImage: "/scenarios/home_05.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "周五晚上，你们窝在沙发上各自看书刷手机。伴侣的手机突然震动了一下，他拿起来看了一眼，嘴角不自觉地上扬，露出了一个意味深长的笑容。",
      textKey: "gameplay.dialogues.home_05.opening.1"
    },
    {
      type: "action",
      text: "紧接着，当你下意识地凑过去时，他似乎是本能地、极其迅速地按下了锁屏键，把手机扣在了胸口。",
      textKey: "gameplay.dialogues.home_05.opening.2"
    },
    {
      type: "inner_monologue",
      text: "（心中的警铃大作）“他在笑什么？为什么要躲着我？那个笑容不对劲……是不是有情况？难道他在外面有人了？”",
      textKey: "gameplay.dialogues.home_05.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "addict_choice",
        label: "偷看查岗（抓取证据）",
        labelKey: "gameplay.options.home_05.addict",
        archetype: "瘾君子",
        visualEffect: "orange",
        followUp: [
          {
            type: "narrator",
            text: "巨大的不确定性像毒瘾一样发作了。你迫切需要一个“真相”来填补内心的焦虑黑洞。你的心跳快得像要蹦出来，眼神时刻盯着他的手机。",
            textKey: "gameplay.dialogues.home_05.survival.addict.1"
          },
          {
            type: "action",
            text: "趁他去洗澡的时候，你颤抖着手拿起了他的手机，试图试出密码。你翻遍了微信、短信、通话记录，像个侦探一样寻找蛛丝马迹。",
            textKey: "gameplay.dialogues.home_05.survival.addict.2"
          },
          {
            type: "failure",
            text: "你没发现什么实质性的证据，但这并没有让你安心，反而让你觉得他“隐藏得太深”。当他洗完澡出来，看到你手里拿着他的手机，眼神里的信任瞬间熄灭。你为了抓住那个假想敌，亲手杀死了当下的信任。",
            textKey: "gameplay.dialogues.home_05.survival.addict.3"
          }
        ]
      },
      {
        id: "coward_choice",
        label: "疑神疑鬼 (旁敲侧击)",
        labelKey: "gameplay.options.home_05.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "恐惧让你不敢直接面对真相。你害怕一旦问出口，那个你最害怕的答案就会变成现实。于是你选择了最折磨人的方式——猜忌。",
            textKey: "gameplay.dialogues.home_05.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（阴阳怪气地）哟，跟谁聊得这么开心啊？都不敢让我看？是不是有什么不可告人的秘密啊？",
            textKey: "gameplay.dialogues.home_05.survival.coward.2"
          },
          {
            type: "failure",
            text: "伴侣皱起眉头，觉得莫名其妙又被冒犯：“你有病吧？看个段子而已。”你制造的紧张空气让家里充满了火药味，虽然没有爆发战争，但那堵怀疑的墙已经高高竖起。",
            textKey: "gameplay.dialogues.home_05.survival.coward.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：怀疑是剧毒，脆弱是解药",
      titleKey: "gameplay.directorNote.home_05.title",
      contentKey: "gameplay.directorNote.home_05.content",
      content: `亲爱的导演，这一幕名为“潘多拉的魔盒”。

为什么一个简单的锁屏动作，能瞬间引发你内心的海啸？
因为在那个瞬间，你的爬行脑接管了控制权。

看看那个抓耳挠腮的**“瘾君子”（Energy 125: Desire）**。
他对“确定性”有着病态的渴望。他把“真相”当成了止痛药，认为只要看一眼手机，焦虑就会消失。但他错了。怀疑是一个无底洞，你填进去多少证据都填不满。因为你怀疑的不是他，而是你自己——你潜意识里觉得自己不配被忠诚地爱着。偷看手机这种行为，本质上是一种通过侵犯边界来获取虚假安全感的暴力。

再看看那个瑟瑟发抖的**“懦夫”（Energy 100: Fear）**。
他活在“被抛弃”的恐惧剧本里。他不敢直面问题，只能通过旁敲侧击来试探。这种能量是收缩的、阴郁的，它会自动在关系中制造出“不被信任”的磁场。当你把伴侣预设为“潜在的背叛者”时，你其实正在把他推向背叛。

但真相是什么？
真相是：你感到不安。
这就是唯一的真相。至于他是不是出轨，那只是你头脑中的猜测。
面对不安，最高级的处理方式不是控制（查岗），也不是逃避（冷嘲热讽），而是**连接**。

现在，请按下【暂停的锚点】。
深呼吸。承认那一刻你的感受：“我害怕了。”
这不丢人。
在亲密关系中，最大的力量不是“我很强，我不需要你”，而是“我很在乎你，所以我也会脆弱”。

请邀请**“疗愈者”（Energy 500: Love）**登场。
疗愈者知道，信任不是一种“保证”，而是一种“选择”。
解开信任危机的钥匙，不在他的手机密码里，而在你的嘴边。
试着脱下防御的铠甲，向他展示你柔软的腹部。
诚实地告诉他你的感受，而不是指责他的行为。
“亲爱的，刚才那个瞬间，我突然感到很没安全感。”
当你敢于袒露脆弱时，你唤起的将不再是他的防御，而是他的呵护。
[cite_start]只有在真实的连接中，疑虑的迷雾才会消散 [cite: 110, 111]。`
    },
    creativeOption: {
      id: "healer_choice",
      label: "袒露脆弱（建立连接）",
      labelKey: "gameplay.options.home_05.healer",
      archetype: "疗愈者",
      visualEffect: "indigo",
      followUp: [
        {
          type: "narrator",
          text: "你闭上眼睛，做了一次深呼吸。你没有任由那个“被背叛”的剧本在脑海里疯狂生长，而是温柔地看见了那个因为在乎而瑟瑟发抖的内在小孩。",
          textKey: "gameplay.dialogues.home_05.creative.1"
        },
        {
          type: "action",
          text: "你放下手中的书，身体微微前倾，靠近他，眼神清澈而真诚。你没有去抢他的手机，而是握住了他的手。",
          textKey: "gameplay.dialogues.home_05.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（声音轻柔，带着一丝真实的脆弱）亲爱的，刚才你突然锁屏的那个动作，让我心里咯噔了一下。我突然有点害怕，怕你有什么事情瞒着我，怕失去你。我知道这可能是我多想了，但我现在确实感觉有点不安。",
          textKey: "gameplay.dialogues.home_05.creative.3"
        },
        {
          type: "narrator",
          text: "伴侣愣住了。他预想过你会发火、会质问，但他没想过你会如此坦诚地表达在这个关系里的依恋。他的眼神瞬间柔和了下来。",
          textKey: "gameplay.dialogues.home_05.creative.4"
        },
        {
          type: "npc",
          speaker: "伴侣",
          speakerKey: "gameplay.characters.partner",
          text: "（反手握紧你的手，有些抱歉地把手机递给你）傻瓜，你想哪去了。刚才群里发了个以前同事的糗照，太搞笑了，但我怕你觉得低俗就下意识关了。来，给你看，真的啥也没有。",
          textKey: "gameplay.dialogues.home_05.creative.5"
        },
        {
          type: "success",
          text: "你没有接过手机，因为那个解释和他的眼神已经足够了。你顺势靠进他怀里。这一次危机，因为你的真实，反而变成了一次确认彼此重要性的温存时刻。你用脆弱（Love）赢得了真正的安全感。",
          textKey: "gameplay.dialogues.home_05.creative.6"
        }
      ]
    }
  }
};

// 16. 婆媳/岳父母矛盾 (Home 06)
export const homeInLawConflictScript: ScenarioScript = {
  id: "home_06",
  title: "婆媳/岳父母矛盾",
  titleKey: "gameplay.sceneTitles.home_06",
  sceneImage: "/scenarios/home_06.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "长辈来家里小住的第三天。晚饭时，你正准备让孩子自己吃饭，老人却一把夺过碗勺。",
      textKey: "gameplay.dialogues.home_06.opening.1"
    },
    {
      type: "npc",
      speaker: "长辈",
      speakerKey: "gameplay.characters.elder",
      text: "哎呀，孩子这么小自己怎么吃得饱？来，奶奶/姥姥喂！张嘴——啊——",
      textKey: "gameplay.dialogues.home_06.opening.2"
    },
    {
      type: "narrator",
      text: "你眼睁睁看着老人把饭吹了又吹，甚至想用嘴抿一下试试温度。你之前已经委婉提过很多次“要培养孩子独立性”和“卫生问题”，但此刻，他们显然完全没把你的话放在心上。你的伴侣埋头扒饭，假装没看见。",
      textKey: "gameplay.dialogues.home_06.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "忍气吞声（积压怨气）",
        labelKey: "gameplay.options.home_06.invisible",
        archetype: "隐形人",
        visualEffect: "dark",
        followUp: [
          {
            type: "narrator",
            text: "碍于“孝顺”的大帽子，你把到嘴边的话咽了回去。你僵硬地赔着笑脸，心里却像吃了苍蝇一样恶心。",
            textKey: "gameplay.dialogues.home_06.survival.invisible.1"
          },
          {
            type: "action",
            text: "晚饭后回到卧室，你关上门，压抑的怒火瞬间爆发，全部宣泄在伴侣身上。",
            textKey: "gameplay.dialogues.home_06.survival.invisible.2"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（压低声音嘶吼）你刚才瞎了吗？你妈那样喂饭你不管管？这日子没法过了！让你妈明天就走！",
            textKey: "gameplay.dialogues.home_06.survival.invisible.3"
          },
          {
            type: "failure",
            text: "伴侣觉得你不可理喻，两人爆发激烈的冷战。老人在外面听到了动静，更加觉得你是个“难伺候”的人。你忍了，但家里的气氛还是毁了。",
            textKey: "gameplay.dialogues.home_06.survival.invisible.4"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "当场翻脸（逼迫站队）",
        labelKey: "gameplay.options.home_06.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "忍无可忍，无需再忍。你“啪”地一声把筷子拍在桌子上。",
            textKey: "gameplay.dialogues.home_06.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（厉声）妈！我说过多少次了，别这样喂！很不卫生！孩子都多大了？！",
            textKey: "gameplay.dialogues.home_06.survival.tyrant.2"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（转头瞪着伴侣）还有你，你是死人吗？你就看着你妈这样祸害孩子？今天必须把话说清楚！",
            textKey: "gameplay.dialogues.home_06.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "老人当场抹眼泪说自己“费力不讨好”，伴侣夹在中间左右为难最后也恼羞成怒。一顿饭吃成了决裂现场，家庭关系降至冰点。",
            textKey: "gameplay.dialogues.home_06.survival.tyrant.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：家庭需要边界，就像房子需要墙壁",
      titleKey: "gameplay.directorNote.home_06.title",
      contentKey: "gameplay.directorNote.home_06.content",
      content: `亲爱的导演，这一幕名为“权力的入侵”。

这不仅仅是关于怎么喂饭的问题，这是关于两个家庭系统的碰撞。
当长辈介入小家庭时，边界线往往会变得模糊。

看看那个不敢说话的**“隐形人”（Energy 20: Shame）**。
他被“孝道”的枷锁困住了。在他的剧本里，反驳长辈=不孝=坏人。他宁愿牺牲孩子的健康规则和自己的感受，也要维持表面的一团和气。但委曲求全换来的不是和平，而是更深的怨恨，这怨恨最终会反噬到夫妻关系中。

再看看那个掀桌子的**“暴君”（Energy 150: Anger）**。
他把长辈当成了入侵者，试图用愤怒来捍卫领土。他不仅攻击长辈，还逼迫伴侣在“妈”和“老婆/老公”之间做单选题。这种逼迫站队的行为，是把伴侣推向对立面的最快方式。

但真相是什么？
**你们（夫妻）才是这个小家庭的核心。**
长辈是客人，是辅助者。
如果核心不稳，外部的介入就会变成灾难。
解决婆媳/岳父母矛盾的关键，永远不在于搞定长辈，而在于搞定你的伴侣。

现在，请按下【暂停的锚点】。
深呼吸。不要在餐桌上发作（那是战场）。
把情绪收回来，把目光投向你的伴侣。
你需要邀请**“实干家”（Energy 250/310: Willingness）**登场。

实干家知道：**不搞情绪对抗，只做规则建设。**
你需要做的是“统一战线”。在面对长辈之前，你必须先和伴侣达成共识。
这不是“我vs你妈”，而是“我们（父母）vs 育儿问题”。
只有当你们两个人像一支严密的队伍一样行动时，长辈才会尊重你们的规则。

试着把伴侣拉到一边，不是去指责他妈，而是去确认你们的规则。
“亲爱的，我知道妈是好心。但为了孩子，我们得统一口径。”
有了这个共识，再由伴侣（也就是长辈的亲儿子/亲闺女）出面去沟通，效果往往事半功倍。温和而坚定地守住边界，才是对大家庭最大的负责。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "统一战线（温和坚定）",
      labelKey: "gameplay.options.home_06.doer",
      archetype: "实干家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你深吸一口气，没有在餐桌上当场发作，而是平静地吃完了饭。你意识到，直接冲突解决不了问题，反而会制造敌人。",
          textKey: "gameplay.dialogues.home_06.creative.1"
        },
        {
          type: "action",
          text: "饭后，你找借口把伴侣拉进房间，关上门。你没有指责，而是冷静地谈论目标。",
          textKey: "gameplay.dialogues.home_06.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "亲爱的，我知道妈来帮忙很辛苦，我们都很感激。但在喂饭这件事上，医生的建议你也听到了。如果我们标准不一致，孩子会很混乱，最后受苦的是孩子。",
          textKey: "gameplay.dialogues.home_06.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "我们需要统一战线。你是妈的儿子/女儿，你去沟通她更容易听进去。我们能不能达成一个‘家庭公约’？如果妈再喂，我们就温和地把碗拿走，但态度要一致。",
          textKey: "gameplay.dialogues.home_06.creative.4"
        },
        {
          type: "narrator",
          text: "伴侣原本准备好迎接你的抱怨，却发现你在谈论解决与合作。他松了一口气，点了点头：“行，我知道了。刚才我也觉得不妥，但我没好意思说。一会我去跟妈聊聊。”",
          textKey: "gameplay.dialogues.home_06.creative.5"
        },
        {
          type: "success",
          text: "当晚，伴侣去和长辈进行了沟通。虽然长辈有些唠叨，但看到你们夫妻俩态度一致且坚决，也就慢慢妥协了。你守住了小家庭的边界，也没有撕破脸。实干家用规则和联盟，化解了情绪的炸弹。",
          textKey: "gameplay.dialogues.home_06.creative.6"
        }
      ]
    }
  }
};

// 17. 性生活被拒 (Home 07)
export const homeIntimacyScript: ScenarioScript = {
  id: "home_07",
  title: "性生活被拒",
  titleKey: "gameplay.sceneTitles.home_07",
  sceneImage: "/scenarios/home_07.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "夜深人静，卧室的灯光暧昧而温暖。你洗完澡，特意喷了点香水，带着一种期待和羞涩的心情钻进了被窝，手轻轻搭在伴侣的腰上，暗示性地抚摸着。",
      textKey: "gameplay.dialogues.home_07.opening.1"
    },
    {
      type: "narrator",
      text: "你期待着热烈的回应，但对方的身体却僵硬了一下，随后轻轻拿开了你的手，翻过身背对着你。",
      textKey: "gameplay.dialogues.home_07.opening.2"
    },
    {
      type: "npc",
      speaker: "伴侣",
      speakerKey: "gameplay.characters.partner",
      text: "（声音疲惫且冷淡）别闹了，今天太累了，我想睡了。",
      textKey: "gameplay.dialogues.home_07.opening.3"
    },
    {
      type: "narrator",
      text: "这句话像一盆冷水浇在你的热情上。空气瞬间凝固，你的手悬在半空，尴尬、失落和某种难以言喻的刺痛感涌上心头。",
      textKey: "gameplay.dialogues.home_07.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "羞耻退缩（自我嫌弃）",
        labelKey: "gameplay.options.home_07.invisible",
        archetype: "隐形人",
        visualEffect: "dark",
        followUp: [
          {
            type: "narrator",
            text: "一种深层的羞耻感瞬间击穿了你。你觉得刚才主动求欢的自己简直像个小丑，甚至觉得自己的身体是肮脏的、毫无吸引力的。",
            textKey: "gameplay.dialogues.home_07.survival.invisible.1"
          },
          {
            type: "inner_monologue",
            text: "“我就知道会这样。我真的很差劲吧？是不是因为我身材走样了？还是我这方面真的很不行？太丢人了，以后我再也不会主动了。”",
            textKey: "gameplay.dialogues.home_07.survival.invisible.2"
          },
          {
            type: "failure",
            text: "你像一只受伤的蜗牛迅速缩回壳里，裹紧被子缩在床边，大气都不敢出。这种对自己魅力的深度怀疑，让你在接下来的很长一段时间里都回避任何肢体接触，性变成了你的禁区。",
            textKey: "gameplay.dialogues.home_07.survival.invisible.3"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "悲伤流泪（怀疑变心）",
        labelKey: "gameplay.options.home_07.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "被拒绝的瞬间，你听到的不是“我累了”，而是“我不爱你了”。悲伤像潮水一样将你淹没。",
            textKey: "gameplay.dialogues.home_07.survival.victim.1"
          },
          {
            type: "inner_monologue",
            text: "“以前无论多晚他都会回应我的……现在居然这么冷漠。他肯定是在外面有人了，或者单纯就是厌倦我了。我们的爱已经死了。”",
            textKey: "gameplay.dialogues.home_07.survival.victim.2"
          },
          {
            type: "failure",
            text: "你背对着他，眼泪无声地流湿了枕头。第二天早上，你顶着红肿的眼睛，对他充满怨气。你把一次生理上的疲惫，上升到了关系破裂的高度，用哀怨推开了对方。",
            textKey: "gameplay.dialogues.home_07.survival.victim.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：性是爱的流动，不是爱的证明",
      titleKey: "gameplay.directorNote.home_07.title",
      contentKey: "gameplay.directorNote.home_07.content",
      content: `亲爱的导演，这一幕名为“卧室里的寒夜”，触碰的是亲密关系中最隐秘也最脆弱的神经——性与接纳。

当你的求欢被拒绝时，为什么会感到如此巨大的痛苦？
这种痛，往往不只是生理欲望的落空，更是自我价值的崩塌。

看看那个缩在床边的**“隐形人”（Energy 20: Shame）**。
在隐形人的剧本里，性=魅力=价值。如果有性，说明我是值得被爱的；如果没有，说明我是垃圾。他把对方的“拒绝行为”直接等同于“对我这个人的否定”。羞耻感让他觉得自己的欲望是肮脏的，主动是可笑的。这种自我攻击是毁灭性的。

再看看那个默默流泪的**“受害者”（Energy 75: Grief）**。
他把性当成了爱的唯一证明。他的逻辑是：“如果你爱我，你就应该随时满足我。”这是一种婴儿式的全能自恋。一旦需求未被满足，他就立刻滑落到“被遗弃”的剧情里。

但真相是什么？
伴侣说“我累了”，可能仅仅就是——**他累了**。
他的身体需要休息，他的大脑需要关机。这与你有没有魅力、他爱不爱你，没有半毛钱关系。这是**事实**。
而“他不爱我了”、“我好丑”，全都是你头脑里编造的**故事**。

性，是两个人能量盈满时的自然溢出，它是爱的**表达**，而不是爱的**证明**，更不是爱的**全部**。
当性被赋予了“证明我值得”这么沉重的任务时，它就变得不再性感，而变得充满压力。

现在，请按下【暂停的锚点】。
深呼吸。感受被窝的温暖。
看着那个背对着你的背影，试着不用“受伤”的眼光看他，而是用“慈悲”的眼光看他。看见他的疲惫，看见他作为一个凡人的局限。

请邀请**“疗愈者”（Energy 500: Love）**登场。
疗愈者知道：**真正的亲密，是允许。**
允许他累，允许他拒绝，允许今天没有性。
当你能接纳他的拒绝时，你才给了他真正的安全感。
而且，爱有千万种表达方式。如果性（Sex）的通道暂时关闭了，亲密（Intimacy）的通道依然敞开。
一个温暖的拥抱，一句轻声的“晚安”，一种无所求的陪伴，往往比性更能滋养灵魂。
当你放下对“结果”的抓取，爱才会重新开始流动。`
    },
    creativeOption: {
      id: "healer_choice",
      label: "温柔接纳（无压力的爱）",
      labelKey: "gameplay.options.home_07.healer",
      archetype: "疗愈者",
      visualEffect: "indigo",
      followUp: [
        {
          type: "narrator",
          text: "你感到心头一紧，但随即你做了一个深呼吸，没有让羞耻感绑架你。你温柔地对自己说：“这不代表我不被爱，这只代表他累了。”",
          textKey: "gameplay.dialogues.home_07.creative.1"
        },
        {
          type: "action",
          text: "你没有赌气移开身体，也没有继续纠缠，而是更加温柔地从背后抱住了他，把脸贴在他的后背上，传递着一种安定的温度。",
          textKey: "gameplay.dialogues.home_07.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（声音柔和而放松）看来今天真的是累坏了呀。那就好好睡觉，充电第一。晚安，亲爱的。",
          textKey: "gameplay.dialogues.home_07.creative.3"
        },
        {
          type: "narrator",
          text: "听到你没有生气也没有抱怨，伴侣紧绷的背部肌肉明显松弛了下来。他转过身，在黑暗中精准地找到了你的额头，轻轻吻了一下。",
          textKey: "gameplay.dialogues.home_07.creative.4"
        },
        {
          type: "npc",
          speaker: "伴侣",
          speakerKey: "gameplay.characters.partner",
          text: "（带着睡意和感激）谢谢亲爱的……最近项目太赶了。周末补偿你。晚安。",
          textKey: "gameplay.dialogues.home_07.creative.5"
        },
        {
          type: "success",
          text: "虽然没有发生性行为，但你们在那个拥抱中感受到了比平时更深层的连接。你用理解化解了尴尬，用接纳滋养了关系。你知道，这种无压力的亲密，是更长久的激情基石。",
          textKey: "gameplay.dialogues.home_07.creative.6"
        }
      ]
    }
  }
};

// 18. 控制狂伴侣 (Home 08)
export const homeControlFreakScript: ScenarioScript = {
  id: "home_08",
  title: "控制狂伴侣",
  titleKey: "gameplay.sceneTitles.home_08",
  sceneImage: "/scenarios/home_08.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "早晨洗漱时，你随手拿过牙膏挤了一下。还没等你放下，旁边就传来了伴侣尖锐的声音。",
      textKey: "gameplay.dialogues.home_08.opening.1"
    },
    {
      type: "npc",
      speaker: "伴侣",
      speakerKey: "gameplay.characters.partner",
      text: "（眉头紧锁，一脸嫌弃）跟你说过多少次了？牙膏要从尾巴挤！你看你挤得中间这凹进去一块，多难看！还有，昨晚你的衣服又没叠成方块放进柜子里……",
      textKey: "gameplay.dialogues.home_08.opening.2"
    },
    {
      type: "narrator",
      text: "从牙膏的形状到拖鞋的朝向，在这个家里，似乎每件小事都有他/她制定的一套“绝对标准”。你感觉周围布满了隐形的红外线，稍微动一下就会触警报。",
      textKey: "gameplay.dialogues.home_08.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "tyrant_choice",
        label: "激烈反抗（故意对着干）",
        labelKey: "gameplay.options.home_08.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "被当作犯人一样管制的屈辱感瞬间点燃了你的怒火。你想：“凭什么都要听你的？这日子没法过了！”",
            textKey: "gameplay.dialogues.home_08.survival.tyrant.1"
          },
          {
            type: "action",
            text: "你故意当着他的面，狠狠地从牙膏中间捏了一把，把牙膏捏得歪七扭八。",
            textKey: "gameplay.dialogues.home_08.survival.tyrant.2"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（挑衅地）我就爱这么挤，怎么了？这是我家还是监狱啊？看不惯你自己搬出去住！",
            textKey: "gameplay.dialogues.home_08.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "伴侣被你的挑衅激怒，开始翻旧账攻击你“生活习惯差”、“烂泥扶不上墙”。家里变成了权力的战场，你们为了赢过对方，不惜互相伤害，关系陷入了无休止的拉锯战。",
            textKey: "gameplay.dialogues.home_08.survival.tyrant.4"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "窒息顺从（感觉像囚犯）",
        labelKey: "gameplay.options.home_08.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你感到一阵深深的无力感。你觉得无论怎么做都无法让他满意，自己在这个家里毫无尊严和自由。",
            textKey: "gameplay.dialogues.home_08.survival.victim.1"
          },
          {
            type: "action",
            text: "你默默地按照他的要求重新整理了牙膏，低着头走出卫生间，一句话也不敢说。",
            textKey: "gameplay.dialogues.home_08.survival.victim.2"
          },
          {
            type: "inner_monologue",
            text: "“我就像个提线木偶。这样的生活还有什么盼头？我快要窒息了……”",
            textKey: "gameplay.dialogues.home_08.survival.victim.3"
          },
          {
            type: "failure",
            text: "你虽然表面顺从，但内心已经枯萎。为了避免被唠叨，你开始甚至不敢回家，或者在家尽量在这个人面前消失。控制狂并没有因为你的顺从而停止，反而变本加厉，因为你没有边界。",
            textKey: "gameplay.dialogues.home_08.survival.victim.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：反抗也是一种被控制",
      titleKey: "gameplay.directorNote.home_08.title",
      contentKey: "gameplay.directorNote.home_08.content",
      content: `亲爱的导演，这一幕名为“自由的牢笼”。

面对一个控制狂（Control Freak），我们通常只有两种反应：要么像**“受害者”（Energy 75: Grief）**一样屈服，在压抑中枯萎；要么像**“暴君”（Energy 150: Anger）**一样反抗，在冲突中消耗。

但你有没有发现？当你费尽心思去“反着干”时，你的行为其实依然是由他决定的。你为了证明自己不受控制，而变得必须要去反抗，这本身就是另一种形式的被控制。你依然在他的剧本里，只不过演了一个反派。

那么，真相是什么？
他为什么要控制？因为他内在有巨大的**焦虑**。
牙膏必须从尾巴挤，不是为了折磨你，而是为了抚平他内心对“失控”的恐惧。他试图通过整理外部世界（物品、你），来整理他混乱的内部世界。
那是他的课题，不是你的错。

现在，请按下【暂停的锚点】。
深呼吸。不要认同他的投射（“我很差劲”），也不要对抗他的恐惧（“我要赢你”）。
请邀请**“和平的观察者”（Energy 600: Peace）**登场。

观察者拥有“如如不动”的力量。
你不需要改变他（那很难），也不需要改变自己来迎合他（那很痛苦）。
你只需要**做你自己**。
保持你内在的节奏。当风暴来袭时，做一座山，而不是随风起舞的草，也不是试图挡风的墙。
温和而坚定地告诉他：“我看到了你的焦虑，但我有我的方式。”
当你不再随他的情绪起舞，当你的内核足够稳定时，他的控制欲就会像打在棉花上的拳头，因为没有受力点而自然消退。`
    },
    creativeOption: {
      id: "observer_choice",
      label: "如如不动（温和坚定）",
      labelKey: "gameplay.options.home_08.observer",
      archetype: "和平的观察者",
      visualEffect: "violet",
      followUp: [
        {
          type: "narrator",
          text: "你停下了手中的动作，做了一个深长的呼吸。你看着眼前这个因为一支牙膏而焦躁不安的人，心中没有愤怒，只有一种看透真相的平静。",
          textKey: "gameplay.dialogues.home_08.creative.1"
        },
        {
          type: "inner_monologue",
          text: "（对自己说）“他在通过控制物品来缓解焦虑。这是他的剧本，我不必入戏。”",
          textKey: "gameplay.dialogues.home_08.creative.2"
        },
        {
          type: "action",
          text: "你没有按照他的要求去挤牙膏，也没有故意破坏。你只是按照自己的方式，平静地把牙膏放回原处，然后转过身，直视他的眼睛，语气温和但没有任何商量的余地。",
          textKey: "gameplay.dialogues.home_08.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "亲爱的，我知道看到东西乱放会让你心里很难受，那是你在意细节。但我有我自己的生活习惯，这种习惯让我感觉放松。我尊重你的标准，也请你尊重我的方式。",
          textKey: "gameplay.dialogues.home_08.creative.4"
        },
        {
          type: "narrator",
          text: "你的语气里没有一点火药味，也没有一丝怯懦。这种强大的稳定性让他愣住了。他原本准备好的争吵或说教，突然失去了目标。",
          textKey: "gameplay.dialogues.home_08.creative.5"
        },
        {
          type: "npc",
          speaker: "伴侣",
          speakerKey: "gameplay.characters.partner",
          text: "（张了张嘴，最后嘟囔了一句）……行吧，反正我也管不了你。你自己舒服就行。",
          textKey: "gameplay.dialogues.home_08.creative.6"
        },
        {
          type: "success",
          text: "他转身离开了卫生间。你没有赢过他，但你赢回了自己。你发现，当你像山一样稳时，风自然就停了。你用“允许他焦虑，但不承担他焦虑”的方式，守住了自由。",
          textKey: "gameplay.dialogues.home_08.creative.7"
        }
      ]
    }
  }
};

// 19. 总是迟到 (Home 09)
export const homeLateScript: ScenarioScript = {
  id: "home_09",
  title: "总是迟到",
  titleKey: "gameplay.sceneTitles.home_09",
  sceneImage: "/scenarios/home_09.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "今晚是你们约定好庆祝周年的晚餐。寒风中，你已经在餐厅门口站了半个小时。这已经不是第一次了，他似乎永远都在迟到。",
      textKey: "gameplay.dialogues.home_09.opening.1"
    },
    {
      type: "narrator",
      text: "你打了三个电话都没人接。周围的情侣成双成对地走进餐厅，只有你像个傻瓜一样在风中瑟瑟发抖。你的耐心随着体温一点点流逝。",
      textKey: "gameplay.dialogues.home_09.opening.2"
    },
    {
      type: "inner_monologue",
      text: "（心中的怒火与委屈交织）“明明说好6点的，现在都6点半了！每次都这样，他到底有没有把我放在心上？我是多余的吗？”",
      textKey: "gameplay.dialogues.home_09.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "tyrant_choice",
        label: "当街咆哮（愤怒指责）",
        labelKey: "gameplay.options.home_09.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "当那个气喘吁吁的身影终于出现时，你积攒了半小时的怒火瞬间爆发。你根本不想听解释，只想让他付出代价。",
            textKey: "gameplay.dialogues.home_09.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（大声吼叫，引得路人侧目）你还知道来啊？！你看看几点了？你有没有一点时间观念！跟你这种人在一起简直是折磨！不过了，分手！",
            textKey: "gameplay.dialogues.home_09.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "伴侣一脸尴尬和羞愤，原本想道歉的话也被你的攻击堵了回去。他转身就走，留你一个人在风中凌乱。一场精心准备的晚餐变成了分手的导火索，你赢了脾气，输了关系。",
            textKey: "gameplay.dialogues.home_09.survival.tyrant.3"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "自怜自艾（感到被弃）",
        labelKey: "gameplay.options.home_09.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "悲伤淹没了你。你觉得这次迟到再次证明了一个残酷的“真相”：你不重要。",
            textKey: "gameplay.dialogues.home_09.survival.victim.1"
          },
          {
            type: "inner_monologue",
            text: "“如果他真的爱我，怎么舍得让我等这么久？他肯定是不在乎我了。我总是那个被忽略的人，这就是我的命。”",
            textKey: "gameplay.dialogues.home_09.survival.victim.2"
          },
          {
            type: "failure",
            text: "见到他时，你红着眼眶一言不发，全程冷暴力。无论他怎么道歉，你都沉浸在“我不值得”的悲情剧本里出不来。这顿饭吃得味同嚼蜡，比寒风更冷的是你的心。",
            textKey: "gameplay.dialogues.home_09.survival.victim.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：改变别人是地狱，管理现实是天堂",
      titleKey: "gameplay.directorNote.home_09.title",
      contentKey: "gameplay.directorNote.home_09.content",
      content: `亲爱的导演，这一幕名为“等待的戈多”。

为什么迟到会让你如此愤怒或痛苦？
因为**“暴君”**觉得这是一种挑战（“你不尊重我”），而**“受害者”**觉得这是一种遗弃（“你不爱我”）。
你们都在试图做一件注定失败的事：**改造对方**。
你认为：“如果他爱我，他就应该变得守时。” 但事实可能是，他就是一个时间观念差、容易被突发事件拖住的人（至少目前是）。这是他的出厂设置。

试图把一只慢吞吞的乌龟变成兔子，除了让你自己气出内伤，没有任何用处。
痛苦的根源，不在于他的迟到，而在于你对他“不迟到”的执着期待，以及你在等待过程中的**无所事事**。

现在，请按下【暂停的锚点】。
深呼吸。承认事实：他就是又迟到了。
这不是针对你，这只是他的弱点。
与其对抗这个事实，不如管理这个事实。

请邀请**“智者”（Energy 350/400: Reason）**登场。
智者从不试图改变天气，智者只会带伞。
既然你知道他大概率会迟到半小时，为什么不利用这半小时做点让自己开心的事？
带一本想看的书，或者找个温暖的咖啡厅处理点自己的事。
当你把“被动的枯等”变成了“主动的独处”，时间的性质就变了。
迟到不再是伤害，而是一段意外赠送的自由时光。
当你不再像个怨妇一样盯着表，而是从容地合上书说“你来啦”，你会发现，你不仅放过了他，更放过了你自己。`
    },
    creativeOption: {
      id: "sage_choice",
      label: "管理预期（享受独处）",
      labelKey: "gameplay.options.home_09.sage",
      archetype: "智者",
      visualEffect: "blue",
      followUp: [
        {
          type: "narrator",
          text: "你看了看表，叹了口气，随即意识到：发火除了坏心情毫无用处。既然他还没来，那这半小时就是完全属于我的。",
          textKey: "gameplay.dialogues.home_09.creative.1"
        },
        {
          type: "action",
          text: "你没有继续站在风口，而是转身走进了隔壁温暖的书店。你拿起一本早就想看的书，沉浸其中，甚至享受这片刻的宁静。",
          textKey: "gameplay.dialogues.home_09.creative.2"
        },
        {
          type: "narrator",
          text: "当他终于满头大汗地跑来，以为会迎接一场狂风暴雨时，却看到你正安静地看书，神情平和。",
          textKey: "gameplay.dialogues.home_09.creative.3"
        },
        {
          type: "npc",
          speaker: "伴侣",
          speakerKey: "gameplay.characters.partner",
          text: "（内疚又惊讶）老婆/老公，对不起对不起！路上太堵了，我还以为你会杀了我……",
          textKey: "gameplay.dialogues.home_09.creative.4"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（合上书，微笑着）没事，刚好趁这空档看了几章书，还挺有意思的。不过下次咱们还是约晚半小时吧，或者设个‘迟到罚金’充当旅游基金？",
          textKey: "gameplay.dialogues.home_09.creative.5"
        },
        {
          type: "success",
          text: "他松了一大口气，感激地看着你。那顿晚餐你们吃得很愉快。你用智慧接纳了他的不完美，也通过调整规则（约晚点/罚金）来管理未来。你不再是被动等待的受害者，而是掌控时间的智者 [cite: 130, 131, 132, 133, 134, 135]。",
          textKey: "gameplay.dialogues.home_09.creative.6"
        }
      ]
    }
  }
};

// 20. 情感勒索 (Home 10)
export const homeEmotionalBlackmailScript: ScenarioScript = {
  id: "home_10",
  title: "情感勒索",
  titleKey: "gameplay.sceneTitles.home_10",
  sceneImage: "/scenarios/home_10.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "一次激烈的争吵中，气氛已经降至冰点。你坚持自己的某个决定（比如换工作、假期安排或教育方式），而这显然不符合伴侣的期待。",
      textKey: "gameplay.dialogues.home_10.opening.1"
    },
    {
      type: "action",
      text: "伴侣突然红了眼眶，声音哽咽，祭出了那句让你无法反驳的“杀手锏”。",
      textKey: "gameplay.dialogues.home_10.opening.2"
    },
    {
      type: "npc",
      speaker: "伴侣",
      speakerKey: "gameplay.characters.partner",
      text: "（声泪俱下）为了这个家，我放弃了晋升的机会，每天累死累活伺候你们爷俩/娘俩。我都为你牺牲到这个份上了，你现在居然连这点要求都不答应我？你怎么能这么没良心？",
      textKey: "gameplay.dialogues.home_10.opening.3"
    },
    {
      type: "narrator",
      text: "这句话像一记重锤砸在你的胸口。巨大的道德压力让你瞬间窒息，你觉得自己仿佛成了这世上最自私、最冷血的罪人。",
      textKey: "gameplay.dialogues.home_10.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "sinner_choice",
        label: "愧疚妥协（自我审判）",
        labelKey: "gameplay.options.home_10.sinner",
        archetype: "罪人",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "“我真该死。”内疚感瞬间击溃了你的防线。你觉得自己欠他太多，根本没有资格提自己的需求。",
            textKey: "gameplay.dialogues.home_10.survival.sinner.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（低下头，声音颤抖）对不起……是我太自私了，没考虑到你的感受。都听你的，我不换工作了/不去旅游了。",
            textKey: "gameplay.dialogues.home_10.survival.sinner.2"
          },
          {
            type: "failure",
            text: "你放弃了自己的原则来“赎罪”。虽然争吵结束了，但你心里感到一种沉重的压抑。你发现，这份爱已经变质成了还债，而你是永远还不清的债务人。",
            textKey: "gameplay.dialogues.home_10.survival.sinner.3"
          }
        ]
      },
      {
        id: "coward_choice",
        label: "恐惧顺从（害怕决裂）",
        labelKey: "gameplay.options.home_10.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你害怕如果不顺着他，他真的会崩溃，或者这段关系就会结束。恐惧让你选择了投降。",
            textKey: "gameplay.dialogues.home_10.survival.coward.1"
          },
          {
            type: "inner_monologue",
            text: "“只要能让他别哭了，别闹了，怎么样都行。我惹不起还躲不起吗？”",
            textKey: "gameplay.dialogues.home_10.survival.coward.2"
          },
          {
            type: "failure",
            text: "你唯唯诺诺地答应了一切要求。你保住了表面的和平，但失去了自我的尊严。对方发现这招好用，以后每次遇到分歧都会使用“卖惨”来控制你。",
            textKey: "gameplay.dialogues.home_10.survival.coward.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：爱是自由的赠予，不是牺牲的账单",
      titleKey: "gameplay.directorNote.home_10.title",
      contentKey: "gameplay.directorNote.home_10.content",
      content: `亲爱的导演，这一幕名为“爱的绑架”。

这可能是亲密关系中最难解的局。
因为对方手里挥舞着一面名为“牺牲”的大旗，站在了道德的制高点。
看看那个立刻跪下的**“罪人”（Energy 30: Guilt）**。
他把对方的痛苦完全归咎于自己。既然他为我牺牲了，那我就欠他的；既然我欠他的，我就必须用顺从来偿还。这种逻辑把亲密关系变成了一场无休止的“债务纠纷”。你以为你在还债，其实你在喂养对方的控制欲。

再看看那个害怕的**“懦夫”（Energy 100: Fear）**。
他害怕冲突，更害怕背负“忘恩负义”的骂名。于是他交出了自我的主权。

但真相是什么？
**所有的牺牲，本质上都是心甘情愿的选择。**
当年他选择放弃晋升照顾家庭，是因为在那一刻，他认为家庭对他更重要。那是他的价值排序，是他为自己的人生做的选择。
既然是选择，就不是你强加给他的“债”。
你可以感激他的付出，但这不代表你要为此这一辈子都只有“听话”的份。
**情感勒索（Emotional Blackmail）**的核心公式是：如果你不按我说的做，你就是坏人/我就让你痛苦。
这是恐惧，不是爱。

现在，请按下【暂停的锚点】。
深呼吸。把“内疚”从身上剥离下来。
告诉自己：“我是好人，我值得拥有自己的想法。我不接受这份账单。”

请邀请**“探险家”（Energy 200: Courage）**登场。
探险家有勇气直面这种操控。
你需要做的是**课题分离**：
1. **肯定他的付出**（看见他的情绪）。
2. **坚持你的原则**（守住你的边界）。
3. **拆穿勒索的逻辑**（拒绝被绑架）。

这需要极大的勇气，因为对方可能会更愤怒。但只有剪断这根勒索的绳索，平等和尊重才有可能重新生长。告诉他：“我感激你的付出，但这不能成为控制我的理由。我们要的是爱，不是交易。” [cite: 136, 137, 138, 139, 140, 141]`
    },
    creativeOption: {
      id: "explorer_choice",
      label: "温柔坚定（拒绝勒索）",
      labelKey: "gameplay.options.home_10.explorer",
      archetype: "探险家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你感到胃部一阵痉挛，那是内疚在攻击你。但你深吸一口气，稳住了心神。你知道，如果在内疚中妥协，这段关系就完了。",
          textKey: "gameplay.dialogues.home_10.creative.1"
        },
        {
          type: "action",
          text: "你没有退缩，也没有反击，而是走过去，递给他一张纸巾，语气平静但异常坚定。",
          textKey: "gameplay.dialogues.home_10.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "亲爱的，我一直都记得你为这个家付出的一切，我也非常感激和爱你。但这并不意味着，我就必须在所有事情上都听你的，或者放弃我对生活的判断。",
          textKey: "gameplay.dialogues.home_10.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "牺牲是你基于爱做出的选择，而不是用来控制我的筹码。如果你用这种方式逼我妥协，我心里只有委屈，没有爱。我们能不能作为两个平等的成年人，就事论事地谈谈这个问题？",
          textKey: "gameplay.dialogues.home_10.creative.4"
        },
        {
          type: "narrator",
          text: "你的话像一根针，刺破了那个膨胀的道德气球。伴侣愣住了，停止了哭诉。虽然他一时半会还很难接受，但他感觉到了你的边界——你是爱他的，但你是不可被操控的。",
          textKey: "gameplay.dialogues.home_10.creative.5"
        },
        {
          type: "success",
          text: "那场谈话虽然艰难，但你们终于走出了“施恩者”与“负债人”的病态模式。你用勇气捍卫了自我的完整，也迫使对方学会用成熟的方式来处理分歧。爱在自由中，终于得以呼吸。",
          textKey: "gameplay.dialogues.home_10.creative.6"
        }
      ]
    }
  }
};


// ========== 场景三：亲子/教育 (Parent) ==========

// 21. 写作业崩溃 (Parent 01)
export const parentHomeworkScript: ScenarioScript = {
  id: "parent_01",
  title: "辅导作业的崩溃时刻",
  titleKey: "gameplay.sceneTitles.parent_01",
  sceneImage: "/scenarios/parent_01.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "墙上的时钟指向了晚上十点半。台灯发出轻微的电流声，在寂静的房间里显得格外刺耳。",
      textKey: "gameplay.dialogues.parent_01.opening.1"
    },
    {
      type: "narrator",
      text: "桌上摊开的数学作业本已经被橡皮擦破了一个角。一道简单的“鸡兔同笼”问题，你已经讲了第十遍。",
      textKey: "gameplay.dialogues.parent_01.opening.2"
    },
    {
      type: "npc",
      speaker: "孩子",
      speakerKey: "gameplay.characters.child",
      text: "（咬着铅笔头，眼神迷离且空洞）爸爸/妈妈……所以，兔子到底有几条腿？",
      textKey: "gameplay.dialogues.parent_01.opening.3"
    },
    {
      type: "narrator",
      text: "那一瞬间，一股滚烫的热浪从你的脚底直冲天灵盖。你的太阳穴突突直跳，理智的防线正在崩塌。",
      textKey: "gameplay.dialogues.parent_01.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "tyrant_choice",
        label: "拍桌怒吼（情绪爆发）",
        labelKey: "gameplay.options.parent_01.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你猛地一拍桌子，巨大的声响让孩子浑身一抖，手中的铅笔掉在了地上。",
            textKey: "gameplay.dialogues.parent_01.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "你是猪脑子吗？！兔子四条腿我讲了十遍了！你是不是故意气我？",
            textKey: "gameplay.dialogues.parent_01.survival.tyrant.2"
          },
          {
            type: "narrator",
            text: "你甚至一把撕掉了那一页作业纸。孩子“哇”地一声哭了出来，恐惧充满了他的眼睛。",
            textKey: "gameplay.dialogues.parent_01.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "教育在这一刻彻底停止，伤害开始了。孩子学会的不是数学，而是对学习的恐惧和对你的疏离。",
            textKey: "gameplay.dialogues.parent_01.survival.tyrant.4"
          }
        ]
      },
      {
        id: "coward_choice",
        label: "焦虑绝望（灾难联想）",
        labelKey: "gameplay.options.parent_01.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你看着孩子茫然的脸，心脏开始剧烈收缩。一种深沉的无力感将你吞没。",
            textKey: "gameplay.dialogues.parent_01.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（双手抱头，语气绝望）完了……连这么简单的题都不会，以后初中怎么办？考不上高中怎么办？这辈子是不是就废了？",
            textKey: "gameplay.dialogues.parent_01.survival.coward.2"
          },
          {
            type: "narrator",
            text: "你在孩子面前长吁短叹，焦虑像病毒一样传染给了孩子。他开始觉得自己是个让父母失望的废物。",
            textKey: "gameplay.dialogues.parent_01.survival.coward.3"
          },
          {
            type: "failure",
            text: "你将当下的一个小困难，无限放大成了人生的终极灾难。恐惧剥夺了孩子尝试的勇气。",
            textKey: "gameplay.dialogues.parent_01.survival.coward.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：当爱变成了恐惧的咆哮",
      titleKey: "gameplay.directorNote.parent_01.title",
      contentKey: "gameplay.directorNote.parent_01.content",
      content: `亲爱的导演，请在这盏昏黄的台灯下，按下那个神圣的【暂停锚点】。

此刻，空气中弥漫着火药味。你的“求生剧组”正在疯狂地抢夺控制台。
那个面目狰狞、拍桌子吼叫的，是你的“暴君”（愤怒，能量层级150）。他想通过暴力和恐吓，强行把知识塞进孩子的脑子里。他相信“只要我足够凶，孩子就会开窍”。但事实上，当人类感到被威胁时，大脑皮层会关闭，只剩下爬行脑在运作——那一刻，孩子不仅学不会数学，他甚至听不懂人话，他只想逃命。

那个在一旁瑟瑟发抖、脑补孩子去送外卖场景的，是你的“懦夫”（恐惧，能量层级100）。他把一道错题等同于失败的人生。他在向孩子投射你对自己未来的不安全感。

请深呼吸。看着眼前这个小小的、被吓坏了的孩子。
那不是你的敌人，那是你的孩子。
那道题做不出来，天不会塌。但如果你继续任由“暴君”肆虐，你们之间的信任之桥会塌。

作为导演，你需要意识到：**当情绪崩溃时，教育就已经停止了。**
你现在面对的不是一个“认知问题”，而是一个“能量问题”。在一个充满恐惧和高压的能量场里，智慧是无法流动的。

请邀请“实干家”（意愿，能量层级310）登场。
实干家不搞情绪对抗，他只解决当下的卡点。他知道，此时此刻，既然“教”已经无效，那么“停”就是最好的“教”。
不管是降低难度，还是哪怕仅仅是允许睡觉，都是一种充满力量的行动。

真正的教育，是让孩子看到：即使在困难和挫败面前，我的父母依然是稳定的，依然是爱我的。
把书本合上吧。今晚，关系比分数更重要。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "暂停与接纳（重置状态）",
      labelKey: "gameplay.options.parent_01.creative",
      archetype: "实干家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你察觉到了胸口那团即将爆发的火焰。你闭上眼睛，强行按下了暂停键。深呼吸，一次，两次，三次。",
          textKey: "gameplay.dialogues.parent_01.creative.1"
        },
        {
          type: "narrator",
          text: "你站起身，走出房间去厨房倒了一杯水，给自己，也给孩子。三分钟的物理隔离，让理智重新回到了大脑。",
          textKey: "gameplay.dialogues.parent_01.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（回到桌前，蹲下来平视孩子，语气平和）看来我们今天的大脑都已经累得转不动了。这道题就像个怪兽，我们现在打不过它。",
          textKey: "gameplay.dialogues.parent_01.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "把书合上吧，先去睡觉。明天早上脑子清醒了，我们换个更简单的方法再试一次。无论你会不会做，爸爸/妈妈都爱你。",
          textKey: "gameplay.dialogues.parent_01.creative.4"
        },
        {
          type: "narrator",
          text: "孩子眼里的惊恐消失了，取而代之的是松了一口气和深深的信赖。他紧紧抱了你一下。",
          textKey: "gameplay.dialogues.parent_01.creative.5"
        },
        {
          type: "success",
          text: "你没有解决那道数学题，但你解决了一个更大的危机。你教会了孩子如何处理挫败感——不是通过自我攻击，而是通过调整状态。今晚，你们都睡了个好觉。",
          textKey: "gameplay.dialogues.parent_01.creative.6"
        }
      ]
    }
  }
};

// 22. 公共场合撒泼 (Parent 02)
export const parentTantrumScript: ScenarioScript = {
  id: "parent_02",
  title: "公共场合的撒泼",
  titleKey: "gameplay.sceneTitles.parent_02",
  sceneImage: "/scenarios/parent_02.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "周六下午的商场，人潮涌动。你正带着孩子路过一家玩具店。",
      textKey: "gameplay.dialogues.parent_02.opening.1"
    },
    {
      type: "npc",
      speaker: "孩子",
      speakerKey: "gameplay.characters.child",
      text: "（死死拽着一个巨大的变形金刚）我要这个！我现在就要！你给我买！",
      textKey: "gameplay.dialogues.parent_02.opening.2"
    },
    {
      type: "npc",
      speaker: "你",
      speakerKey: "gameplay.characters.you",
      text: "不行，家里已经有很多类似的玩具了，而且我们说好今天只买鞋子。",
      textKey: "gameplay.dialogues.parent_02.opening.3"
    },
    {
      type: "narrator",
      text: "下一秒，孩子突然躺倒在商场光洁的地板上，开始疯狂打滚，发出尖锐的哭嚎声。周围的逛街的人群纷纷停下脚步，投来探究、看戏甚至指责的目光。",
      textKey: "gameplay.dialogues.parent_02.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "妥协逃离（羞耻掩盖）",
        labelKey: "gameplay.options.parent_02.invisible",
        archetype: "隐形人",
        visualEffect: "dark",
        followUp: [
          {
            type: "narrator",
            text: "你会感觉到无数道目光像聚光灯一样打在你身上，脸颊瞬间发烫。此时此刻，你只想让这个场面立刻消失。",
            textKey: "gameplay.dialogues.parent_02.survival.invisible.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（压低声音，慌乱地）别哭了！丢死人了！行行行，买买买，快起来！",
            textKey: "gameplay.dialogues.parent_02.survival.invisible.2"
          },
          {
            type: "narrator",
            text: "你为了息事宁人，掏钱买下了玩具，或者粗暴地把孩子拖离现场。你觉得自己像个被公开处刑的罪犯。",
            textKey: "gameplay.dialogues.parent_02.survival.invisible.3"
          },
          {
            type: "failure",
            text: "“隐形人”为了面子牺牲了原则。孩子学会了一课：只要闹得够大，让父母感到丢脸，就能满足愿望。",
            textKey: "gameplay.dialogues.parent_02.survival.invisible.4"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "当众镇压（暴力对抗）",
        labelKey: "gameplay.options.parent_02.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "路人的目光让你感到被冒犯，孩子的行为让你觉得权威受到了挑战。怒火中烧。",
            textKey: "gameplay.dialogues.parent_02.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（指着孩子大吼）你再哭一声试试？无法无天了是吧！给我站起来！",
            textKey: "gameplay.dialogues.parent_02.survival.tyrant.2"
          },
          {
            type: "narrator",
            text: "你当众斥责甚至动手打了孩子，试图用更强的暴力来压制孩子的撒泼，以此向围观者证明你“管教有方”。",
            textKey: "gameplay.dialogues.parent_02.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "你赢了场面，输了孩子。孩子在恐惧中闭嘴，但内心充满了对你的仇恨。你把亲子关系变成了一场权力的角斗。",
            textKey: "gameplay.dialogues.parent_02.survival.tyrant.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：你是容器，不是演员",
      titleKey: "gameplay.directorNote.parent_02.title",
      contentKey: "gameplay.directorNote.parent_02.content",
      content: `亲爱的导演，这一幕真的很难演。
商场的人流、刺眼的灯光、地上的熊孩子、路人像针一样的目光……所有这些元素叠加在一起，构成了一个巨大的高压场。

此时，第一个抢戏的通常是“隐形人”（羞愧，能量层级20）。
你的脸红了，心跳加速。你脑子里全是弹幕：“天哪，大家都在看我”、“他们肯定觉得我是个失败的父母”、“太丢脸了”。此时，你的焦点完全在【观众】身上。为了让观众满意，为了让自己消失在聚光灯下，你选择了妥协——要么买玩具，要么逃跑。你牺牲了教育的原则，只为了维护那层薄薄的面子。

紧接着，“暴君”（愤怒，能量层级150）可能会接管身体。
他觉得羞耻感太痛苦了，于是转化为愤怒向外投射：“都是这个死孩子害我丢脸！”你开始表演给路人看，试图通过严厉的管教来证明“我并没有失控”。

但是，亲爱的导演，请按下【暂停锚点】。
深呼吸。环顾四周。
那些路人，他们只是你人生剧场里的NPC（非玩家角色）。他们看完这一眼，转头就会去买奶茶，根本不会记得你是谁。
别为了讨好NPC，而伤害了你的主角（孩子）。

现在，请把聚光灯从“别人的眼光”上移开，哪怕只有一秒。
把光打在地上那个歇斯底里的小生物身上。
他不是在故意让你丢脸，他只是大脑前额叶未发育成熟，被巨大的挫败感淹没了。他现在就像一个溺水的人，在情绪的洪流里挣扎。

请邀请“疗愈者”（爱，能量层级500）登场。
疗愈者不需要观众，疗愈者只在乎连接。
你需要做的，不是去制止海啸，而是成为容纳海啸的【容器】。
蹲下来，意味着你放下了“高高在上”的面子；抱住他，意味着你提供了“安全”的港湾。
当你选择与孩子的情绪同在，而不是与路人的眼光同在时，奇迹就会发生。羞耻感会退去，爱会流动。
那一刻，商场里只有你们两个人。你不是在表演教子，你是在爱他。`
    },
    creativeOption: {
      id: "healer_choice",
      label: "温和坚定（爱的容器）",
      labelKey: "gameplay.options.parent_02.creative",
      archetype: "疗愈者",
      visualEffect: "indigo",
      followUp: [
        {
          type: "narrator",
          text: "你深吸一口气，像是按下了一个静音键，周围嘈杂的人声和目光瞬间被你屏蔽在背景之外。",
          textKey: "gameplay.dialogues.parent_02.creative.1"
        },
        {
          type: "narrator",
          text: "你并没有站着指责，而是蹲下身，单膝跪地，让自己和孩子的视线齐平。你张开双臂，给这只失控的小兽一个结实的拥抱。",
          textKey: "gameplay.dialogues.parent_02.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（轻拍孩子的后背，语气温柔但不需要大声）我知道你很想要那个变形金刚，没买到你特别难过，甚至很生气，对吗？",
          textKey: "gameplay.dialogues.parent_02.creative.3"
        },
        {
          type: "narrator",
          text: "孩子在你的怀里挣扎了几下，但感受到你的接纳后，尖叫变成了委屈的呜咽。",
          textKey: "gameplay.dialogues.parent_02.creative.4"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（擦去他的眼泪，眼神坚定）想哭就哭一会儿，妈妈/爸爸陪着你。但是我们要遵守约定，今天不买玩具。等你哭好了，我们去买好吃的面包。",
          textKey: "gameplay.dialogues.parent_02.creative.5"
        },
        {
          type: "success",
          text: "你没有因为羞愧而妥协，也没有因为愤怒而施暴。你用“爱”承接了孩子的情绪，同时用“理智”守住了边界。孩子虽然没得到玩具，但他得到了比玩具更珍贵的东西——无条件的接纳。",
          textKey: "gameplay.dialogues.parent_02.creative.6"
        }
      ]
    }
  }
};

// 23. 沉迷屏幕 (Parent 03)
export const parentScreenAddictionScript: ScenarioScript = {
  id: "parent_03",
  title: "电子屏幕的围墙",
  titleKey: "gameplay.sceneTitles.parent_03",
  sceneImage: "/scenarios/parent_03.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "暑假的午后，客厅窗帘紧闭。孩子蜷缩在沙发角落，脸被iPad的幽幽蓝光照亮，手指在屏幕上飞快滑动。",
      textKey: "gameplay.dialogues.parent_03.opening.1"
    },
    {
      type: "npc",
      speaker: "你",
      speakerKey: "gameplay.characters.you",
      text: "吃饭了！叫了你第三遍了！听到没有？",
      textKey: "gameplay.dialogues.parent_03.opening.2"
    },
    {
      type: "narrator",
      text: "空气仿佛是凝固的。孩子像个被抽走灵魂的躯壳，没有任何反应，只有游戏里激烈的音效在回应你的呼唤。",
      textKey: "gameplay.dialogues.parent_03.opening.3"
    },
    {
      type: "narrator",
      text: "那一刻，你感觉横亘在你们之间的不是一个iPad，而是一道无法逾越的叹息之墙。",
      textKey: "gameplay.dialogues.parent_03.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "coward_choice",
        label: "灾难想象（焦虑内耗）",
        labelKey: "gameplay.options.parent_03.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "看着那双盯着屏幕一动不动的眼睛，恐惧像藤蔓一样爬满你的心脏。",
            textKey: "gameplay.dialogues.parent_03.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（内心独白）完了，这孩子眼睛要瞎了，脊椎要弯了。整天沉迷网络，以后肯定不想学习，考不上大学，这辈子就毁了……",
            textKey: "gameplay.dialogues.parent_03.survival.coward.2"
          },
          {
            type: "narrator",
            text: "你在脑海里已经快进到了孩子流落街头的悲惨画面。你站在那里叹气、唠叨，传递着令人窒息的焦虑，却没有任何实际的行动方案。",
            textKey: "gameplay.dialogues.parent_03.survival.coward.3"
          },
          {
            type: "failure",
            text: "你的焦虑并没有让孩子放下iPad，反而让他觉得现实世界充满了令人厌烦的负能量，于是他选择在虚拟世界里躲得更深。",
            textKey: "gameplay.dialogues.parent_03.survival.coward.4"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "强制断网（暴力控制）",
        labelKey: "gameplay.options.parent_03.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "被无视的愤怒让你瞬间失去了理智。你大步冲过去。",
            textKey: "gameplay.dialogues.parent_03.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "我说话当耳旁风是吧？！给我拿来！",
            textKey: "gameplay.dialogues.parent_03.survival.tyrant.2"
          },
          {
            type: "narrator",
            text: "你一把夺过iPad，甚至粗暴地拔掉了家里的路由器网线。孩子猛地跳起来，像一头被激怒的小狮子冲你尖叫，甚至发生了肢体推搡。",
            textKey: "gameplay.dialogues.parent_03.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "屏幕是关掉了，但心门也关上了。家里弥漫着硝烟味。你赢得了控制权，但输掉了尊重和信任。这不再是教育，这是战争。",
            textKey: "gameplay.dialogues.parent_03.survival.tyrant.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：如果不提供更精彩的现实，谁愿意下线？",
      titleKey: "gameplay.directorNote.parent_03.title",
      contentKey: "gameplay.directorNote.parent_03.content",
      content: `亲爱的导演，这一幕不仅发生在你的客厅，也发生在千万个家庭里。这是一场关于注意力的争夺战。

当孩子沉迷屏幕时，你的“求生剧组”往往反应过度。
“懦夫”（恐惧，能量层级100）是一个糟糕的编剧，他擅长把“玩了一下午游戏”直接改写成“毁掉的一生”。这种灾难化的联想让你充满了无力感。
而“暴君”（愤怒，能量层级150）则是一个粗暴的执行者。他相信“切断电源”就能“切断瘾头”。但他忘了，每一个行为背后都有一个未被满足的需求。强行拔网线，就像从一个饥饿的人手里抢走唯一的馒头，只会激起最本能的反抗。

请按下【暂停锚点】。深呼吸。
诚实地问自己：为什么孩子愿意待在屏幕里？
因为那里有即时的反馈，有成就感，有连接感，而且——那里不无聊。
再看看现实世界：也许充满了唠叨、责备、无聊的作业和空荡荡的房间。
有时候，屏幕其实是我们自己请来的“廉价保姆”。我们忙的时候把孩子丢给iPad，现在却怪孩子离不开它。

导演，如果你想让观众（孩子）离开那个虚拟舞台，你得在现实舞台上搭建更吸引人的布景。
请邀请“实干家”（意愿，能量层级310）登场。

实干家明白一个核心逻辑：**你不能只拿走东西（Deprive），你必须提供替代（Replace）。**
如果不想让他玩游戏，那就得提供比游戏更好玩的现实连接。
这不是一场关于“控制”的战争，这是一场关于“规则建设”的谈判。

与其像警察抓小偷一样盯着屏幕时间，不如像合作伙伴一样召开家庭会议。
把问题摆在桌面上：“我们都觉得最近屏幕时间有点失控了，影响了眼睛和睡眠，我们一起来定个规矩怎么样？”
更重要的是，当他放下屏幕时，你能给他什么？是一个一起打篮球的下午？是一场全家参与的桌游？还是一次专注的倾听？

记住，屏幕是现实的替代品。当现实足够温暖、有趣、充满连接时，孩子自然会愿意下线回家。
不要制造战争，去构建规则，去创造生活。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "契约与替代（建设规则）",
      labelKey: "gameplay.options.parent_03.creative",
      archetype: "实干家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你压下心头的焦虑和怒火，没有去抢夺iPad。你走过去，坐在孩子身边，静静地看他打完这一局。",
          textKey: "gameplay.dialogues.parent_03.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（待游戏结束，平和地）这关看起来很难，你反应挺快的。不过，我们之前是不是有个约定？现在是吃饭时间。",
          textKey: "gameplay.dialogues.parent_03.creative.2"
        },
        {
          type: "narrator",
          text: "孩子有些惊讶你没有发火，虽然不情愿，但还是放下了iPad。饭后，你没有说教，而是拿出了一张纸和笔。",
          textKey: "gameplay.dialogues.parent_03.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "我们都需要管理一下屏幕时间了，包括我。来，我们开个家庭会议，一起制定一个大家都能接受的《暑期屏幕公约》。规则我们一起定，惩罚也一起定。",
          textKey: "gameplay.dialogues.parent_03.creative.4"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "另外，省下来的时间，如果你愿意，我们可以去楼下打羽毛球，或者把那盒买了很久的乐高拼完，你选哪个？",
          textKey: "gameplay.dialogues.parent_03.creative.5"
        },
        {
          type: "success",
          text: "你将“对抗”转化为了“合作”。通过契约精神（制定规则）和高质量陪伴（替代活动），你不仅管理了屏幕时间，更重要的是，你让孩子觉得现实世界也很有趣，值得“登录”。",
          textKey: "gameplay.dialogues.parent_03.creative.6"
        }
      ]
    }
  }
};

// 24. 别人家的孩子 (Parent 04)
export const parentComparisonScript: ScenarioScript = {
  id: "parent_04",
  title: "别人家的孩子",
  titleKey: "gameplay.sceneTitles.parent_04",
  sceneImage: "/scenarios/parent_04.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "深夜，你躺在床上刷朋友圈。一条动态刺痛了你的眼睛：你的大学同学晒出了孩子手捧奥数金奖的照片，配文“功夫不负有心人，省一等奖，老母亲的骄傲”。",
      textKey: "gameplay.dialogues.parent_04.opening.1"
    },
    {
      type: "narrator",
      text: "你转头看向客厅，你自家的孩子正四仰八叉地躺在沙发上，一边扣着脚丫，一边看着搞笑漫画傻乐。",
      textKey: "gameplay.dialogues.parent_04.opening.2"
    },
    {
      type: "narrator",
      text: "那一瞬间，巨大的落差感像一块石头砸在你的胸口。期中考试那张平平无奇的成绩单浮现在脑海，焦虑和羞耻混合着涌上心头。",
      textKey: "gameplay.dialogues.parent_04.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "performer_choice",
        label: "虚荣攀比（面子受损）",
        labelKey: "gameplay.options.parent_04.performer",
        archetype: "演员",
        visualEffect: "yellow",
        followUp: [
          {
            type: "narrator",
            text: "你觉得孩子这副懒散的样子简直是在打你的脸。一种“被比下去”的羞耻感让你恼羞成怒。",
            textKey: "gameplay.dialogues.parent_04.survival.performer.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（冲出卧室，一把夺过漫画书）看什么看！就知道看这些没用的！人家小明都拿奥数金奖了，你看看你？我都替你害臊！",
            textKey: "gameplay.dialogues.parent_04.survival.performer.2"
          },
          {
            type: "narrator",
            text: "你为了挽回自己的面子，立刻给孩子报了两个补习班，并在言语上不断贬低他。孩子眼里的光熄灭了，觉得自己是你炫耀失败的次品。",
            textKey: "gameplay.dialogues.parent_04.survival.performer.3"
          },
          {
            type: "failure",
            text: "你把孩子当成了你的“勋章”。当勋章不够闪亮时，你攻击了勋章。你赢回了心理上的虚荣，却失去了孩子的心。",
            textKey: "gameplay.dialogues.parent_04.survival.performer.4"
          }
        ]
      },
      {
        id: "coward_choice",
        label: "焦虑恐慌（阶层跌落）",
        labelKey: "gameplay.options.parent_04.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "看着那个金奖，你脑海里开始播放恐怖片：“一步慢，步步慢”。",
            textKey: "gameplay.dialogues.parent_04.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（内心独白）完了，现在的竞争这么激烈，并没有拿得出手的特长，以后肯定会被社会淘汰，阶层要滑落了……我们家要完了。",
            textKey: "gameplay.dialogues.parent_04.survival.coward.2"
          },
          {
            type: "narrator",
            text: "你整夜失眠，并在第二天开始疯狂地给孩子施压，脸上写满了“大难临头”的焦虑。",
            textKey: "gameplay.dialogues.parent_04.survival.coward.3"
          },
          {
            type: "failure",
            text: "你将对未来的恐惧投射到了当下。孩子感觉不到你的爱，只感觉到你对他未来的不信任。他在你的焦虑中变得更加畏缩。",
            textKey: "gameplay.dialogues.parent_04.survival.coward.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：比较是快乐的小偷",
      titleKey: "gameplay.directorNote.parent_04.title",
      contentKey: "gameplay.directorNote.parent_04.content",
      content: `亲爱的导演，请关掉手机屏幕。
刚才那一瞬间的刺痛，不是因为你的孩子不好，而是因为你内在的剧本被“比较”劫持了。

那个让你恼羞成怒的，是你的“演员”（骄傲，能量层级175）。
在他眼里，孩子不是一个独立的生命，而是你人生舞台上的一个“道具”，是你面子的一部分。当别人的道具金光闪闪，而你的道具在扣脚丫时，“演员”觉得自己的完美形象碎了。他攻击孩子，其实是在掩饰自己内在的“不够好”。

那个让你彻夜难眠的，是你的“懦夫”（恐惧，能量层级100）。
他把人生看作一场残酷的淘汰赛，把那张金奖照片看作是末日审判的判决书。他爱你，但他爱的方式是恐吓：“如果你不优秀，你就活不下去。”

现在，请按下【暂停锚点】。
看着沙发上那个傻乐的孩子。真的看他，而不是透过“奥数金奖”的滤镜看他。
看他放松的姿态，看他纯真的笑容，看他对漫画的专注。
他是一个活生生的人，他有自己的灵魂节奏。

孩子不是你的勋章，也不是你的焦虑垃圾桶。
如果你是一棵苹果树，你为什么要因为隔壁的松树长得高而感到羞耻呢？
比较，是快乐的小偷，也是亲子关系的杀手。

请邀请“庆祝者”（喜悦，能量层级540）登场。
庆祝者懂得欣赏万物的“本然”。
他不需要孩子成为“第一名”才去庆祝。他庆祝，是因为孩子“存在”。
也许他不擅长奥数，但他可能善良、幽默、画画很好，或者仅仅是有一个健康的身体。
每一个生命都有自己独特的光谱。当你停止用别人的标准来裁剪你的孩子，你才能开始真正地“看见”他。

在这个焦虑的世界里，做一个能够欣赏“普通”孩子的父母，本身就是一种英雄主义。
去庆祝他的独特吧。每一朵花都有自己的花期，有的在春天开，有的在冬天开，有的——也许永远不开花，但他会长成一棵参天大树。`
    },
    creativeOption: {
      id: "celebrator_choice",
      label: "看见独特（庆祝生命）",
      labelKey: "gameplay.options.parent_04.creative",
      archetype: "庆祝者",
      visualEffect: "indigo",
      followUp: [
        {
          type: "narrator",
          text: "你放下了手机，深吸一口气，把那股酸溜溜的嫉妒和焦虑呼了出去。你告诉自己：那是别人家的剧本，我有我的剧本。",
          textKey: "gameplay.dialogues.parent_04.creative.1"
        },
        {
          type: "narrator",
          text: "你走到客厅，看着正在傻笑的孩子，不仅没有生气，反而被他的快乐感染，嘴角上扬。",
          textKey: "gameplay.dialogues.parent_04.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（坐到他身边，好奇地）看什么呢笑这么开心？给我也讲讲？",
          textKey: "gameplay.dialogues.parent_04.creative.3"
        },
        {
          type: "narrator",
          text: "孩子惊讶地看了你一眼，然后兴致勃勃地给你讲起了漫画里的笑话。你们一起大笑。那一刻，家里充满了松弛和喜悦。",
          textKey: "gameplay.dialogues.parent_04.creative.4"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（摸摸他的头，真诚地）儿子/女儿，虽然你没拿金奖，但我发现你真的很有幽默感，而且特别能感染人。这也是一种了不起的天赋啊。",
          textKey: "gameplay.dialogues.parent_04.creative.5"
        },
        {
          type: "success",
          text: "你没有让“别人家的孩子”成为你们之间的第三者。你庆祝了孩子独特的生命力。在这个充满比较的世界里，你的肯定，成了孩子内心最坚固的铠甲。",
          textKey: "gameplay.dialogues.parent_04.creative.6"
        }
      ]
    }
  }
};

// 25. 青春期顶嘴 (Parent 05)
export const parentAdolescentRebellionScript: ScenarioScript = {
  id: "parent_05",
  title: "青春期的闭门羹",
  titleKey: "gameplay.sceneTitles.parent_05",
  sceneImage: "/scenarios/parent_05.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "气温骤降的早晨，你看着孩子单薄的裤腿，忍不住多唠叨了几句。",
      textKey: "gameplay.dialogues.parent_05.opening.1"
    },
    {
      type: "npc",
      speaker: "你",
      speakerKey: "gameplay.characters.you",
      text: "把秋裤穿上！外面零下几度了，老了腿疼有你受的！",
      textKey: "gameplay.dialogues.parent_05.opening.2"
    },
    {
      type: "narrator",
      text: "孩子突然像个被点燃的火药桶，猛地转身，眼神里充满了厌烦和愤怒。",
      textKey: "gameplay.dialogues.parent_05.opening.3"
    },
    {
      type: "npc",
      speaker: "孩子",
      speakerKey: "gameplay.characters.child",
      text: "你有完没完啊！烦不烦！我的事不用你管！别总是监视我！",
      textKey: "gameplay.dialogues.parent_05.opening.4"
    },
    {
      type: "narrator",
      text: "“砰”的一声巨响，房门在你面前重重摔上，震得墙灰似乎都掉了下来。你被关在了门外，手里还拿着那条秋裤。",
      textKey: "gameplay.dialogues.parent_05.opening.5"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "victim_choice",
        label: "心寒哭泣（情感勒索）",
        labelKey: "gameplay.options.parent_05.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "那一瞬间，你的心凉透了。眼泪不受控制地涌出来。",
            textKey: "gameplay.dialogues.parent_05.survival.victim.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（对着门哭诉）我辛辛苦苦把你养这么大，关心你还有错了？你居然这样对我……真是养了个白眼狼！",
            textKey: "gameplay.dialogues.parent_05.survival.victim.2"
          },
          {
            type: "narrator",
            text: "你陷入了深深的自我怜悯，觉得自己是世界上最委屈的父母。你用眼泪制造内疚感，但门后的孩子只会觉得更窒息，逃得更远。",
            textKey: "gameplay.dialogues.parent_05.survival.victim.3"
          },
          {
            type: "failure",
            text: "你把孩子的独立宣言解读成了对你的抛弃。你试图用“痛苦”来挽留关系，结果只留下了一地破碎的情感。",
            textKey: "gameplay.dialogues.parent_05.survival.victim.4"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "权威压制（以暴制暴）",
        labelKey: "gameplay.options.parent_05.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "被摔门的那一刻，你的权威受到了前所未有的挑衅。血往上涌。",
            textKey: "gameplay.dialogues.parent_05.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（疯狂砸门）反了你了！敢摔门？这是我家！你吃我的住我的，还敢跟我横？给我滚出来道歉！",
            textKey: "gameplay.dialogues.parent_05.survival.tyrant.2"
          },
          {
            type: "narrator",
            text: "你试图用更高的音量和更强的掌控力来压服孩子。门没开，但你们心里的隔阂已经变成了鸿沟。",
            textKey: "gameplay.dialogues.parent_05.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "你赢了“谁是家长”的争论，但输掉了孩子的心。青春期的孩子，你越压，反弹越强。",
            textKey: "gameplay.dialogues.parent_05.survival.tyrant.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：被推开，是父母的宿命",
      titleKey: "gameplay.directorNote.parent_05.title",
      contentKey: "gameplay.directorNote.parent_05.content",
      content: `亲爱的导演，那一记摔门声，确实很痛。它像一记耳光，打在了你作为父母的尊严和爱心上。

此时，你的“求生剧组”会把这解读为一场针对你个人的攻击。
“受害者”（悲伤，能量层级75）会哭泣：“他不爱我了，我的付出都喂了狗。”
“暴君”（愤怒，能量层级150）会咆哮：“他想造反，我必须镇压。”
这两个角色都犯了一个核心错误：他们把孩子的行为【个人化】了。他们认为那是针对“我”的。

请按下【暂停锚点】。深呼吸。看着那扇紧闭的门。
这一幕，其实不是关于你。
这是关于一只正在试图起飞的小鸟，在笨拙地练习如何离开巢穴。
青春期的本质，就是“分离”。为了成为一个独立的个体，他必须在心理上“杀死”父母。
那句“烦不烦”，翻译过来其实是：“我想自己做决定，哪怕那个决定是错的（比如挨冻）。”
那个摔门，翻译过来其实是：“我需要一个属于我自己的空间，请退后。”

这种推开，虽然粗暴，却是成长的必然。如果他一直粘着你，那才是不正常的。
作为导演，你需要调用“智者”（理智，能量层级400）的视角。
智者明白：**大脑的前额叶（负责情绪控制）在青春期正在重组，此时的孩子就是一个行走的炸药包。**
他的失控是生理性的，不是道德性的。

所以，不要去砸门，也不要在门口哭。
做一个稳如泰山的基地。
允许他有情绪，允许他推开你。
当你知道这是他成长的必经之路时，你就不再受伤，也不再攻击。
你就站在那里，稳定地守望着。告诉他：“门在那里，你想关就关。但我一直在这里，等你愿意出来的时候，热汤也在这里。”
被推开而不倒下，这就是青春期父母最伟大的爱。`
    },
    creativeOption: {
      id: "sage_choice",
      label: "尊重边界（理智抽离）",
      labelKey: "gameplay.options.parent_05.creative",
      archetype: "智者",
      visualEffect: "blue",
      followUp: [
        {
          type: "narrator",
          text: "你举在半空中想砸门的手停住了。你深吸一口气，告诉自己：“这不是针对我，这是他的大脑在经历风暴。”",
          textKey: "gameplay.dialogues.parent_05.creative.1"
        },
        {
          type: "narrator",
          text: "你没有大喊大叫，也没有哭泣。你只是隔着门，用平静且稳定的声音说了一句。",
          textKey: "gameplay.dialogues.parent_05.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "看来你现在情绪很激动，需要一点独处的空间。我尊重你的感受。我们晚点冷静了再谈。",
          textKey: "gameplay.dialogues.parent_05.creative.3"
        },
        {
          type: "narrator",
          text: "说完，你转身离开，去做自己的事，不再纠结于那条没穿的秋裤。哪怕很担心他冷，你也选择了尊重他的选择权。",
          textKey: "gameplay.dialogues.parent_05.creative.4"
        },
        {
          type: "npc",
          speaker: "孩子",
          speakerKey: "gameplay.characters.child",
          text: "（晚饭时，有些别扭地走出来）……那个，今天早上我态度不好。其实我是因为昨晚没睡好。",
          textKey: "gameplay.dialogues.parent_05.creative.5"
        },
        {
          type: "success",
          text: "因为你没有把冲突升级，给了他冷静的空间，他反而有了自我反思的机会。你用理智和尊重，保护了亲子关系的连接，也让他学会了如何为自己的情绪负责。",
          textKey: "gameplay.dialogues.parent_05.creative.6"
        }
      ]
    }
  }
};

// 26. 孩子撒谎 (Parent 06)
export const parentChildLyingScript: ScenarioScript = {
  id: "parent_06",
  title: "谎言的试金石",
  titleKey: "gameplay.sceneTitles.parent_06",
  sceneImage: "/scenarios/parent_06.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "你在收拾书包时，意外发现了那张不及格的数学考卷，被揉成一团塞在角落里。或者，你发现微信钱包里少了两百块钱，记录显示充值给了游戏。",
      textKey: "gameplay.dialogues.parent_06.opening.1"
    },
    {
      type: "npc",
      speaker: "你",
      speakerKey: "gameplay.characters.you",
      text: "（拿着证据）这是怎么回事？",
      textKey: "gameplay.dialogues.parent_06.opening.2"
    },
    {
      type: "npc",
      speaker: "孩子",
      speakerKey: "gameplay.characters.child",
      text: "（眼神闪躲，脖子一梗）我不知道！不是我干的！可能是……可能是系统出错了！",
      textKey: "gameplay.dialogues.parent_06.opening.3"
    },
    {
      type: "narrator",
      text: "面对确凿的证据，孩子竟然还在信誓旦旦地撒谎。那一刻，比“犯错”更让你愤怒和寒心的，是“欺骗”。",
      textKey: "gameplay.dialogues.parent_06.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "coward_choice",
        label: "道德审判（灾难化）",
        labelKey: "gameplay.options.parent_06.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "恐惧瞬间击中了你的神经。你把这次撒谎看作是孩子品行败坏的开始。",
            textKey: "gameplay.dialogues.parent_06.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "你现在就敢撒谎偷钱，长大还得了？小时偷针，大时偷金！你以后是不是想进监狱？",
            textKey: "gameplay.dialogues.parent_06.survival.coward.2"
          },
          {
            type: "narrator",
            text: "你上升到了道德高度，对孩子的人格进行了毁灭性的审判。孩子被贴上了“坏孩子”的标签，眼神变得更加惊恐和封闭。",
            textKey: "gameplay.dialogues.parent_06.survival.coward.3"
          },
          {
            type: "failure",
            text: "恐惧让你把孩子推向了对立面。为了防御你的审判，他以后只会把谎撒得更圆，或者藏得更深。",
            textKey: "gameplay.dialogues.parent_06.survival.coward.4"
          }
        ]
      },
      {
        id: "sinner_choice",
        label: "自我攻击（内疚自责）",
        labelKey: "gameplay.options.parent_06.sinner",
        archetype: "罪人",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你感到一阵深深的挫败感，觉得这是你教育的彻底失败。",
            textKey: "gameplay.dialogues.parent_06.survival.sinner.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（瘫坐在椅子上，掩面叹息）是我没教好你……我是个失败的父母，才让你变成了这样的人。",
            textKey: "gameplay.dialogues.parent_06.survival.sinner.2"
          },
          {
            type: "narrator",
            text: "你沉浸在自己的内疚中，这种沉重的低气压让孩子感到窒息和不知所措。他不仅背负了错误的压力，还背负了让父母痛苦的罪恶感。",
            textKey: "gameplay.dialogues.parent_06.survival.sinner.3"
          },
          {
            type: "failure",
            text: "你在用受苦来“赎罪”，但这并没有解决孩子面临的真实问题（成绩或游戏瘾），反而增加了巨大的心理负担。",
            textKey: "gameplay.dialogues.parent_06.survival.sinner.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：真相需要一个安全的着陆点",
      titleKey: "gameplay.directorNote.parent_06.title",
      contentKey: "gameplay.directorNote.parent_06.content",
      content: `亲爱的导演，面对孩子的谎言，我们本能的反应往往是“愤怒”或“失望”。
我们觉得被背叛了：“我那么信任你，你居然骗我？”

这时，你的“求生剧组”开始编造恐怖故事。
“懦夫”（恐惧，能量层级100）告诉你：“这就是品德问题！如果不狠狠管教，他将来会成为罪犯！”
“罪人”（内疚，能量层级30）告诉你：“是你无能，你养出了一个骗子。”

请按下【暂停锚点】。深呼吸。
让我们透过谎言的迷雾，看清背后的真相：**人为什么会撒谎？**
无论是大人还是孩子，撒谎的动机通常只有一个——**恐惧**。
恐惧后果，恐惧惩罚，恐惧让你失望，恐惧失去爱。
当孩子看着你那张即将爆发的脸，他小小的“求生剧组”也启动了。他的“隐形人”想通过掩盖事实来躲避审判。
正如书中所说：“撒谎是求生的本能。如果真相是安全的，没人愿意撒谎。”

如果你此时选择审判（Coward）或自责（Sinner），你就在证实他的恐惧：“看吧，说实话果然会带来灾难。”
那样，你也许能逼问出这次的真相，但你将永远失去听到下一次真相的机会。

请邀请“疗愈者”（爱，能量层级500）登场。
疗愈者明白：**如果你想听到真话，你必须先构建一个能承载真话的安全空间。**
你需要让孩子知道：错误是可以被接纳的，问题是可以共同解决的，而我们的连接是不会因为错误而断裂的。
你的目标不是“赢过”孩子（拆穿他），而是“赢得”孩子（让他信任你）。

试着把重点从“你为什么撒谎（审判过去）”转移到“你遇到了什么困难（解决未来）”。
告诉他：“无论发生了什么，只要你说实话，我们一起面对。”
当真相有了安全的着陆点，谎言就不再有存在的必要。`
    },
    creativeOption: {
      id: "healer_choice",
      label: "构建安全（接纳与解决）",
      labelKey: "gameplay.options.parent_06.creative",
      archetype: "疗愈者",
      visualEffect: "indigo",
      followUp: [
        {
          type: "narrator",
          text: "你没有发火，也没有揭穿他的谎言。你深吸一口气，调整了自己的能量，让自己从“法官”变成了“盟友”。",
          textKey: "gameplay.dialogues.parent_06.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（蹲下来，握住孩子的手，眼神平静）孩子，看着我的眼睛。无论你做了什么——考砸了也好，花了钱也好，那都是可以解决的问题。",
          textKey: "gameplay.dialogues.parent_06.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "但我最在乎的是你的安全感。我向你保证，如果你告诉我实话，我绝不打骂你。我想知道你遇到了什么困难，我们一起想办法。",
          textKey: "gameplay.dialogues.parent_06.creative.3"
        },
        {
          type: "narrator",
          text: "孩子紧绷的身体松懈了下来，“不说实话会被打死”的恐惧消散了。他的眼泪流了下来。",
          textKey: "gameplay.dialogues.parent_06.creative.4"
        },
        {
          type: "npc",
          speaker: "孩子",
          speakerKey: "gameplay.characters.child",
          text: "……我不敢说。我怕你生气。其实我是因为那关怎么都过不去，同学都笑话我……",
          textKey: "gameplay.dialogues.parent_06.creative.5"
        },
        {
          type: "success",
          text: "你不仅得到了真相，更重要的是，你收获了信任。你们开始讨论如何控制游戏花费或补习数学，而不是纠缠于“品德”。因为安全，所以诚实。",
          textKey: "gameplay.dialogues.parent_06.creative.6"
        }
      ]
    }
  }
};

// 27. 挑食/不吃饭 (Parent 07)
export const parentPickyEaterScript: ScenarioScript = {
  id: "parent_07",
  title: "餐桌上的战争",
  titleKey: "gameplay.sceneTitles.parent_07",
  sceneImage: "/scenarios/parent_07.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "为了让孩子摄入均衡的营养，你在厨房忙碌了两小时，精心制作了一份包含了五种颜色的营养晚餐。",
      textKey: "gameplay.dialogues.parent_07.opening.1"
    },
    {
      type: "narrator",
      text: "满怀期待地端上桌，孩子却只尝了一口，就一脸嫌弃地把勺子扔回碗里。",
      textKey: "gameplay.dialogues.parent_07.opening.2"
    },
    {
      type: "npc",
      speaker: "孩子",
      speakerKey: "gameplay.characters.child",
      text: "呸！好难吃！我不吃这个！我要吃饼干！我要喝酸奶！",
      textKey: "gameplay.dialogues.parent_07.opening.3"
    },
    {
      type: "narrator",
      text: "看着那碗被推开的心血，你感觉被推开的不仅仅是饭，还有你的爱。挫败感和怒火交织在一起。",
      textKey: "gameplay.dialogues.parent_07.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "victim_choice",
        label: "委屈控诉（道德绑架）",
        labelKey: "gameplay.options.parent_07.victim",
        archetype: "受害者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你的眼圈瞬间红了，觉得自己的一片丹心照了沟渠。",
            textKey: "gameplay.dialogues.parent_07.survival.victim.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（带着哭腔）妈妈/爸爸在厨房站了两小时腿都肿了，就为了给你做顿饭，你对得起我吗？你知道这些有机蔬菜多贵吗？",
            textKey: "gameplay.dialogues.parent_07.survival.victim.2"
          },
          {
            type: "narrator",
            text: "你把吃饭变成了沉重的恩情债。孩子或许会勉强吃下几口，但每一口都伴随着罪恶感，这顿饭变得难以下咽。",
            textKey: "gameplay.dialogues.parent_07.survival.victim.3"
          },
          {
            type: "failure",
            text: "你把“食物”和“爱”混为一谈。孩子学会了吃饭是为了讨好父母，这往往是未来饮食障碍的心理根源。",
            textKey: "gameplay.dialogues.parent_07.survival.victim.4"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "强行喂饭（权力控制）",
        labelKey: "gameplay.options.parent_07.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "被拒绝的愤怒让你失去了耐心，你决定动用家长的权威。",
            textKey: "gameplay.dialogues.parent_07.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（拍桌子）给我坐下！不吃完不许下桌！小小年纪还反了你了，今天你不吃也得吃！",
            textKey: "gameplay.dialogues.parent_07.survival.tyrant.2"
          },
          {
            type: "narrator",
            text: "你强行把勺子塞进孩子嘴里，或者厉声呵斥。孩子一边哭一边吞咽，餐桌变成了刑场。",
            textKey: "gameplay.dialogues.parent_07.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "你赢得了这场关于“进食量”的战役，但输掉了孩子对食物的兴趣。从此吃饭对他来说，就意味着痛苦和控制。",
            textKey: "gameplay.dialogues.parent_07.survival.tyrant.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：把饥饿感还给孩子",
      titleKey: "gameplay.directorNote.parent_07.title",
      contentKey: "gameplay.directorNote.parent_07.content",
      content: `亲爱的导演，餐桌是最容易让人把“爱”和“控制”混淆的地方。
当孩子拒绝那碗饭时，你的“求生剧组”为什么反应这么大？

“受害者”（悲伤，能量层级75）觉得这是一种拒绝。他内心的独白是：“我不辛苦吗？我不值得被感激吗？他不吃就是不爱我。”于是，饭变成了用来勒索情感的筹码。
“暴君”（愤怒，能量层级150）觉得这是一种失控。他内心的独白是：“我是为了你好！如果你连吃饭都不听我的，那我还有什么权威？”于是，饭变成了测试服从度的工具。
甚至还有一个没登场的“懦夫”（恐惧，能量层级100），他在旁边嘀咕：“万一他饿坏了怎么办？万一营养不良长不高怎么办？”

请按下【暂停锚点】。看看眼前这碗饭。
它只是一碗饭。它不是你价值的证明，也不是爱的试金石。
吃饭，是人类的本能。没有哪个健康的孩子会把自己饿死。
但是，没有什么比一个焦虑、强迫、苦情的喂食者，更能破坏胃口的了。
当你把吃饭变成任务、战场或道德法庭时，你就剥夺了孩子享受食物的本能乐趣。

请邀请“实干家”（意愿，能量层级310）登场。
实干家明白一个最简单的生理学原理：**饥饿是最好的厨师。**
你需要做的，不是强迫，而是制定规则并从容执行。
将吃饭的责任（Responsibility）还给孩子——身体是他的，饿不饿他最清楚。
将吃饭的边界（Boundary）守住——不吃正餐就没有零食，这是家庭的规则。

做一个“温和而坚定”的守门员，而不是一个“歇斯底里”的推销员。
允许他不吃，允许他饿。
当他体验到真实的饥饿感（自然结果）时，下一顿饭，他自然会拿起勺子。
把控制权交还给身体，把快乐交还给餐桌。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "温和坚定（责任归还）",
      labelKey: "gameplay.options.parent_07.creative",
      archetype: "实干家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你看着孩子抗拒的样子，压下了心中的不悦和焦虑。你意识到，这是他的身体，不是你的。",
          textKey: "gameplay.dialogues.parent_07.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（平静地收起碗筷）好的，看来你现在不饿，或者不想吃这个。没关系。",
          textKey: "gameplay.dialogues.parent_07.creative.2"
        },
        {
          type: "npc",
          speaker: "孩子",
          speakerKey: "gameplay.characters.child",
          text: "那我能吃饼干吗？",
          textKey: "gameplay.dialogues.parent_07.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（微笑着摇头）不可以哦。我们家的规则是，如果不吃晚饭，那就只能等明天的早饭了。中间没有零食。",
          textKey: "gameplay.dialogues.parent_07.creative.4"
        },
        {
          type: "narrator",
          text: "你没有生气，也没有妥协。孩子试探了几次发现无效后，有些失落地离开了餐桌。那一晚，他确实饿了。",
          textKey: "gameplay.dialogues.parent_07.creative.5"
        },
        {
          type: "success",
          text: "第二天早晨，孩子吃得比平时都香。你没有制造冲突，而是让“自然结果”（饥饿）成为了最好的老师。你把吃饭的责任还给了孩子，也解放了焦虑的自己。",
          textKey: "gameplay.dialogues.parent_07.creative.6"
        }
      ]
    }
  }
};

// 28. 分离焦虑 (Parent 08)
export const parentSeparationAnxietyScript: ScenarioScript = {
  id: "parent_08",
  title: "幼儿园门口的生死离别",
  titleKey: "gameplay.sceneTitles.parent_08",
  sceneImage: "/scenarios/parent_08.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "清晨的幼儿园门口，空气中弥漫着离愁别绪。这是送孩子入园的第一周。",
      textKey: "gameplay.dialogues.parent_08.opening.1"
    },
    {
      type: "narrator",
      text: "当你准备松开手交给老师时，孩子突然像个考拉一样死死抱住你的大腿，爆发出撕心裂肺的哭声。",
      textKey: "gameplay.dialogues.parent_08.opening.2"
    },
    {
      type: "npc",
      speaker: "孩子",
      speakerKey: "gameplay.characters.child",
      text: "（满脸泪水，尖叫）妈妈/爸爸不要走！我不要上学！救命啊！",
      textKey: "gameplay.dialogues.parent_08.opening.3"
    },
    {
      type: "narrator",
      text: "那凄惨的叫声引得路人侧目，你的心脏像被一只无形的手狠狠揪住，脚下仿佛灌了铅。",
      textKey: "gameplay.dialogues.parent_08.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "sinner_choice",
        label: "愧疚纠缠（难舍难分）",
        labelKey: "gameplay.options.parent_08.sinner",
        archetype: "罪人",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "看着孩子绝望的眼神，深深的罪恶感将你淹没。你觉得自己在做一件极其残忍的事。",
            textKey: "gameplay.dialogues.parent_08.survival.sinner.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（眼圈也红了，蹲下来抱着孩子一起哭）对不起宝贝，妈妈/爸爸也不想离开你……再抱五分钟，就五分钟。",
            textKey: "gameplay.dialogues.parent_08.survival.sinner.2"
          },
          {
            type: "narrator",
            text: "你在门口上演了十八相送，一步三回头。你的犹豫给了孩子错误的信号：这里真的很危险，连妈妈都舍不得丢下我。",
            textKey: "gameplay.dialogues.parent_08.survival.sinner.3"
          },
          {
            type: "failure",
            text: "你的愧疚感变成了孩子焦虑的燃料。分离过程被无限拉长，每一次拉扯都是对双方的折磨。",
            textKey: "gameplay.dialogues.parent_08.survival.sinner.4"
          }
        ]
      },
      {
        id: "coward_choice",
        label: "恐慌监控（灾难联想）",
        labelKey: "gameplay.options.parent_08.coward",
        archetype: "懦夫",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "虽然把孩子推进去了，但你的魂也跟着丢了。恐惧占据了你的大脑。",
            textKey: "gameplay.dialogues.parent_08.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（盯着手机监控APP，自言自语）他怎么坐在角落里？是不是被孤立了？那个小孩是不是推了他一下？他要是尿裤子了不敢说怎么办？",
            textKey: "gameplay.dialogues.parent_08.survival.coward.2"
          },
          {
            type: "narrator",
            text: "你整天魂不守舍，每隔五分钟刷新一次监控，任何风吹草动都能让你脑补出一场霸凌大戏。",
            textKey: "gameplay.dialogues.parent_08.survival.coward.3"
          },
          {
            type: "failure",
            text: "你对孩子没有任何信任，你相信他无法独自面对世界。这种焦虑的能量场，即便隔着屏幕，也会阻碍孩子的独立生长。",
            textKey: "gameplay.dialogues.parent_08.survival.coward.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：有一种爱叫“温柔地推一把”",
      titleKey: "gameplay.directorNote.parent_08.title",
      contentKey: "gameplay.directorNote.parent_08.content",
      content: `亲爱的导演，在这个充满泪水的早晨，请按下【暂停锚点】。

你的心很痛，这说明你很爱他。但此刻，爱需要换一种方式表达。
看看你的“求生剧组”：
“罪人”（内疚，能量层级30）在告诉你：“你是抛弃孩子的坏人。”
“懦夫”（恐惧，能量层级100）在告诉你：“外面的世界是丛林，小羊会被吃掉。”

请记住一个心理学真相：**孩子的焦虑，往往是父母焦虑的镜像。**
孩子是极其敏感的雷达。如果你表现得像是在送他去刑场，那他怎么可能相信那里是乐园？
如果你在门口犹豫不决，这就等于在告诉他：“其实我也不确定这里安不安全。”
你的犹豫，就是他恐慌的来源。

请邀请“探险家”（勇气，能量层级200）登场。
探险家知道：**成长就是不断地分离，不断地去探索新的领地。**
信任孩子的适应力，就像信任种子会发芽。
你需要做的，是给他一颗“定心丸”。这颗定心丸就是你的——**确定性**。

你要传递的信息是：“我知道这很难，但我相信你能行。这里是安全的，而且我会准时回来接你。”
即使你心里也在滴血，表面上也要做一个演技派。
微笑，拥抱，然后果断转身。
你的背影越坚定，孩子心里越踏实。因为他知道，他的“基地”是稳固的。
别回头，哪怕听见哭声。把成长的空间留给他和老师。
相信我，大部分孩子在你转身后的五分钟内，就会被玩具吸引而停止哭泣。`
    },
    creativeOption: {
      id: "explorer_choice",
      label: "坚定放手（信任祝福）",
      labelKey: "gameplay.options.parent_08.creative",
      archetype: "探险家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你深吸一口气，压下心头的酸楚。你知道，这是他社会化探索的第一步，你不能当那个绊脚石。",
          textKey: "gameplay.dialogues.parent_08.creative.1"
        },
        {
          type: "narrator",
          text: "你蹲下来，直视孩子泪汪汪的眼睛，脸上绽放出一个灿烂的、充满信心的笑容。",
          textKey: "gameplay.dialogues.parent_08.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（语气轻快且笃定）宝贝，我知道你有点舍不得。但幼儿园里有很多好玩的探险在等着你。爸爸/妈妈要去工作了，那是我的探险。",
          textKey: "gameplay.dialogues.parent_08.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "我们做一个约定：时针指到5的时候，我一定会出现在这里。现在，给我一个最勇敢的击掌！",
          textKey: "gameplay.dialogues.parent_08.creative.4"
        },
        {
          type: "narrator",
          text: "你们完成了一个充满仪式感的告别。你把他交给老师，挥挥手，果断地转身离开，没有回头。",
          textKey: "gameplay.dialogues.parent_08.creative.5"
        },
        {
          type: "success",
          text: "你的坚定给了孩子安全感。他虽然哭了两声，但看到你没有犹豫，很快便接受了现实，被老师带进了教室。你用勇气，为他开启了独立探索世界的大门。",
          textKey: "gameplay.dialogues.parent_08.creative.6"
        }
      ]
    }
  }
};

// 29. 兴趣班拉锯战 (Parent 09)
export const parentInterestClassScript: ScenarioScript = {
  id: "parent_09",
  title: "兴趣班的拉锯战",
  titleKey: "gameplay.sceneTitles.parent_09",
  sceneImage: "/scenarios/parent_09.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "周末的午后，昂贵的钢琴在客厅里闪着冷光。原本应该是享受音乐的时间，现在却成了家里的“至暗时刻”。",
      textKey: "gameplay.dialogues.parent_09.opening.1"
    },
    {
      type: "narrator",
      text: "当初哭着喊着要学钢琴的是孩子，现在每天为了练琴鸡飞狗跳的也是他。你看着每小时好几百块的账单，再看着孩子一脸的不情愿。",
      textKey: "gameplay.dialogues.parent_09.opening.2"
    },
    {
      type: "npc",
      speaker: "孩子",
      speakerKey: "gameplay.characters.child",
      text: "（胡乱敲了几下琴键，发出刺耳的噪音）我不想练了！我讨厌钢琴！我要出去玩！",
      textKey: "gameplay.dialogues.parent_09.opening.3"
    },
    {
      type: "narrator",
      text: "那噪音像锯子一样锯着你的神经。你的耐心条已经见底。",
      textKey: "gameplay.dialogues.parent_09.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "performer_choice",
        label: "虚荣面子（强行坚持）",
        labelKey: "gameplay.options.parent_09.performer",
        archetype: "演员",
        visualEffect: "yellow",
        followUp: [
          {
            type: "narrator",
            text: "你脑海里浮现出隔壁邻居孩子考级通过时，邻居脸上得意的表情。你绝不能输。",
            textKey: "gameplay.dialogues.parent_09.survival.performer.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（严厉地）我们家字典里没有“半途而废”这四个字！当初是你自己选的，跪着也要弹完！你是想让大家看笑话吗？",
            textKey: "gameplay.dialogues.parent_09.survival.performer.2"
          },
          {
            type: "narrator",
            text: "你把孩子的兴趣班当成了自己的面子工程。你逼着他为了你的虚荣心而坚持，而不是为了音乐。",
            textKey: "gameplay.dialogues.parent_09.survival.performer.3"
          },
          {
            type: "failure",
            text: "孩子学会了“坚持”的形式，却丢失了“热爱”的内核。钢琴成了他童年的噩梦，以后恐怕再也不会碰了。",
            textKey: "gameplay.dialogues.parent_09.survival.performer.4"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "严厉监工（痛苦逼迫）",
        labelKey: "gameplay.options.parent_09.tyrant",
        archetype: "暴君",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "想着哗哗流走的学费，你怒火中烧，化身为最严厉的监工。",
            textKey: "gameplay.dialogues.parent_09.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（拿把椅子坐在旁边死死盯着）又错一个音！重来！今天不弹满一小时谁也别想吃饭！",
            textKey: "gameplay.dialogues.parent_09.survival.tyrant.2"
          },
          {
            type: "narrator",
            text: "你把艺术变成了一种苦役刑罚。每一次指责都像鞭子一样抽在孩子心上。",
            textKey: "gameplay.dialogues.parent_09.survival.tyrant.3"
          },
          {
            type: "failure",
            text: "你在培养一个钢琴家，还是在培养一个仇人？琴技也许进步了，但亲子关系却破碎了。这笔交易真的划算吗？",
            textKey: "gameplay.dialogues.parent_09.survival.tyrant.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：如果不爱，坚持就是折磨",
      titleKey: "gameplay.directorNote.parent_09.title",
      contentKey: "gameplay.directorNote.parent_09.content",
      content: `亲爱的导演，听听这琴声，里面有音乐吗？还是只有愤怒和反抗？
这一刻，你可能被“沉没成本”绑架了。

看看你的“求生剧组”：
“演员”（骄傲，能量层级175）在乎的是那个“培养出钢琴十级孩子”的光环。他觉得如果现在放弃，就是承认自己教育失败，就是丢面子。
“暴君”（愤怒，能量层级150）在乎的是投入产出比。“老子花了那么多钱，你居然敢不学？”他试图用控制来挽回损失。
但是，所谓的“坚持”，如果建立在痛苦和厌恶之上，那就不是美德，而是执念。

请按下【暂停锚点】。闭上眼睛，忘掉那架钢琴，忘掉那些学费。
回到初衷：我们让孩子学艺术，是为了什么？
是为了让他拥有感知美的能力，拥有一生的陪伴？还是为了让他恨上音乐？
真正的天赋不需要逼，只需要唤醒。如果钢琴已经成了亲子关系的杀手，那这首曲子不弹也罢。

请邀请“智者”（理智，能量层级400）登场。
智者拥有一种分辨的智慧：**分辨什么是“瓶颈期”，什么是“死胡同”。**
如果孩子是因为遇到了难点而畏难，这时候需要的是陪伴和拆解困难，而不是逼迫。
如果孩子是真的对音乐毫无感觉，甚至感到痛苦，那么及时止损就是最大的智慧。

即使是“半途而废”，也是一种宝贵的体验——它让孩子知道了“我不喜欢什么”。这也是一种自我认知。
与其在一个他不擅长也不喜欢的领域里互相折磨，不如放手让他去探索别的。
也许他的天赋在画笔上，在足球场上，或者在编程代码里。
导演，请把目光从琴键上移开，看向那个活生生的人。若音乐不能滋养灵魂，那就换一种养分。`
    },
    creativeOption: {
      id: "sage_choice",
      label: "理智观察（甄别天赋）",
      labelKey: "gameplay.options.parent_09.creative",
      archetype: "智者",
      visualEffect: "blue",
      followUp: [
        {
          type: "narrator",
          text: "你没有发火，也没有立刻逼他继续。你盖上了琴盖，那个令人生厌的噪音终于停止了。",
          textKey: "gameplay.dialogues.parent_09.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（平静地）看来今天这琴是练不下去了。我们都冷静一下。来，喝杯水，我们聊聊。",
          textKey: "gameplay.dialogues.parent_09.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "你是觉得这首曲子太难了不想练？还是真的觉得弹钢琴这件事本身就很痛苦，完全没意思？",
          textKey: "gameplay.dialogues.parent_09.creative.3"
        },
        {
          type: "narrator",
          text: "孩子见你态度转变，也松懈下来，开始吐露真言。也许是太难了需要帮助，也许是真的不喜欢。",
          textKey: "gameplay.dialogues.parent_09.creative.4"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "如果是太难，我陪你一起把这一小节练好。如果是真的不喜欢……那我们把这学期上完，如果你还是不想学，我们就暂停，去试试别的。我不强求。",
          textKey: "gameplay.dialogues.parent_09.creative.5"
        },
        {
          type: "success",
          text: "你用理智化解了对抗。你不再为了“坚持”而坚持，而是为了“成长”而选择。允许放弃，有时候比逼迫坚持更需要智慧。孩子眼里的光，又回来了。",
          textKey: "gameplay.dialogues.parent_09.creative.6"
        }
      ]
    }
  }
};

// 30. 工作忙没空陪 (Parent 10)
export const parentBusyWorkScript: ScenarioScript = {
  id: "parent_10",
  title: "缺席的陪伴",
  titleKey: "gameplay.sceneTitles.parent_10",
  sceneImage: "/scenarios/parent_10.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "这是一个连续加班一周后的周六早晨。你的身体像灌了铅一样沉重，只想在床上躺到地老天荒。",
      textKey: "gameplay.dialogues.parent_10.opening.1"
    },
    {
      type: "npc",
      speaker: "孩子",
      speakerKey: "gameplay.characters.child",
      text: "（兴奋地跳上床，摇晃你的手臂）爸爸/妈妈！别睡了！快起来陪我玩乐高！你说好周末陪我的！",
      textKey: "gameplay.dialogues.parent_10.opening.2"
    },
    {
      type: "narrator",
      text: "你艰难地睁开眼，看着孩子期待的眼神，只觉得头痛欲裂，身体里的每一个细胞都在尖叫着“我要休息”。",
      textKey: "gameplay.dialogues.parent_10.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "sinner_choice",
        label: "愧疚补偿（物质替代）",
        labelKey: "gameplay.options.parent_10.sinner",
        archetype: "罪人",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "看着孩子失望的脸，深深的内疚感击中了你。你觉得自己是个不称职的父母。",
            textKey: "gameplay.dialogues.parent_10.survival.sinner.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（充满歉意地）宝贝对不起，爸爸/妈妈真的太累了……这样吧，我给你买那个最新的超级飞侠玩具好不好？你自己玩会儿？",
            textKey: "gameplay.dialogues.parent_10.survival.sinner.2"
          },
          {
            type: "narrator",
            text: "你试图用昂贵的玩具来赎买你的缺席。孩子虽然拿到了玩具，但眼神里的落寞并没有消失。",
            textKey: "gameplay.dialogues.parent_10.survival.sinner.3"
          },
          {
            type: "failure",
            text: "你教会了孩子：爱可以用物质来衡量。玩具堆满了房间，但他心里的空洞依然无法被填满。愧疚是无用的垃圾。",
            textKey: "gameplay.dialogues.parent_10.survival.sinner.4"
          }
        ]
      },
      {
        id: "bystander_choice",
        label: "敷衍陪伴（身在心不在）",
        labelKey: "gameplay.options.parent_10.bystander",
        archetype: "旁观者",
        visualEffect: "red",
        followUp: [
          {
            type: "narrator",
            text: "你勉强爬起来，像个游魂一样坐在地毯上。身体虽然在这里，但灵魂早已飞到了手机里。",
            textKey: "gameplay.dialogues.parent_10.survival.bystander.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（一边刷短视频一边敷衍）嗯……好……你搭得真好……（其实根本没看）",
            textKey: "gameplay.dialogues.parent_10.survival.bystander.2"
          },
          {
            type: "narrator",
            text: "孩子跟你说话你总要慢半拍才反应。这种冷漠的“僵尸式陪伴”，让孩子感觉到被忽视和隔离。",
            textKey: "gameplay.dialogues.parent_10.survival.bystander.3"
          },
          {
            type: "failure",
            text: "这种低质量的陪伴比不陪更伤人。孩子感受到的是：“手机比我更有趣，我在爸爸/妈妈眼里是透明的。”",
            textKey: "gameplay.dialogues.parent_10.survival.bystander.4"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：哪怕只有15分钟的高光时刻",
      titleKey: "gameplay.directorNote.parent_10.title",
      contentKey: "gameplay.directorNote.parent_10.content",
      content: `亲爱的导演，这一刻你的电量确实见底了。
这很正常，父母不是永动机，你也是血肉之躯。

但是，看看你的“求生剧组”是如何处理这份匮乏的：
“罪人”（内疚，能量层级30）试图用钱解决问题。他觉得既然给不了时间，就给物质。但这就像给一个口渴的人吃馒头，解决不了根本需求。
“旁观者”（冷漠，能量层级50）选择了“伪装在场”。他以为只要肉体在场就是陪伴，殊不知孩子对“心不在焉”的感知力是敏锐的。这种敷衍传递出的信号是：“你很无聊，我不爱跟你玩。”

请按下【暂停锚点】。
承认你的疲惫，接纳你的有限。你不需要做24小时的完美父母。
孩子要的其实并不多——他只需要那个瞬间，你眼里只有他。
**陪伴的质量（Quality）远比时长（Quantity）重要。**
全情投入的15分钟，胜过心不在焉的一整天。

请邀请“实干家”（意愿，能量层级310）登场。
实干家懂得管理能量和预期。
与其拖着疲惫的身体敷衍两小时，不如把手机扔得远远的，像个疯子一样和孩子玩15分钟。
在这15分钟里，你不是那个疲惫的员工，你是孩子的玩伴，是怪兽，是超人。
把自己完全丢进当下的快乐里，这对孩子是滋养，对你自己也是一种从工作压力中的“积极休息”。
然后，诚实地告诉孩子：“现在超人没电了，需要去充电舱睡一会儿。”
这时候，孩子通常会心满意足地放你去休息。因为他的情感杯子，已经被你刚才的高浓度关注注满了。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "全情投入（高质短陪）",
      labelKey: "gameplay.options.parent_10.creative",
      archetype: "实干家",
      visualEffect: "green",
      followUp: [
        {
          type: "narrator",
          text: "你坐起来，用力搓了搓脸，把手机扔到卧室最远的角落，开启了“飞行模式”。",
          textKey: "gameplay.dialogues.parent_10.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（抱住孩子，语气夸张）好！既然你要玩，那我就变身成乐高大魔王！但我现在的能量只能维持20分钟，这20分钟我要把你打败！",
          textKey: "gameplay.dialogues.parent_10.creative.2"
        },
        {
          type: "narrator",
          text: "在这20分钟里，你彻底忘掉了KPI和PPT。你在地上打滚，模仿怪兽的叫声，和孩子笑作一团。你的眼里只有他和手中的积木。",
          textKey: "gameplay.dialogues.parent_10.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（气喘吁吁地躺在地板上）哇，大魔王被打败了！能量耗尽了……但我玩得真开心。宝贝，现在我要去充电舱睡觉了，你可以自己守卫城堡吗？",
          textKey: "gameplay.dialogues.parent_10.creative.4"
        },
        {
          type: "npc",
          speaker: "孩子",
          speakerKey: "gameplay.characters.child",
          text: "（满头大汗，心满意足地点头）好！你去充电吧！我来守卫！",
          textKey: "gameplay.dialogues.parent_10.creative.5"
        },
        {
          type: "success",
          text: "你并没有透支自己，却给了孩子最顶级的滋养。当下的全情投入，让这一刻变成了闪光的记忆。孩子的情感得到了满足，你也安心地获得了休息。",
          textKey: "gameplay.dialogues.parent_10.creative.6"
        }
      ]
    }
  }
};

// ========== 场景四：社交/朋友圈 (Social) ==========

// 31. 借钱两难 (Social 01)
export const socialLendingScript: ScenarioScript = {
  id: "social_01",
  title: "借钱两难",
  titleKey: "gameplay.sceneTitles.social_01",
  sceneImage: "/scenarios/social_01.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "周五晚上，你正准备享受难得的放松时光，手机突然震动了一下。是一个许久未联系的大学同学“老李”发来的微信。",
      textKey: "gameplay.dialogues.social_01.opening.1"
    },
    {
      type: "npc",
      speaker: "老李",
      speakerKey: "gameplay.characters.laoli",
      text: "兄弟/姐妹，最近怎么样？好久不见了，改天聚聚啊！那个……有个事儿实在不好意思开口，但我最近手头有点紧，能不能借我五万块周转一下？下个月底肯定还你！",
      textKey: "gameplay.dialogues.social_01.opening.2"
    },
    {
      type: "narrator",
      text: "看着屏幕上的数字，你心里“咯噔”一下。五万块不是小数目，而且你听说老李最近沉迷投资，风险很大。你本能地不想借，但脑海中浮现出大学时一起打球的情谊，拒绝的话卡在喉咙里。",
      textKey: "gameplay.dialogues.social_01.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "勉强答应（拉不下脸）",
        labelKey: "gameplay.options.social_01.invisible",
        archetype: "隐形人",
        visualEffect: "dark_red", // Energy 20: Shame (Dark Red/Dark)
        followUp: [
          {
            type: "narrator",
            text: "你的胃部一阵痉挛，羞愧感涌上心头——你害怕如果拒绝，会被对方认为“不够朋友”或“小气”。为了维持那个“好人”的形象，你咬着牙转了账。",
            textKey: "gameplay.dialogues.social_01.survival.invisible.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（打字时手在抖）行……转过去了。你记得按时还啊。",
            textKey: "gameplay.dialogues.social_01.survival.invisible.2"
          },
          {
            type: "failure",
            text: "钱转出去的那一刻，你并没有感到轻松，反而像吞了一只苍蝇一样恶心。接下来的一个月，你每天都在焦虑中度过，甚至开始在心里咒骂对方。你为了面子，牺牲了内心的真实，这段关系实际上已经出现了裂痕。",
            textKey: "gameplay.dialogues.social_01.survival.invisible.3"
          }
        ]
      },
      {
        id: "coward_choice",
        label: "编造谎言（恐惧撒谎）",
        labelKey: "gameplay.options.social_01.coward",
        archetype: "懦夫",
        visualEffect: "red", // Energy 100: Fear (Red)
        followUp: [
          {
            type: "narrator",
            text: "恐惧占据了你的大脑。你害怕直接拒绝会得罪人，甚至脑补出对方到处说你坏话的场景。于是，你选择了最安全的策略——撒谎。",
            textKey: "gameplay.dialogues.social_01.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "哎呀老李，真不巧！我刚把钱都投进理财里了，死期，取都取不出来。要不你问问别人？",
            textKey: "gameplay.dialogues.social_01.survival.coward.2"
          },
          {
            type: "failure",
            text: "消息发出去后，你松了一口气，但紧接着又是新的焦虑：万一他知道我刚买了新车怎么办？万一穿帮了怎么办？你用一个谎言暂时逃避了冲突，但你的心变得虚弱且提心吊胆。",
            textKey: "gameplay.dialogues.social_01.survival.coward.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：钱是钱，情是情",
      titleKey: "gameplay.directorNote.social_01.title",
      contentKey: "gameplay.directorNote.social_01.content",
      content: `亲爱的导演，这场戏极其经典，因为它触碰了我们最脆弱的两个神经：金钱与归属感。

当那条借钱的信息弹出时，请观察你的后台，是不是瞬间乱成了一锅粥？
“隐形人”（羞愧，20）在尖叫：“如果我不借，我就不是个好人，我不配被喜欢！”他试图通过自我牺牲（给钱）来购买“被接纳”的安全感。
“懦夫”（恐惧，100）在颤抖：“拒绝是危险的，冲突是可怕的。”他试图通过谎言来构建一道虚假的防线。
请注意，这两个演员都在演同一出戏：匮乏。他们都认为，真实的自己（那个想说“不”的自己）是不被允许存在的，是会导致关系破裂的。

但真相是什么？
正如书中第十一章所说，真正的勇气，不是没有恐惧，而是感受着恐惧，依然选择忠于自己。
如果你为了维持关系而借出这笔钱，这笔钱就不再是“帮助”，而是“贿赂”。你在贿赂对方不要讨厌你。而这份建立在委屈之上的“好意”，终将转化为怨恨，彻底毒害这段关系。

现在，按下【暂停的锚点】。深呼吸。
把“钱”和“情”分开。
真正的友谊，是经得起拒绝的。如果一段关系因为你没有借钱就断裂了，那么请庆祝吧，因为你刚刚以极低的成本（仅仅是一次拒绝），筛选掉了一段虚假的交易关系。

邀请“探险家”（勇气，200）登场吧。
探险家知道，设立边界不是为了推开别人，而是为了保护自己，从而能更长久地与人连接。
当你诚实地表达你的原则时，你其实是在向宇宙宣告：“我尊重我的金钱，我也尊重我们的关系。我不愿意让金钱的纠葛污染了我们的情谊。”
这种坦荡，虽然可能会带来暂时的尴尬，但它散发着一种极高频的能量——那是“自尊”与“真实”的光芒。

试试看，不带评判，不带借口，只是温柔而坚定地站在此刻。`
    },
    creativeOption: {
      id: "explorer_choice",
      label: "真诚拒绝（设立边界）",
      labelKey: "gameplay.options.social_01.creative",
      archetype: "探险家",
      visualEffect: "green", // Energy 200: Courage (Green)
      followUp: [
        {
          type: "narrator",
          text: "你按下了暂停键，感受着心跳的加速，那是恐惧的信号。但你决定不再被它绑架。你深吸一口气，决定在这个时刻，对自己诚实，也对朋友诚实。",
          textKey: "gameplay.dialogues.social_01.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "老李，真的很抱歉听到你遇到困难。我很珍惜咱们的同学情谊，但也正因为如此，我有个原则是不和朋友发生金钱借贷关系，怕伤感情。这点希望你能理解。",
          textKey: "gameplay.dialogues.social_01.creative.2"
        },
        {
          type: "narrator",
          text: "发送的那一刻，你的手微微发抖，但心里却涌起一股前所未有的踏实感。过了许久，老李回了信息。",
          textKey: "gameplay.dialogues.social_01.creative.3"
        },
        {
          type: "npc",
          speaker: "老李",
          speakerKey: "gameplay.characters.laoli",
          text: "……行，理解。也是，谈钱伤感情。我再想想别的办法。",
          textKey: "gameplay.dialogues.social_01.creative.4"
        },
        {
          type: "success",
          text: "天没有塌下来，你也没有被拉黑。你守住了自己的边界，也守住了内心的平静。你发现，真实的拒绝比虚假的迎合，更有力量。",
          textKey: "gameplay.dialogues.social_01.creative.5"
        }
      ]
    }
  }
};

// 32. 炫耀局 (Social 02)
export const socialShowOffScript: ScenarioScript = {
  id: "social_02",
  title: "炫耀局",
  titleKey: "gameplay.sceneTitles.social_02",
  sceneImage: "/scenarios/social_02.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "大学毕业十周年的同学聚会，包厢里灯光璀璨，觥筹交错。空气中弥漫着昂贵的香水味和更加昂贵的“凡尔赛”气息。",
      textKey: "gameplay.dialogues.social_02.opening.1"
    },
    {
      type: "npc",
      speaker: "班长",
      speakerKey: "gameplay.characters.monitor",
      text: "哎呀，其实年薪百万也就那样，主要是税扣得心疼。倒是老王刚换的那辆保时捷是真的帅，落地得两百多万吧？",
      textKey: "gameplay.dialogues.social_02.opening.2"
    },
    {
      type: "narrator",
      text: "话题在豪车、大平层和上市公司期权之间来回跳跃。你低头看了看自己使用了三年的手机，又想了想自己平淡无奇的工作，一种强烈的格格不入感如潮水般袭来。",
      textKey: "gameplay.dialogues.social_02.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "沉默隐身（自惭形秽）",
        labelKey: "gameplay.options.social_02.invisible",
        archetype: "隐形人",
        visualEffect: "dark_red", // Energy 20: Shame (Dark Red/Dark)
        followUp: [
          {
            type: "narrator",
            text: "羞愧感像一块巨石压在你的胸口。你觉得自己是个彻头彻尾的失败者（Loser）。你全程埋头吃菜，祈祷没有任何人注意到你。",
            textKey: "gameplay.dialogues.social_02.survival.invisible.1"
          },
          {
            type: "npc",
            speaker: "老同学",
            speakerKey: "gameplay.characters.classmate",
            text: "哎，你现在在哪高就呢？半天没听你说话。",
            textKey: "gameplay.dialogues.social_02.survival.invisible.2"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "啊……我就瞎混，瞎混……那个，我去个洗手间。",
            textKey: "gameplay.dialogues.social_02.survival.invisible.3"
          },
          {
            type: "failure",
            text: "你狼狈地逃离了包厢，提前退场。回家的路上，巨大的挫败感吞噬了你，你觉得人生无望，甚至不想再去面对第二天的工作。",
            textKey: "gameplay.dialogues.social_02.survival.invisible.4"
          }
        ]
      },
      {
        id: "performer_choice",
        label: "虚荣吹嘘（故作高深）",
        labelKey: "gameplay.options.social_02.performer",
        archetype: "演员",
        visualEffect: "yellow", // Energy 175: Pride (Yellow)
        followUp: [
          {
            type: "narrator",
            text: "为了掩盖内心的卑微，你决定戴上面具。不就是吹牛吗？谁不会？你清了清嗓子，强行插入话题。",
            textKey: "gameplay.dialogues.social_02.survival.performer.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "其实最近我也在看那个盘的房子，不过还是觉得地段稍微偏了点。我们公司最近那个IPO项目，忙得我都顾不上看房。",
            textKey: "gameplay.dialogues.social_02.survival.performer.2"
          },
          {
            type: "failure",
            text: "大家礼貌地附和了几句，眼神中却透着看穿一切的敷衍。聚会结束后，你在深夜的镜子里看着卸下面具的自己，感到了比“隐形人”更深的空虚和自我厌恶。你赢得了一时的面子，却输掉了真实的自己。",
            textKey: "gameplay.dialogues.social_02.survival.performer.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：比较是快乐的小偷",
      titleKey: "gameplay.directorNote.social_02.title",
      contentKey: "gameplay.directorNote.social_02.content",
      content: `亲爱的导演，欢迎来到这出名为“名利场”的大戏。

在这个场景中，灯光师（你的注意力）似乎失控了。它疯狂地打在别人的豪车、名表和头衔上，而将你自己的角落留在了阴影里。
这时候，你的后台立刻冲出了两个最为焦虑的演员。
一位是“隐形人”（羞愧，20），他低着头说：“我不配待在这里，我和他们不是一个世界的人。”他试图通过消失来避免被评判。
另一位是“演员”（骄傲，175），他昂着头说：“我不能输！哪怕是演，我也要演得比他们好。”他试图通过虚假的膨胀来掩盖内在的干瘪。
请看清他们的本质：他们都活在“比较”的幻觉里。他们都相信同一个谎言——“我的价值，取决于我比别人拥有更多。”

现在，请按下【暂停的锚点】。
看着这一屋子喧闹的人。你以为他们在炫耀吗？不，他们其实和你一样，在恐惧。
那些大声谈论金钱的人，往往是内心最害怕匮乏的人。他们需要通过别人的羡慕（镜子的反射），来确认自己是存在的，是安全的。
所以，这是一场集体性的求生表演。

作为清醒的导演，你要如何改写剧本？
请邀请“庆祝者”（喜悦，540）登场。
庆祝者知道一个宇宙秘密：能量是共振的。
当你嫉妒或自卑时，你在向宇宙广播“我没有”的频率。而当你真诚地为别人的成功鼓掌时，你是在通过共振，将那份“丰盛”的能量下载到你自己的生命里。
别人的光，不会让你的光变暗。相反，如果你愿意，它可以照亮你的房间。

试着转换视角：这不是一场比赛，这是一场分享。
接纳你当下的节奏。也许你没有豪车，但你拥有一个能在周末安心读书的下午，拥有一手好厨艺，或者仅仅是一颗能感知微风的心。
当你在这个浮躁的房间里，稳稳地安住在自己的真实之中，不卑不亢地分享你那些“微小而确定的幸福”时，你就是全场能量最高的人。
因为真实，永远比完美更迷人。`
    },
    creativeOption: {
      id: "celebrator_choice",
      label: "真诚庆祝（安住当下）",
      labelKey: "gameplay.options.social_02.creative",
      archetype: "庆祝者",
      visualEffect: "indigo", // Energy 540: Joy (Indigo)
      followUp: [
        {
          type: "narrator",
          text: "你做了一个深呼吸，将那个想逃跑的“隐形人”和想吹牛的“演员”温柔地请下台。你看着那位买了豪车的同学，心中升起真诚的喜悦。",
          textKey: "gameplay.dialogues.social_02.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（举起酒杯，眼神明亮）老王，真心为你高兴！那是你奋斗应得的。来，大家走一个，祝我们都能越来越好！",
          textKey: "gameplay.dialogues.social_02.creative.2"
        },
        {
          type: "narrator",
          text: "你的真诚像一阵清风，吹散了包厢里的攀比味。有人问起你的近况。",
          textKey: "gameplay.dialogues.social_02.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "我呀，工作挺安稳的。最近最大的成就是终于学会了做戚风蛋糕，改天给你们尝尝。虽然没发大财，但日子过得挺有滋味。",
          textKey: "gameplay.dialogues.social_02.creative.4"
        },
        {
          type: "success",
          text: "大家愣了一下，随即露出了今晚最放松的笑容。有人开始聊起自己养的猫，有人吐槽带娃的辛苦。话题从“凡尔赛”变成了“生活流”。你发现，当你接纳了自己的光，你不仅照亮了自己，也温暖了别人。这才是真正的聚会。",
          textKey: "gameplay.dialogues.social_02.creative.5"
        }
      ]
    }
  }
};

// 33. 被好友“鸽”了 (Social 03)
export const socialStoodUpScript: ScenarioScript = {
  id: "social_03",
  title: "被好友“鸽”了",
  titleKey: "gameplay.sceneTitles.social_03",
  sceneImage: "/scenarios/social_03.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "为了今晚的聚餐，你提前一周订好了这家很难预约的网红餐厅，还特意化了全妆，搭配了新买的衣服。你正准备出门，心情像外面的天气一样晴朗。",
      textKey: "gameplay.dialogues.social_03.opening.1"
    },
    {
      type: "narrator",
      text: "突然，手机响了。是好友小A打来的电话。",
      textKey: "gameplay.dialogues.social_03.opening.2"
    },
    {
      type: "npc",
      speaker: "小A",
      speakerKey: "gameplay.characters.friend_a",
      text: "哎呀亲爱的，实在对不起！我这边突然有个临时的急事走不开，今晚可能去不了了……真的不好意思啊！",
      textKey: "gameplay.dialogues.social_03.opening.3"
    },
    {
      type: "narrator",
      text: "挂断电话，看着镜子里精心打扮的自己，你的笑容凝固了。这已经是她第三次临时爽约了。空气中弥漫着尴尬和失望的味道。",
      textKey: "gameplay.dialogues.social_03.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "tyrant_choice",
        label: "愤怒拉黑（觉得被耍）",
        labelKey: "gameplay.options.social_03.tyrant",
        archetype: "暴君",
        visualEffect: "red", // Energy 150: Anger (Red)
        followUp: [
          {
            type: "narrator",
            text: "一股怒火直冲脑门。你觉得自己被轻视、被愚弄了。你无法容忍这种对他人的不尊重。",
            textKey: "gameplay.dialogues.social_03.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（发微信怒吼）你有病吧？第三次了！我的时间不是时间吗？既然不想来以后永远别来了！",
            textKey: "gameplay.dialogues.social_03.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "发完信息，你直接拉黑了对方。虽然发泄了怒火，但你整个晚上都气得手发抖，胃口全无，原本美好的夜晚变成了愤怒的刑场。你赢了争吵，却输了心情。",
            textKey: "gameplay.dialogues.social_03.survival.tyrant.3"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "自怜自艾（觉得不重要）",
        labelKey: "gameplay.options.social_03.victim",
        archetype: "受害者",
        visualEffect: "dark_red", // Energy 75: Grief (Dark Red/Red)
        followUp: [
          {
            type: "narrator",
            text: "你的肩膀垮了下来，眼泪在眼眶里打转。你并没有责怪对方，而是把矛头指向了自己。",
            textKey: "gameplay.dialogues.social_03.survival.victim.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（内心独白）我就知道……如果我是个重要的大人物，她肯定不会这样对我。我不配拥有完美的约会，没人真的在乎我。",
            textKey: "gameplay.dialogues.social_03.survival.victim.2"
          },
          {
            type: "failure",
            text: "你默默地卸了妆，换上睡衣，瘫在沙发上吃泡面。你不仅失去了一顿大餐，更陷入了深深的自我价值怀疑中，觉得自己被整个世界遗弃了。",
            textKey: "gameplay.dialogues.social_03.survival.victim.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：谁掌握着你快乐的遥控器？",
      titleKey: "gameplay.directorNote.social_03.title",
      contentKey: "gameplay.directorNote.social_03.content",
      content: `亲爱的导演，这一幕叫“落空”。

当期待落空时，不仅是今晚的计划被打乱，更是我们的“自我价值感”受到了冲击。
看看你的舞台上发生了什么：
“暴君”（愤怒，150）认为这是对尊严的挑衅。他的潜台词是：“你怎么敢这样对我？我要惩罚你！”他试图通过攻击来找回控制感。
“受害者”（悲伤，75）认为这是对自己价值的否定。他的潜台词是：“因为我不重要，所以你才鸽我。”他通过自我攻击来合理化这份痛苦。

这两位演员，虽然反应截然不同，但都犯了一个共同的错误：他们把快乐的遥控器，交到了对方手里。
因为对方不来，所以我就不能快乐。因为对方失约，所以今晚就必须被毁掉。

现在，请按下【暂停的锚点】。
深呼吸，从情绪的漩涡中抽离出来。
事实是什么？事实仅仅是：对方没来。
故事是什么？故事是：他不尊重我 / 我不重要 / 今晚完蛋了。
痛苦，不来自事实，而来自你给自己讲的那个“故事”。

请邀请“智者”（理智，350-400）登场。
智者拥有“课题分离”的智慧。
对方的失约，可能有急事，也可能是他本身时间管理能力差，甚至就是没礼貌。但这都是“他的课题”，是他的混乱，与你的价值毫无关系。
你的课题是：面对这个既定事实，我如何度过今晚？

你已经化了妆，穿了新衣，订了餐厅。这一切美好都已经准备就绪。
为什么要因为一个人的缺席，就取消这场为你自己准备的盛宴呢？
智者会告诉你：你的快乐是自给自足的。你不需要等待另一个人来为你今晚的快乐盖章。
甚至，这是一次绝佳的“和自己约会”的机会。

拿回遥控器。今晚的主角是你，从来都是你。`
    },
    creativeOption: {
      id: "sage_choice",
      label: "理性独享（课题分离）",
      labelKey: "gameplay.options.social_03.creative",
      archetype: "智者",
      visualEffect: "blue", // Energy 350/400: Reason (Blue)
      followUp: [
        {
          type: "narrator",
          text: "你深吸一口气，切断了那条通往愤怒或悲伤的神经回路。你冷静地分析现状：她来不了是既定事实，但这不代表我的晚上要被毁掉。",
          textKey: "gameplay.dialogues.social_03.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（对着电话平静地说）好的，我知道了，你先忙你的。下次如果还是不能确定，我们可以约得随意一点。",
          textKey: "gameplay.dialogues.social_03.creative.2"
        },
        {
          type: "narrator",
          text: "挂断电话，你看着镜子里的自己，依然光彩照人。你决定按原计划出门。",
          textKey: "gameplay.dialogues.social_03.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（微笑自语）这妆可不能白化。听说那家的黑松露意面很棒，一个人吃两份也不错。",
          textKey: "gameplay.dialogues.social_03.creative.4"
        },
        {
          type: "success",
          text: "你独自享用了一顿丰盛的晚餐，甚至因为没有社交压力而感到格外惬意。服务员送了你一份甜点，你边吃边看书。你意识到，你的快乐不依附于任何人，这种独立的自由感，比任何陪伴都更让你心安。",
          textKey: "gameplay.dialogues.social_03.creative.5"
        }
      ]
    }
  }
};

// 34. 社交媒体焦虑 (Social 04)
export const socialMediaAnxietyScript: ScenarioScript = {
  id: "social_04",
  title: "社交媒体焦虑",
  titleKey: "gameplay.sceneTitles.social_04",
  sceneImage: "/scenarios/social_04.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "深夜11点，你躺在乱糟糟的床上，手里端着吃了一半的泡面。房间里只有手机屏幕发出的幽幽蓝光。",
      textKey: "gameplay.dialogues.social_04.opening.1"
    },
    {
      type: "narrator",
      text: "手指机械地滑动着屏幕。朋友圈里，有人在马尔代夫晒着落日，有人在米其林餐厅庆祝纪念日，还有人刚拿到了融资。",
      textKey: "gameplay.dialogues.social_04.opening.2"
    },
    {
      type: "narrator",
      text: "每一个光鲜亮丽的像素都在刺痛你的神经。对比之下，你看着手里廉价的泡面和这狭窄的出租屋，一种巨大的落差感如黑洞般袭来。",
      textKey: "gameplay.dialogues.social_04.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "victim_choice",
        label: "自怨自艾（命运不公）",
        labelKey: "gameplay.options.social_04.victim",
        archetype: "受害者",
        visualEffect: "dark_red", // Energy 75: Grief (Dark Red/Red)
        followUp: [
          {
            type: "narrator",
            text: "悲伤的情绪淹没了你。你觉得老天对你太不公平了，为什么别人都能活得那么轻松精彩，只有你在泥潭里挣扎？",
            textKey: "gameplay.dialogues.social_04.survival.victim.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（对着屏幕流泪）没意思，真没意思。我就知道我是个废物，这辈子也就这样了。",
            textKey: "gameplay.dialogues.social_04.survival.victim.2"
          },
          {
            type: "failure",
            text: "你越刷越抑郁，却又无法停下。你在这种自我折磨中度过了大半夜，第二天顶着肿眼泡醒来，整个人如同被抽干了精气，对生活更加绝望。",
            textKey: "gameplay.dialogues.social_04.survival.victim.3"
          }
        ]
      },
      {
        id: "addict_choice",
        label: "强迫刷新（寻找平衡）",
        labelKey: "gameplay.options.social_04.addict",
        archetype: "瘾君子",
        visualEffect: "orange", // Energy 125: Desire (Orange)
        followUp: [
          {
            type: "narrator",
            text: "你无法忍受这种落差，急切地想要寻找一些东西来填补空虚。你开始疯狂刷新，试图找到一些不如意的信息来平衡心态，或者疯狂点赞评论以求获得关注。",
            textKey: "gameplay.dialogues.social_04.survival.addict.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（手指飞快滑动）肯定不仅仅是这样……肯定有人过得比我惨……怎么还没人回我评论？再刷五分钟，就五分钟。",
            textKey: "gameplay.dialogues.social_04.survival.addict.2"
          },
          {
            type: "failure",
            text: "多巴胺的渴望让你变成了手机的奴隶。直到凌晨两点，你才在极度的疲惫中昏睡过去。你什么也没得到，除了更深的空虚和更差的皮肤。",
            textKey: "gameplay.dialogues.social_04.survival.addict.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：别用他人的高光，霸凌你的幕后",
      titleKey: "gameplay.directorNote.social_04.title",
      contentKey: "gameplay.directorNote.social_04.content",
      content: `亲爱的导演，这是一场名为“橱窗效应”的现代心理剧。

在这深夜的微光中，两个迷失的灵魂正在争夺控制权：
“受害者”（悲伤，75）沉浸在“我不配”的剧本里。他看着别人的精彩，不仅看到了差距，更将其解读为对自己的判决书。他把手机当成了审判台。
“瘾君子”（欲望，125）则陷入了“我要更多”的陷阱。他以为通过不断的滑动、点赞、寻找刺激，就能填补内心的那个洞。但他不知道，手机屏幕是吃能量的黑洞，越填越空。

现在，请按下【暂停的锚点】。
把手机屏幕锁上。让房间回归黑暗。
在这个瞬间，问自己一个问题：你看到的真的是他们的生活吗？
不，你看到的只是他们精心修剪、加了滤镜、挑选了角度的“高光时刻”（Highlight Reel）。
而你正在做的，是拿自己最真实、最粗糙、甚至最狼狈的“幕后花絮”（Behind the Scenes），去和他们的高光时刻做比较。
这是一场注定失败的比较，是一场对自己残酷的霸凌。

请邀请“疗愈者”（爱，500）来到你的床边。
疗愈者不需要滤镜，他只需要真实。
看看你手里的泡面，感受它的热气。看看你乱糟糟的床，感受它的柔软。
这就是当下，这就是生活。它不完美，但它是真实的，它是属于你的。
那个在马尔代夫发朋友圈的人，可能此刻正在忍受蚊虫叮咬；那个晒恩爱的人，可能刚吵完架。每个人都有自己的幕后花絮，只是没有发出来而已。

疗愈者会温柔地抱住那个焦虑的你，说：“亲爱的，你不需要去任何地方，也不需要成为任何人。你此时此刻的存在，本身就是完整的。”
这一碗泡面，如果是为了照顾饥饿的身体而吃，它就是神圣的。
关掉那个虚幻的橱窗，回到你自己这个温暖的小窝里来。
只有当你开始爱上自己并不完美的幕后花絮时，你才真正活在现实里。`
    },
    creativeOption: {
      id: "healer_choice",
      label: "回归当下（自我关怀）",
      labelKey: "gameplay.options.social_04.creative",
      archetype: "疗愈者",
      visualEffect: "indigo", // Energy 500: Love (Indigo)
      followUp: [
        {
          type: "narrator",
          text: "你意识到自己正在自我霸凌。你做了一个坚定的动作——按下锁屏键，把手机扔到了够不着的地方。",
          textKey: "gameplay.dialogues.social_04.creative.1"
        },
        {
          type: "narrator",
          text: "房间黑了下来，世界安静了。你闭上眼，深吸一口气，闻到了泡面的香味。你重新端起碗，感受着热气扑在脸上的温暖。",
          textKey: "gameplay.dialogues.social_04.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（轻声对自己说）没关系，泡面也很好吃。我很累了，我需要休息。我不需要羡慕任何人，我也值得被爱。",
          textKey: "gameplay.dialogues.social_04.creative.3"
        },
        {
          type: "success",
          text: "你不再关注远方的虚幻，而是拥抱了身边的真实。吃完面，你洗了个热水澡，钻进被窝。那份焦虑消散了，取而代之的是一种对自己身体和心灵的深深怜惜与接纳。今晚，你睡得很香。",
          textKey: "gameplay.dialogues.social_04.creative.4"
        }
      ]
    }
  }
};

// 35. 观点争论 (Social 05)
export const socialDebateScript: ScenarioScript = {
  id: "social_05",
  title: "观点争论",
  titleKey: "gameplay.sceneTitles.social_05",
  sceneImage: "/scenarios/social_05.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "微信群里突然炸开了锅。大家因为这几天的一个社会热点话题吵翻了天，信息一条接一条地弹出，红色的未读消息数瞬间变成了“99+”。",
      textKey: "gameplay.dialogues.social_05.opening.1"
    },
    {
      type: "npc",
      speaker: "激进派群友",
      speakerKey: "gameplay.characters.group_member_a",
      text: "这种人就该判死刑！凡是给他们洗地的都是非蠢即坏！现在的社会风气就是被这帮圣母毁了！",
      textKey: "gameplay.dialogues.social_05.opening.2"
    },
    {
      type: "npc",
      speaker: "理中客群友",
      speakerKey: "gameplay.characters.group_member_b",
      text: "楼上的太极端了吧？法治社会要讲证据。@你，你怎么看？平时你挺有想法的，你来评评理。",
      textKey: "gameplay.dialogues.social_05.opening.3"
    },
    {
      type: "narrator",
      text: "突然被@，你看着屏幕上那些充满情绪色彩的词汇——“蠢货”、“洗地”、“脑残”，心跳不由自主地加速，一种想要表达、想要“纠正”的冲动涌上心头。",
      textKey: "gameplay.dialogues.social_05.opening.4"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "tyrant_choice",
        label: "愤怒回怼（试图骂醒）",
        labelKey: "gameplay.options.social_05.tyrant",
        archetype: "暴君",
        visualEffect: "red", // Energy 150: Anger (Red)
        followUp: [
          {
            type: "narrator",
            text: "你觉得对方简直不可理喻，这种错误的价值观必须被粉碎。你的手指在键盘上飞快敲击，每一个字都带着火药味。",
            textKey: "gameplay.dialogues.social_05.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "不仅是法盲，还缺乏基本的逻辑！你这种言论才是社会毒瘤。多读点书再出来说话吧！",
            textKey: "gameplay.dialogues.social_05.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "群里瞬间爆发了混战，针对你的人身攻击接踵而至。你气得手抖，甚至想摔手机。你花费了两小时去辩论，最后除了满肚子的怒火和被破坏的心情，什么也没改变。对方依然觉得你是傻X。",
            textKey: "gameplay.dialogues.social_05.survival.tyrant.3"
          }
        ]
      },
      {
        id: "performer_choice",
        label: "傲慢说教（秀优越感）",
        labelKey: "gameplay.options.social_05.performer",
        archetype: "演员",
        visualEffect: "yellow", // Energy 175: Pride (Yellow)
        followUp: [
          {
            type: "narrator",
            text: "你轻蔑地一笑，觉得这帮人都太肤浅，看问题看不到本质。是时候展示你高人一等的认知了。",
            textKey: "gameplay.dialogues.social_05.survival.performer.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "其实你们争的都在表层。这个问题本质上是结构性的矛盾，我之前看过一篇深度的论文分析这个现象……（此处省略五百字长篇大论）",
            textKey: "gameplay.dialogues.social_05.survival.performer.2"
          },
          {
            type: "failure",
            text: "群里陷入了短暂的沉默，然后有人回了一句：“装什么大尾巴狼。” 你的长篇大论并没有获得预期的掌声，反而被认为是“掉书袋”和“装逼”。你感到一种被误解的孤傲，愤愤地退出了群聊。",
            textKey: "gameplay.dialogues.social_05.survival.performer.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：争论是为了真理，还是为了“我”？",
      titleKey: "gameplay.directorNote.social_05.title",
      contentKey: "gameplay.directorNote.social_05.content",
      content: `亲爱的导演，网络是一个巨大的、即时的能量检测场。

当你在群里看到不同观点时，请立刻觉察你的内在反应：
“暴君”（愤怒，150）想要消灭异己。他的逻辑是：“你是错的，我是对的，所以你必须闭嘴。”
“演员”（骄傲，175）想要确立地位。他的逻辑是：“你们都看不懂，只有我懂，所以我比你们高级。”
请注意，无论是攻击还是说教，这些行为的动力都不是为了“真理”，而是为了维护那个虚幻的小我（Ego）。小我需要通过“我是对的”来确认自己的存在感。

但真相是：在这个二元对立的世界里，每一个观点都只是盲人摸象中的一只手、一条腿。每一个人的发言，都是他过往经历、认知局限和当下情绪的投射。
试图在群里“骂醒”一个人，就像试图对着镜子里的污点擦拭一样徒劳。你无法改变别人的剧本，你只能决定是否跳进他们的剧本里去演一个配角。

现在，请按下【暂停的锚点】。
深呼吸。问自己：如果我不需要证明自己是对的，我会失去什么吗？
答案是：你什么都不会失去，除了你的焦虑和愤怒。你将获得最大的自由。

请邀请“和平的观察者”（和平，600）登场。
这是一个极高的能量层级。观察者不是冷漠（旁观者，50），而是深度的允许。
他看到每个人的观点背后都有其成因。他看到愤怒背后是恐惧，傲慢背后是自卑。
他允许世界呈现出它混乱的样子，因为他知道，这混乱本身也是一种秩序。
他不介入因果，不卷入漩涡。他像天空看着云卷云舒一样，看着屏幕上的文字生灭。

你可以选择不回复。或者，如果非要回复，发一个微笑，或者一句中性的话。
这不是软弱，这是力量。因为只有内心极度强大的人，才允许别人“误解”自己，才允许别人拥有“错误”的权利。
当你不需要赢得争论时，你就赢得了生活。`
    },
    creativeOption: {
      id: "observer_choice",
      label: "允许存在（如如不动）",
      labelKey: "gameplay.options.social_05.creative",
      archetype: "和平的观察者",
      visualEffect: "violet", // Energy 600: Peace (Violet)
      followUp: [
        {
          type: "narrator",
          text: "你看着屏幕上不断滚动的争吵，就像看着一群孩子在争抢玩具。你深吸一口气，身体向后靠，从那个“必须回应”的紧绷状态中松弛下来。",
          textKey: "gameplay.dialogues.social_05.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（内心独白）每个人都活在自己的剧本里。这是他们的投射，与我无关。我不需要去纠正河流的走向。",
          textKey: "gameplay.dialogues.social_05.creative.2"
        },
        {
          type: "narrator",
          text: "你没有打一个字，甚至没有去反驳那个@你的人。你只是发了一个淡淡的微笑表情包，或者是直接锁屏，放下手机，去给自己倒了一杯水。",
          textKey: "gameplay.dialogues.social_05.creative.3"
        },
        {
          type: "success",
          text: "群里的争吵还在继续，但那股狂躁的能量再也无法穿透你。你站在岸上，看着河水汹涌，内心却是一片宁静的湖泊。你保护了自己的能量，也给予了他人做自己的自由。这就是和平的力量。",
          textKey: "gameplay.dialogues.social_05.creative.4"
        }
      ]
    }
  }
};

// 36. 情绪垃圾桶 (Social 06)
export const socialEmotionalDumpsterScript: ScenarioScript = {
  id: "social_06",
  title: "情绪垃圾桶",
  titleKey: "gameplay.sceneTitles.social_06",
  sceneImage: "/scenarios/social_06.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "晚上九点，你刚准备看会儿书休息一下，电话响了。看到来电显示是那个把你当成“免费心理咨询师”的朋友，你的心里顿时一沉。",
      textKey: "gameplay.dialogues.social_06.opening.1"
    },
    {
      type: "npc",
      speaker: "朋友",
      speakerKey: "gameplay.characters.friend_complainer",
      text: "喂！气死我了！你不知道今天我那个变态老板又干了什么……还有我男朋友，简直是木头……（此处省略十分钟不带喘气的负能量输出）",
      textKey: "gameplay.dialogues.social_06.opening.2"
    },
    {
      type: "narrator",
      text: "电话那头的抱怨像洪水一样倾泻而来，根本没有停下来的意思。你的耳朵发烫，脑袋嗡嗡作响，感觉身体里的能量正在被一根无形的管子迅速抽走。",
      textKey: "gameplay.dialogues.social_06.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "隐忍附和（不敢挂断）",
        labelKey: "gameplay.options.social_06.invisible",
        archetype: "隐形人",
        visualEffect: "dark_red", // Energy 20: Shame (Dark Red/Dark)
        followUp: [
          {
            type: "narrator",
            text: "你感到极度的疲惫，但心里有个声音在说：“如果我挂电话，或者表现出不耐烦，我就不是个好朋友了。”羞耻感让你不敢设立边界。",
            textKey: "gameplay.dialogues.social_06.survival.invisible.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（一边翻白眼一边机械回复）嗯……是吗……太过分了……唉……",
            textKey: "gameplay.dialogues.social_06.survival.invisible.2"
          },
          {
            type: "failure",
            text: "这通电话持续了一个半小时。挂断后，你感觉身体被掏空，瘫在沙发上一动也不想动。你为了做一个“好人”，献祭了自己的能量。最糟糕的是，这种事情下次还会发生。",
            textKey: "gameplay.dialogues.social_06.survival.invisible.3"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "内心怨恨（觉得自己倒霉）",
        labelKey: "gameplay.options.social_06.victim",
        archetype: "受害者",
        visualEffect: "dark_red", // Energy 75: Grief (Dark Red/Red)
        followUp: [
          {
            type: "narrator",
            text: "你一边听，一边在心里疯狂吐槽。你觉得自己就像个垃圾桶，专门装别人的垃圾。你感到委屈极了。",
            textKey: "gameplay.dialogues.social_06.survival.victim.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（内心独白）为什么我总是遇到这种吸血鬼？为什么我就得听这些破事？我的命怎么这么苦，周围全是负能量的人。",
            textKey: "gameplay.dialogues.social_06.survival.victim.2"
          },
          {
            type: "failure",
            text: "虽然你没有明说，但你的怨气已经积累到了顶点。挂断电话后，你心情极差，甚至把气撒在了家人身上。你把自己定义为无法拒绝的受害者，于是你真的就在这种关系里受困了。",
            textKey: "gameplay.dialogues.social_06.survival.victim.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：同理心不是陪葬",
      titleKey: "gameplay.directorNote.social_06.title",
      contentKey: "gameplay.directorNote.social_06.content",
      content: `亲爱的导演，这一幕名为“能量吸血鬼的盛宴”。

在这个场景里，我们常常混淆了“同理心”和“自我牺牲”。
“隐形人”（羞愧，20）不敢挂电话，因为他深信：“如果我拒绝倾听，我就是冷漠的坏人。”他通过牺牲自己的边界，来换取“我是好朋友”的道德标签。
“受害者”（悲伤，75）则沉浸在无力感中，觉得这种被侵犯是无法避免的命运，只能被动承受。

但请按下【暂停的锚点】，深呼吸。
真正的同理心，不是陪着掉进泥坑的人一起在泥里打滚，而是站在岸上，稳稳地递给他一根绳子。
如果你自己都被拖进了泥里（能量耗尽），你还能帮谁呢？
保护好自己的能量，不仅是对自己负责，也是对这段关系负责。因为一个精疲力竭、满腹怨气的倾听者，给不出任何高质量的愛。

请邀请“实干家”（意愿，250/310）登场。
实干家知道，任何健康的系统都需要“边界”。房子需要墙壁，细胞需要细胞膜，人际关系也需要界限。
设立边界不是攻击，而是澄清。
你有权利决定你的时间如何使用。你有权利保护你的情绪空间。
实干家的策略非常务实：
1. **时间限制**：明确告知你能提供多少时间（“我有10分钟”）。这既给了对方宣泄的窗口，也保护了你自己的生活。
2. **结果导向**：将对话从“情绪宣泄”引导向“问题解决”（“那你打算怎么做？”）。

这会发生什么？这会迫使对方停止无限循环的抱怨，开始思考行动。或者，如果他只想抱怨，他会去找别人。
无论哪种结果，你都从“垃圾桶”变成了“引导者”。
记住，真正的朋友会尊重你的边界。如果有人因为你设立了边界而离开，那他只是在寻找垃圾桶，而不是朋友。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "设定边界（引导解决）",
      labelKey: "gameplay.options.social_06.creative",
      archetype: "实干家",
      visualEffect: "green", // Energy 250/310: Willingness (Green)
      followUp: [
        {
          type: "narrator",
          text: "你察觉到自己的能量正在流失，立刻按下了暂停键。你不需要做一个无底洞般的“好人”，你需要做一个有原则的朋友。",
          textKey: "gameplay.dialogues.social_06.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（温和但坚定地打断）亲爱的，听起来你今天确实受了不少委屈。我这会儿还有点急事要处理，只能再听你说10分钟。",
          textKey: "gameplay.dialogues.social_06.creative.2"
        },
        {
          type: "narrator",
          text: "对方愣了一下，语速慢了下来。你趁机转换了话题的方向。",
          textKey: "gameplay.dialogues.social_06.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "既然情况已经这样了，那你接下来打算怎么解决这个问题呢？有没有什么具体的计划？",
          textKey: "gameplay.dialogues.social_06.creative.4"
        },
        {
          type: "success",
          text: "这句提问像一道闸门，截断了情绪的洪水，迫使对方回到了理智层面。10分钟后，你们友好地挂断了电话。你保护了自己的能量，也没有破坏关系，甚至还通过提问帮助对方从抱怨转向了思考。这就是“实干家”的高效与智慧。",
          textKey: "gameplay.dialogues.social_06.creative.5"
        }
      ]
    }
  }
};

// 37. 派对里的局外人 (Social 07)
export const socialWallflowerScript: ScenarioScript = {
  id: "social_07",
  title: "派对里的局外人",
  titleKey: "gameplay.sceneTitles.social_07",
  sceneImage: "/scenarios/social_07.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "被朋友硬拉来参加这个聚会，结果朋友转身就钻进了熟人堆里，把你一个人晾在了原地。四周是陌生的面孔，三三两两的人群谈笑风生。",
      textKey: "gameplay.dialogues.social_07.opening.1"
    },
    {
      type: "narrator",
      text: "你手里紧紧攥着一杯饮料，感觉自己像个误入外星人派对的地球人。为了掩饰无所适从的尴尬，你掏出手机，假装在回复重要的信息，实际上只是在来回滑动主屏幕。",
      textKey: "gameplay.dialogues.social_07.opening.2"
    },
    {
      type: "narrator",
      text: "每当有人经过身边，你的肌肉都会下意识紧绷，不知道视线该往哪里放。",
      textKey: "gameplay.dialogues.social_07.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "社恐逃避（觉得自己是个怪胎）",
        labelKey: "gameplay.options.social_07.invisible",
        archetype: "隐形人",
        visualEffect: "dark_red", // Energy 20: Shame (Dark Red/Dark)
        followUp: [
          {
            type: "narrator",
            text: "羞耻感让你觉得浑身不自在。你总觉得所有人都在用余光嘲笑你：“看那个人，一个朋友都没有，真奇怪。”",
            textKey: "gameplay.dialogues.social_07.survival.invisible.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（内心独白）我就不该来……我真是个社交废物，连个招呼都不会打。太丢人了，我要回家。",
            textKey: "gameplay.dialogues.social_07.survival.invisible.2"
          },
          {
            type: "failure",
            text: "你像个逃犯一样，趁人不注意溜出了大门。虽然呼吸到了外面的新鲜空气，但内心那种“我不属于群体”的孤独感和挫败感，却久久挥之不去。",
            textKey: "gameplay.dialogues.social_07.survival.invisible.3"
          }
        ]
      },
      {
        id: "bystander_choice",
        label: "高冷防御（假装看不起）",
        labelKey: "gameplay.options.social_07.bystander",
        archetype: "旁观者",
        visualEffect: "dark_red", // Energy 50: Apathy (Dark Red/Red)
        followUp: [
          {
            type: "narrator",
            text: "为了抵御被冷落的痛苦，你开启了“高冷”防御模式。你摆出一副生人勿近的面孔，在这个角落里筑起了一道冰墙。",
            textKey: "gameplay.dialogues.social_07.survival.bystander.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（冷眼旁观）一群无聊的人，聊着肤浅的话题。这种低质量的社交简直是浪费生命。我才不屑于融入他们。",
            textKey: "gameplay.dialogues.social_07.survival.bystander.2"
          },
          {
            type: "failure",
            text: "有人本想过来跟你打招呼，但被你冰冷的眼神劝退了。你成功地用傲慢保护了自己，但也成功地把自己锁在了孤独的牢笼里。你觉得自己赢了，其实你从未入场。",
            textKey: "gameplay.dialogues.social_07.survival.bystander.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：谁在等待被拯救？",
      titleKey: "gameplay.directorNote.social_07.title",
      contentKey: "gameplay.directorNote.social_07.content",
      content: `亲爱的导演，这一幕名为“聚光灯下的孤独”。

尴尬，是社交场合中最常见的一种低频能量。
观察你的后台，是不是有两个演员正在试图帮你处理这种尴尬？
“隐形人”（羞愧，20）通过自我攻击来处理。他坚信“聚光灯效应”，认为所有人都在审视他的孤独，于是他想把自己缩到无限小，直至消失。
“旁观者”（冷漠，50）通过攻击世界来处理。他戴上“高冷”的面具，告诉自己“我不稀罕”，以此来掩盖渴望连接却不得的失落。

这两位演员都在做一个共同的动作：等待。
他们在等待别人走过来，等待别人来打破僵局，等待被拯救。而尴尬，恰恰就源于这种“被动的等待”——你把自己放在了客体的位置上，任由环境来定义你的处境。

现在，请按下【暂停的锚点】。
深呼吸，把注意力从“别人怎么看我”收回到“我现在在哪里”。
看看周围，也许那个站在甜点桌旁的人也和你一样在玩手机；也许那个看似高谈阔论的人手也在微微发抖。
大家都在害怕。大家都在等待。
在这个充满了等待者的房间里，为什么你不做那个唯一的“创造者”呢？

请邀请“探险家”（勇气，200）登场。
探险家知道，所有的连接，都始于一次微小的冒险。
放下手机，这需要勇气。
走向一个陌生人，这需要勇气。
说出第一句“你好”，这需要巨大的勇气。
但这正是探险家的使命。他不等待环境变好，他去创造环境。
当你主动伸出手时，你就从一个等待被挑选的“商品”，变成了一个主动创造连接的“人”。
尴尬会瞬间消融，因为你不再是被动的承受者，你是主动的行动者。哪怕对方反应冷淡，你也已经赢了——因为你战胜了自己内心的恐惧。

通常情况下，你会惊讶地发现，对方松了一口气，因为他也正在等你来救他。`
    },
    creativeOption: {
      id: "explorer_choice",
      label: "主动破冰（创造连接）",
      labelKey: "gameplay.options.social_07.creative",
      archetype: "探险家",
      visualEffect: "green", // Energy 200: Courage (Green)
      followUp: [
        {
          type: "narrator",
          text: "你察觉到自己正在等待被救赎，于是深吸一口气，决定做那个打破僵局的人。你把那个用来做挡箭牌的手机揣回兜里。",
          textKey: "gameplay.dialogues.social_07.creative.1"
        },
        {
          type: "narrator",
          text: "你环顾四周，发现不远处也有一个落单的人正在尴尬地吃着薯片。尽管手心微微冒汗，腿有点发软，你还是迈步走了过去。",
          textKey: "gameplay.dialogues.social_07.creative.2"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（微笑着试探）嗨，这薯片味道怎么样？我看你吃得挺香，我也想来点。",
          textKey: "gameplay.dialogues.social_07.creative.3"
        },
        {
          type: "npc",
          speaker: "陌生人",
          speakerKey: "gameplay.characters.stranger",
          text: "（如释重负地笑了）哈哈，其实有点咸，但我实在不知道干嘛，只能一直吃。你是谁的朋友？",
          textKey: "gameplay.dialogues.social_07.creative.4"
        },
        {
          type: "success",
          text: "就像魔法一样，那层厚厚的尴尬冰墙瞬间融化了。你们开始聊天，甚至引来了其他人的加入。你发现，并没有什么可怕的审判，只要你愿意迈出那勇敢的一小步，世界就会向你敞开。",
          textKey: "gameplay.dialogues.social_07.creative.5"
        }
      ]
    }
  }
};

// 38. 被评价外貌 (Social 08)
export const socialBodyShamingScript: ScenarioScript = {
  id: "social_08",
  title: "被评价外貌",
  titleKey: "gameplay.sceneTitles.social_08",
  sceneImage: "/scenarios/social_08.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "春节回家，家宴上热气腾腾，亲戚们围坐一堂。你刚夹起一块心心念念的红烧肉，准备大快朵颐。",
      textKey: "gameplay.dialogues.social_08.opening.1"
    },
    {
      type: "npc",
      speaker: "二姑/大姨",
      speakerKey: "gameplay.characters.relative_aunt",
      text: "（突然大嗓门）哎哟！你怎么最近胖了这么多啊？脸都圆了一圈！看来大城市伙食太好了，都快认不出来了。",
      textKey: "gameplay.dialogues.social_08.opening.2"
    },
    {
      type: "narrator",
      text: "这一嗓子让全桌的目光都聚焦到了你的脸上和那块红烧肉上。空气突然安静，那块肉悬在半空，吃也不是，放也不是。",
      textKey: "gameplay.dialogues.social_08.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "羞愧难当（立刻停筷）",
        labelKey: "gameplay.options.social_08.invisible",
        archetype: "隐形人",
        visualEffect: "dark_red", // Energy 20: Shame (Dark Red/Dark)
        followUp: [
          {
            type: "narrator",
            text: "你的脸瞬间烧得通红，觉得自己丑陋无比。羞耻感让你觉得那块肉简直是罪证。",
            textKey: "gameplay.dialogues.social_08.survival.invisible.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（尴尬地把肉放回盘子，低下头）啊……是吗……最近是没怎么运动……我不吃了，你们吃。",
            textKey: "gameplay.dialogues.social_08.survival.invisible.2"
          },
          {
            type: "failure",
            text: "接下来的整个假期，你都不敢大口吃饭，陷入了严重的容貌焦虑和身材羞辱中。你看着镜子里的自己，满眼都是厌恶。别人的随口一说，成了你自我攻击的武器。",
            textKey: "gameplay.dialogues.social_08.survival.invisible.3"
          }
        ]
      },
      {
        id: "tyrant_choice",
        label: "恼羞成怒（互相伤害）",
        labelKey: "gameplay.options.social_08.tyrant",
        archetype: "暴君",
        visualEffect: "red", // Energy 150: Anger (Red)
        followUp: [
          {
            type: "narrator",
            text: "一股无名火起。你觉得对方多管闲事，毫无边界感。既然你不让我好过，我也不会让你好过。",
            textKey: "gameplay.dialogues.social_08.survival.tyrant.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（冷笑一声）二姑，您还是先操心操心您自己吧，我看您发际线又后移了不少，是不是更年期到了？",
            textKey: "gameplay.dialogues.social_08.survival.tyrant.2"
          },
          {
            type: "failure",
            text: "“啪”的一声，二姑把筷子摔在桌上，家宴瞬间变成了战场。父母责怪你不懂礼貌，你觉得自己委屈至极。这顿饭谁也没吃好，你赢了嘴仗，输了关系和心情。",
            textKey: "gameplay.dialogues.social_08.survival.tyrant.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：当你爱身体时，它就是圣殿",
      titleKey: "gameplay.directorNote.social_08.title",
      contentKey: "gameplay.directorNote.social_08.content",
      content: `亲爱的导演，这一幕名为“身体的审判”。

当别人评价我们的外貌时，为什么我们会如此受伤或愤怒？
请看你的后台：
“隐形人”（羞愧，20）瞬间认同了对方的评价：“是的，我胖了，所以我很丑，我不值得被爱。”羞愧是能量最低的情绪，它让你想毁灭自己。
“暴君”（愤怒，150）则试图通过攻击对方来转移这种痛感：“你攻击我，那我也攻击你。”
这两个反应都基于同一个前提：我们内心深处，并没有真正接纳自己的身体。因为我们自己就在嫌弃自己，所以别人的话才像一把盐，撒在了原本就有的伤口上。

现在，请按下【暂停的锚点】。
看着那块红烧肉，看着你那个被评价的身体。
你的身体，是你灵魂在这个世界行走的载体，是你的圣殿。它忠诚地陪伴你经历了每一次加班、每一次熬夜、每一次欢笑和哭泣。那些多出来的肉，也许是你在压力下自我安抚的痕迹，或者是你最近享受美食的快乐证明。
为什么要因为别人的眼光，而惩罚这个一直支持你的伙伴呢？

请邀请“疗愈者”（爱，500）登场。
疗愈者知道，美不是某种标准的数据（体重、围度），美是生命力的流动。
当你的身体被爱充满时，任何外在的评价都只是空气的震动，无法穿透你爱的护盾。
你可以摸摸自己的脸，对自己说：“谢谢你，我很健康，我很丰盛。”
当你不再对抗你的身体，当你开始从心底里欣赏它时，你对外在的评价就会产生免疫。
你会发现，你不需要攻击回去，也不需要羞愧躲藏。你可以用一种极其温柔而强大的方式，化解这股能量。

你可以微笑着承认，并赋予它积极的意义。
因为只有当你自己爱自己的时候，别人才无法用不爱来伤害你。`
    },
    creativeOption: {
      id: "healer_choice",
      label: "温柔接纳（赋予正名）",
      labelKey: "gameplay.options.social_08.creative",
      archetype: "疗愈者",
      visualEffect: "indigo", // Energy 500: Love (Indigo)
      followUp: [
        {
          type: "narrator",
          text: "你没有放下筷子，而是轻轻摸了摸自己圆润的脸颊。你感受到了皮肤的温度，那是生命鲜活的证据。你决定不与身体为敌，而是与它站在一起。",
          textKey: "gameplay.dialogues.social_08.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（灿烂地一笑，语气轻松）是啊二姑，最近日子过得太滋润了，吃得香睡得好，这可是“幸福肥”呢。我觉得现在的状态特别健康。",
          textKey: "gameplay.dialogues.social_08.creative.2"
        },
        {
          type: "narrator",
          text: "说完，你把那块红烧肉放进嘴里，津津有味地咀嚼，脸上洋溢着真实的满足感。",
          textKey: "gameplay.dialogues.social_08.creative.3"
        },
        {
          type: "success",
          text: "二姑愣了一下，本来准备好的说教被你的自信堵了回去，只能讪讪地说：“那是，健康最重要，能吃是福。” 你的自我接纳不仅化解了尴尬，更让你周围的人感受到了你对自己身体的爱。这顿饭，你吃得格外香。",
          textKey: "gameplay.dialogues.social_08.creative.4"
        }
      ]
    }
  }
};

// 39. 必须随大流 (Social 09)
export const socialConformityScript: ScenarioScript = {
  id: "social_09",
  title: "必须随大流",
  titleKey: "gameplay.sceneTitles.social_09",
  sceneImage: "/scenarios/social_09.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "周末和一群许久未见的朋友聚餐。大家兴致很高，菜单传到了一位“老饕”朋友手中。",
      textKey: "gameplay.dialogues.social_09.opening.1"
    },
    {
      type: "npc",
      speaker: "老饕朋友",
      speakerKey: "gameplay.characters.foodie_friend",
      text: "哇，这家店的招牌海鲜拼盘看起来太棒了！虽然贵点，但难得聚一次嘛，咱们每人来一份这个398的套餐怎么样？AA下来也还能接受。",
      textKey: "gameplay.dialogues.social_09.opening.2"
    },
    {
      type: "narrator",
      text: "周围的朋友纷纷附和：“好啊好啊！”“看着就不错！”你心里一紧，快速算了一下，这顿饭会花掉你半个月的伙食预算。其实你只想点个几十块的主食，但看着大家热烈的气氛，话堵在嘴边。",
      textKey: "gameplay.dialogues.social_09.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "performer_choice",
        label: "打肿脸充胖子（虚假豪爽）",
        labelKey: "gameplay.options.social_09.performer",
        archetype: "演员",
        visualEffect: "yellow", // Energy 175: Pride (Yellow)
        followUp: [
          {
            type: "narrator",
            text: "为了维持“我过得不错”的人设，也为了不扫大家的兴，你强行挤出一个笑容。",
            textKey: "gameplay.dialogues.social_09.survival.performer.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "没问题！看着确实不错，我都饿了，就点这个吧！",
            textKey: "gameplay.dialogues.social_09.survival.performer.2"
          },
          {
            type: "failure",
            text: "昂贵的海鲜吃在嘴里，你却尝不出什么鲜味，脑子里全是下半月要吃土的焦虑。你用金钱买了一时的面子，却在心里甚至开始埋怨提议的朋友。这顿饭吃得心力交瘁。",
            textKey: "gameplay.dialogues.social_09.survival.performer.3"
          }
        ]
      },
      {
        id: "coward_choice",
        label: "唯唯诺诺跟随（害怕排挤）",
        labelKey: "gameplay.options.social_09.coward",
        archetype: "懦夫",
        visualEffect: "red", // Energy 100: Fear (Red)
        followUp: [
          {
            type: "narrator",
            text: "恐惧占据了你的心。你害怕如果说“不”，会被大家瞧不起，或者显得不合群，被排除在这个圈子之外。",
            textKey: "gameplay.dialogues.social_09.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（声音很小）嗯……我都行，听你们的。",
            textKey: "gameplay.dialogues.social_09.survival.coward.2"
          },
          {
            type: "failure",
            text: "你交出了选择权，也交出了自己的边界。看着账单，你感到一阵深深的无力感。你为了“合群”而弄丢了自己，这种顺从并没有让你赢得尊重，反而让你觉得自己很渺小。",
            textKey: "gameplay.dialogues.social_09.survival.coward.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：真实的穷，比虚假的富更迷人",
      titleKey: "gameplay.directorNote.social_09.title",
      contentKey: "gameplay.directorNote.social_09.content",
      content: `亲爱的导演，这一幕名为“合群的代价”。

在社交餐桌上，我们常常被一种隐形的压力所绑架。
看看你的后台：
“演员”（骄傲，175）在算计：“如果我嫌贵，我的面子往哪搁？我必须表现得大方。”他用金钱购买虚荣。
“懦夫”（恐惧，100）在颤抖：“如果我不一样，他们会不会讨厌我？”他用金钱购买安全感。
这两者都在做同一件事：背叛自己，去迎合他人。

但请按下【暂停的锚点】。
问自己一个核心问题：如果你为了合群而弄丢了自己，那个群还值得合吗？
真正的朋友，连接的是你的灵魂，而不是你的钱包。如果一段友谊因为你点了一份便宜的意面而破裂，那它本来就是塑料做的。

请邀请“探险家”（勇气，200）登场。
探险家拥有一种名为“坦荡”的超能力。
他不怕展示自己的真实状况，因为他不把“金钱”等同于“价值”。
试着直接说出来：“我最近在攒钱买个大件（或者就是手头紧），我就不吃那个大餐了，我点个简单的陪你们。”
这种真实的表达，往往会产生意想不到的磁场。它打破了社交场合中那种紧绷的“装”的氛围。
你会惊讶地发现，当你坦荡地做自己时，你不仅没有被排挤，反而给了其他人“卸下面具”的许可。也许你会听到有人松了一口气说：“其实我也觉得有点贵，那我也跟你吃一样的吧。”

真实的穷坦荡，永远比虚假的富更迷人。因为真实，最有力量。`
    },
    creativeOption: {
      id: "explorer_choice",
      label: "坦荡做自己（真实表达）",
      labelKey: "gameplay.options.social_09.creative",
      archetype: "探险家",
      visualEffect: "green", // Energy 200: Courage (Green)
      followUp: [
        {
          type: "narrator",
          text: "你深吸一口气，决定打破这个“随大流”的魔咒。你不需要通过吃什么来证明你是谁。",
          textKey: "gameplay.dialogues.social_09.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（轻松且自然地）哇，那个拼盘看着是真不错，不过我这阵子正攒钱准备换个电脑（或者直说手头紧），预算有限。我就点这份肉酱面就好啦，你们吃好喝好，不用管我！",
          textKey: "gameplay.dialogues.social_09.creative.2"
        },
        {
          type: "narrator",
          text: "桌上安静了一秒，并没有出现你担心的嘲笑。",
          textKey: "gameplay.dialogues.social_09.creative.3"
        },
        {
          type: "npc",
          speaker: "朋友B",
          speakerKey: "gameplay.characters.friend_b",
          text: "哎，其实我也觉得那个有点超预算了……既然你这么说，那我也来份炒饭吧，正好我想吃点热乎的主食。",
          textKey: "gameplay.dialogues.social_09.creative.4"
        },
        {
          type: "success",
          text: "气氛不仅没有变尴尬，反而变得更轻松真实了。大家不再端着架子，开始聊起各自真实的近况和省钱小妙招。你守住了钱包，也筛选出了真正的朋友，更重要的是，你享受了做自己的自由。",
          textKey: "gameplay.dialogues.social_09.creative.5"
        }
      ]
    }
  }
};

// 40. 被“已读不回” (Social 10)
export const socialLeftOnReadScript: ScenarioScript = {
  id: "social_10",
  title: "被“已读不回”",
  titleKey: "gameplay.sceneTitles.social_10",
  sceneImage: "/scenarios/social_10.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "你给那个你在乎的人（也许是暧昧对象，也许是重要客户）发了一条精心编辑的信息。五分钟后，屏幕上显示了两个令人窒息的小字：“已读”。",
      textKey: "gameplay.dialogues.social_10.opening.1"
    },
    {
      type: "narrator",
      text: "半小时过去了，没有回复。一小时过去了，对话框依然静悄悄的。两小时过去了……",
      textKey: "gameplay.dialogues.social_10.opening.2"
    },
    {
      type: "narrator",
      text: "你的手机就像一块烧红的烙铁，虽然没有响动，却灼烧着你的注意力。你每隔几分钟就解锁查看一次，生怕错过了通知。",
      textKey: "gameplay.dialogues.social_10.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "coward_choice",
        label: "焦虑内耗（自我检讨）",
        labelKey: "gameplay.options.social_10.coward",
        archetype: "懦夫",
        visualEffect: "red", // Energy 100: Fear (Red)
        followUp: [
          {
            type: "narrator",
            text: "恐惧抓住了你的心脏。你开始反复阅读那条发出去的信息，逐字逐句地分析。",
            textKey: "gameplay.dialogues.social_10.survival.coward.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（疯狂脑补）我是不是语气太冲了？还是这个表情包太幼稚了？他是不是觉得我很烦？天哪，我刚才就不该发那句话！",
            textKey: "gameplay.dialogues.social_10.survival.coward.2"
          },
          {
            type: "failure",
            text: "你在这种高强度的自我审判中度过了一下午，什么正事也没干成。你的情绪完全被对方的反应（或者说“无反应”）所绑架，变得患得患失，卑微至极。",
            textKey: "gameplay.dialogues.social_10.survival.coward.3"
          }
        ]
      },
      {
        id: "victim_choice",
        label: "悲情演绎（确认不配）",
        labelKey: "gameplay.options.social_10.victim",
        archetype: "受害者",
        visualEffect: "dark_red", // Energy 75: Grief (Dark Red/Red)
        followUp: [
          {
            type: "narrator",
            text: "你叹了一口气，把手机扔到一边，但这只是为了掩盖内心的绝望。你觉得这是命运对你的又一次嘲弄。",
            textKey: "gameplay.dialogues.social_10.survival.victim.1"
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（内心独白）我就知道……总是这样。从来没有人真正把我的事放在心上。我不重要，我不配得到及时的回应。我就活该被忽视。",
            textKey: "gameplay.dialogues.social_10.survival.victim.2"
          },
          {
            type: "failure",
            text: "你陷入了一种凄凉的受害者剧本里，不仅对这个人感到失望，甚至对整个人际关系都失去了信心。那个沉默的对话框，成了你“不被爱”的铁证。",
            textKey: "gameplay.dialogues.social_10.survival.victim.3"
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：你的价值不随信号波动",
      titleKey: "gameplay.directorNote.social_10.title",
      contentKey: "gameplay.directorNote.social_10.content",
      content: `亲爱的导演，这一幕叫“空白的等待”。

现代通讯工具最残忍的发明之一，就是“已读”功能。它把一个微小的时间缝隙，放大成了巨大的心理黑洞。
在这个黑洞里，你的两个演员正在疯狂加戏：
“懦夫”（恐惧，100）在喊：“我做错了！我不安全！”他把对方的沉默解读为对自己的惩罚。
“受害者”（悲伤，75）在哭：“我不重要！我是弃子！”他把对方的沉默解读为对自己的定性。

但请按下【暂停的锚点】。
把目光从屏幕上移开，看看窗外的树，看看桌上的水杯。它们依然存在，你也依然存在。
事实只有一个：对方看了信息，但还没有回。
除此之外的一切——“他讨厌我”、“我做错了”、“我不重要”——全部都是你脑补出来的“故事”。
你把自己的自尊心，挂在了一个不确定的、可能只是因为对方在开车、在开会、或者单纯忘了回的行为上。

请邀请“智者”（理智，350-400）登场。
智者拥有“区分事实与想象”的能力。
他会告诉你：对方回不回信息，是对方的事（课题分离）。你的价值是恒定的，不随无线电信号的波动而涨跌。
也许他真的很忙，也许他在思考怎么回，也许他就是个回信息慢的人。
但这都与“你是否值得被爱”无关。

放下手机，去做你自己的事。去读书，去运动，去工作。
当你把注意力收回到自己身上，不再像个乞丐一样等待那个“回复”的施舍时，你反而变得更有吸引力。
通常，当你忘了这回事的时候，手机就响了。`
    },
    creativeOption: {
      id: "sage_choice",
      label: "事实判断（专注自我）",
      labelKey: "gameplay.options.social_10.creative",
      archetype: "智者",
      visualEffect: "blue", // Energy 350/400: Reason (Blue)
      followUp: [
        {
          type: "narrator",
          text: "你深吸一口气，觉察到自己正在编造恐怖故事。你强行切断了那些灾难性的联想，回归理性。",
          textKey: "gameplay.dialogues.social_10.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（冷静分析）已读不回有无数种可能：他在开车、他在开会、手机没电了，或者只是意念回复了。这不代表讨厌我，也不代表我做错了什么。这就是一个单纯的物理状态。",
          textKey: "gameplay.dialogues.social_10.creative.2"
        },
        {
          type: "narrator",
          text: "你把手机调成静音，扣在桌面上。你决定把这两个小时还给自己。",
          textKey: "gameplay.dialogues.social_10.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（起身伸个懒腰）正好，趁这个时间把那本书看完。我的时间也很宝贵。",
          textKey: "gameplay.dialogues.social_10.creative.4"
        },
        {
          type: "success",
          text: "当你沉浸在书本的世界里时，焦虑不知不觉消散了。晚些时候，对方发来了回复和解释。你看着信息，内心毫无波澜，甚至有点想笑：原来刚才那场内心大戏，真的只是自导自演。你找回了内心的稳态。",
          textKey: "gameplay.dialogues.social_10.creative.5"
        }
      ]
    }
  }
};


// ========== 场景五：独处/内在自我 (Inner) ==========

// 41. 深夜emo（刷手机） (Inner 01)
export const innerDoomscrollingScript: ScenarioScript = {
  id: "inner_01",
  title: "深夜的蓝光牢笼",
  titleKey: "gameplay.sceneTitles.inner_01",
  sceneImage: "/scenarios/inner_01.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "凌晨 02:13。房间里一片漆黑，只有手机屏幕发出的冷冽蓝光，照亮了你有些油腻的脸庞。",
      textKey: "gameplay.dialogues.inner_01.opening.1"
    },
    {
      type: "narrator",
      text: "你的眼睛干涩刺痛，身体因为维持同一个姿势而发出僵硬的抗议。理智告诉你“明天还要上班，必须睡了”，但你的大拇指却像有了自己的意识，机械地向上滑动。",
      textKey: "gameplay.dialogues.inner_01.opening.2"
    },
    {
      type: "narrator",
      text: "短视频里喧闹的笑声、无关紧要的八卦、贩卖焦虑的鸡汤……它们一个接一个地流过你的视网膜。你并不觉得快乐，甚至感到一种深深的空虚和恶心，但你就是停不下来。仿佛只要一关上屏幕，那种巨大的、无边的孤独感就会将你吞噬。",
      textKey: "gameplay.dialogues.inner_01.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "addict_choice",
        label: "再看五分钟（寻找刺激）",
        labelKey: "gameplay.options.inner_01.addict",
        archetype: "瘾君子",
        visualEffect: "orange", // 脐轮 (欲望)
        followUp: [
          {
            type: "narrator",
            text: "“再看最后一个就睡。”你对自己撒谎。手指继续滑动，寻找下一个能带来多巴胺刺激的视频。",
            textKey: "gameplay.dialogues.inner_01.survival.addict.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（眼神空洞）这日子太没劲了，只有这点时间是属于我的……",
            textKey: "gameplay.dialogues.inner_01.survival.addict.2" 
          },
          {
            type: "failure",
            text: "当你再次看时间时，已经是凌晨四点。你精疲力竭地昏睡过去，带着深深的自责。第二天醒来，你头痛欲裂，精神萎靡，仿佛被吸干了精气。",
            textKey: "gameplay.dialogues.inner_01.survival.addict.3" 
          }
        ]
      },
      {
        id: "victim_choice",
        label: "听伤感歌（沉浸悲伤）",
        labelKey: "gameplay.options.inner_01.victim",
        archetype: "受害者",
        visualEffect: "red", // 海底轮 (悲伤/求生)
        followUp: [
          {
            type: "narrator",
            text: "你关掉视频，打开了那个名为“深夜致郁”的歌单。悲伤的旋律流淌出来，你开始回想过去所有的遗憾。",
            textKey: "gameplay.dialogues.inner_01.survival.victim.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（默默流泪）为什么大家都睡得那么安稳，只有我这么孤独？也许我注定就是不被爱的……",
            textKey: "gameplay.dialogues.inner_01.survival.victim.2" 
          },
          {
            type: "failure",
            text: "你在这个“悲剧主角”的剧本里找到了某种凄美感，但也因此消耗了仅存的能量。你带着泪痕入睡，梦里依然是灰色的迷雾。",
            textKey: "gameplay.dialogues.inner_01.survival.victim.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：拿回夜晚的主权",
      titleKey: "gameplay.directorNote.inner_01.title",
      contentKey: "gameplay.directorNote.inner_01.content",
      content: `亲爱的导演，此刻是凌晨两点。这是一天中防线最薄弱的时刻，也是“求生剧组”最容易发动政变的时刻。

这里正在上演的，是一场典型的“报复性熬夜”。
你的“瘾君子”（欲望，能量 125）在尖叫。他之所以停不下来，是因为他在白天感受到了深深的失控感。白天的时间属于老板、属于客户、属于家庭，只有这深夜的几个小时，似乎才真正属于你。于是，“瘾君子”试图通过吞噬垃圾信息，来制造一种“我在享受生活”的虚假快感。他告诉你：“别睡，睡了今天就结束了，而你还没活够。”

与此同时，“受害者”（悲伤，能量 75）也在角落里低语。他利用黑夜的寂静，放大你的孤独感，让你沉溺在一种“全世界都离我而去”的凄凉美学中。

但请看清真相：这不仅不是享受，这是一场对自己身体的残酷掠夺。你正在透支明天的生命，来填补今天心灵的黑洞。那个发光的屏幕，不是通往世界的窗口，而是囚禁你灵魂的牢笼。

现在，请按下【暂停的锚点】。
把手机屏幕熄灭。哪怕只有一瞬间，感受一下黑暗。
感受你干涩的眼球，感受你沉重的眼皮，听听你心脏疲惫的跳动声。那是你的身体在向你求救。
对自己说：“看见你们了，瘾君子和受害者。谢谢你们试图用这种方式来补偿我白天的劳累。”

然后，请邀请“实干家”（意愿，能量 250/310）进场。
实干家不需要感慨，不需要分析，他只需要一个简单的、物理上的动作。
真正的爱自己，不是纵容欲望，而是像照顾一个珍贵的孩子一样，照顾你自己的身体。因为你的身体，是你体验这个世界唯一的圣殿。

放下手机（物理动作），把它放到伸手够不到的地方，或者客厅。
关灯。躺平。
你的任务只有一个：休息。

试着这样对自己说：`
    },
    creativeOption: {
      id: "doer_choice",
      label: "放下手机（物理关机）",
      labelKey: "gameplay.options.inner_01.creative",
      archetype: "实干家",
      visualEffect: "green", // 心轮 (意愿/行动)
      followUp: [
        {
          type: "narrator",
          text: "你意识到这是一种名为“睡前拖延”的自我攻击。你没有再给大脑辩解的机会，而是直接坐起身，做了一个决定性的动作。",
          textKey: "gameplay.dialogues.inner_01.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（深吸一口气，语气坚定）够了。今晚的任务已经结束，现在的任务是充电。",
          textKey: "gameplay.dialogues.inner_01.creative.2"
        },
        {
          type: "narrator",
          text: "你将手机插上充电器，放在了卧室门外的柜子上。当你回到黑暗的房间，没有了蓝光的干扰，你第一次感觉到了被子柔软的触感和周围宁静的空气。",
          textKey: "gameplay.dialogues.inner_01.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（闭上眼睛，关注呼吸）我不缺那一个视频，我缺的是一个饱满的明天。",
          textKey: "gameplay.dialogues.inner_01.creative.4"
        },
        {
          type: "success",
          text: "几分钟后，自然的困意如潮水般温柔地将你淹没。你没有逃避明天，你在为明天积蓄力量。这一夜，你睡得无比踏实。",
          textKey: "gameplay.dialogues.inner_01.creative.5"
        }
      ]
    }
  }
};

// 42. 报复性消费 (Inner 02)
export const innerRevengeSpendingScript: ScenarioScript = {
  id: "inner_02",
  title: "填不满的购物车",
  titleKey: "gameplay.sceneTitles.inner_02",
  sceneImage: "/scenarios/inner_02.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "结束了一天高压的工作，你瘫倒在沙发上，感觉身体被掏空，心里堵着一团无处发泄的火气。",
      textKey: "gameplay.dialogues.inner_02.opening.1"
    },
    {
      type: "narrator",
      text: "你习惯性地打开购物软件，直播间里主播激昂的叫喊声“最后三分钟，不买就亏了！”刺激着你的耳膜。精修的图片、限量的标签、满减的优惠券……",
      textKey: "gameplay.dialogues.inner_02.opening.2"
    },
    {
      type: "narrator",
      text: "你的手指在“立即支付”按钮上方悬停。你其实并不缺这只口红，也不缺那个昂贵的摆件，但此时此刻，你迫切地需要一种“拥有”的感觉，来填补内心的那个大洞。",
      textKey: "gameplay.dialogues.inner_02.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "addict_choice",
        label: "下单！就要对自己好点（追求快感）",
        labelKey: "gameplay.options.inner_02.addict",
        archetype: "瘾君子",
        visualEffect: "orange", // 脐轮 (欲望)
        followUp: [
          {
            type: "narrator",
            text: "指纹验证通过，“支付成功”的绿色对勾弹出的那一瞬间，你感到头皮一阵酥麻。多巴胺瞬间分泌，仿佛你真的是这世界的王。",
            textKey: "gameplay.dialogues.inner_02.survival.addict.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（嘴角上扬）不管了，赚钱不就是为了花吗？还是买东西最解压。",
            textKey: "gameplay.dialogues.inner_02.survival.addict.2" 
          },
          {
            type: "failure",
            text: "然而，快感只持续了五分钟。关掉软件后，面对空荡荡的房间，那股空虚感比之前更猛烈地袭来。你买回来的不是快乐，只是短暂的麻醉剂。你的钱包空了，心却没满。",
            textKey: "gameplay.dialogues.inner_02.survival.addict.3" 
          }
        ]
      },
      {
        id: "sinner_choice",
        label: "看完账单想剁手（自我攻击）",
        labelKey: "gameplay.options.inner_02.sinner",
        archetype: "罪人",
        visualEffect: "red", // 海底轮 (内疚/恐惧)
        followUp: [
          {
            type: "narrator",
            text: "冲动过后，你点开了这个月的账单。看着那个红色的数字，你的胃部开始痉挛。",
            textKey: "gameplay.dialogues.inner_02.survival.sinner.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（抱头痛哭）我怎么这么败家？明明说好要存钱的，我真的一点自制力都没有，我是个废物。",
            textKey: "gameplay.dialogues.inner_02.survival.sinner.2" 
          },
          {
            type: "failure",
            text: "你陷入了深深的自我厌恶中，甚至想退货谢罪。这种内疚感让你更加焦虑，而为了缓解这种焦虑，你明天可能又会忍不住想买点什么来安慰自己。恶性循环开始了。",
            textKey: "gameplay.dialogues.inner_02.survival.sinner.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：物质填不满灵魂的洞",
      titleKey: "gameplay.directorNote.inner_02.title",
      contentKey: "gameplay.directorNote.inner_02.content",
      content: `亲爱的导演，让我们按下暂停键，看看购物车里装的到底是什么。

在这个场景中，主演是“瘾君子”（欲望，能量 125）。
当你在工作中感到压力、委屈或无力时，你的能量处于一种“收缩”和“匮乏”的状态。这时候，“瘾君子”跳出来告诉你一个谎言：“如果不快乐，那就去买点快乐回来。”
他让你相信，那个名牌包、那个新款电子产品，是你的“解药”。通过“支付”这个动作，你体验到了一种虚假的“掌控感”和“获得感”。那一瞬间的多巴胺飙升，让你误以为这就是幸福。
但就像所有的成瘾机制一样，阈值会越来越高，而空虚感回潮的速度会越来越快。因为你试图用有形的物质（Matter），去填补无形的情绪（Emotion）黑洞。这就像是用创可贴去修补破碎的镜子，注定是徒劳的。

另一位常客是“罪人”（内疚，能量 30）。
当你看到账单时的自我攻击，其实是另一种逃避。你在惩罚自己，试图通过痛苦来“赎罪”。但这种低频能量只会让你更虚弱，从而更容易在下一次压力来袭时崩溃。

现在，作为导演，请启动【暂停的锚点】。
在你的手指按下“支付”之前，停下来。
闭上眼睛，做三次深呼吸。问自己那个直击灵魂的问题：
“我现在真正需要的，真的是这个商品吗？还是我需要一种‘被填满’、‘被安慰’的感觉？”

如果是后者，请邀请“智者”（理智，能量 350/400）进场。
智者拥有透过现象看本质的能力。他知道，你真正饥渴的不是物品，而是能量。
既然是能量的匮乏，就要用能量的方式来补充，而不是物质。
去洗个热水澡，去公园跑一圈，或者只是静静地喝一杯水。
你会发现，当你关照了那个内在的需求，购物车的诱惑就瞬间消失了。因为你已经“满”了。`
    },
    creativeOption: {
      id: "sage_choice",
      label: "觉察并关掉软件（理性转念）",
      labelKey: "gameplay.options.inner_02.creative",
      archetype: "智者",
      visualEffect: "blue", // 喉轮 (理智/冷静)
      followUp: [
        {
          type: "narrator",
          text: "在手指即将触碰屏幕的瞬间，你突然停住了。你像一个旁观者一样，看着自己急促的呼吸和渴望的眼神。",
          textKey: "gameplay.dialogues.inner_02.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（冷静地自言自语）等等，我买这个是为了它的功能，还是为了缓解我现在的不爽？",
          textKey: "gameplay.dialogues.inner_02.creative.2"
        },
        {
          type: "narrator",
          text: "答案显而易见。你意识到这是一个“情绪代偿”的陷阱。你果断地退出了直播间，锁上了手机屏幕。",
          textKey: "gameplay.dialogues.inner_02.creative.3"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（起身走向浴室）我需要的不是快递，而是一个热水澡和早点睡觉。",
          textKey: "gameplay.dialogues.inner_02.creative.4"
        },
        {
          type: "success",
          text: "当你从浴室出来，身体暖洋洋的，那股想花钱的冲动早已烟消云散。你不仅省下了一笔钱，更重要的是，你战胜了欲望的操控，你感到了真正的自由和充实。",
          textKey: "gameplay.dialogues.inner_02.creative.5"
        }
      ]
    }
  }
};

// 43. 梦想拖延症 (Inner 03)
export const innerDreamProcrastinationScript: ScenarioScript = {
  id: "inner_03",
  title: "永远在“准备中”的梦想",
  titleKey: "gameplay.sceneTitles.inner_03",
  sceneImage: "/scenarios/inner_03.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "你的电脑收藏夹里躺着几十个“必看教程”，书架上堆满了全新的参考书，墙上贴着一张完美的“年度计划表”。",
      textKey: "gameplay.dialogues.inner_03.opening.1"
    },
    {
      type: "narrator",
      text: "你一直想开启那个副业，或者学习那门外语。所有的准备工作都做足了，甚至连用来签名的笔都买好了。但在那个最为关键的“开始”按钮面前，你却死死地卡住了。",
      textKey: "gameplay.dialogues.inner_03.opening.2"
    },
    {
      type: "narrator",
      text: "日复一日，计划表上的日期一个个过去，你依然停留在起跑线上，看着别人绝尘而去，心里的焦虑像杂草一样疯长。",
      textKey: "gameplay.dialogues.inner_03.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "coward_choice",
        label: "再学点干货（恐惧失败）",
        labelKey: "gameplay.options.inner_03.coward",
        archetype: "懦夫",
        visualEffect: "red", // 海底轮 (恐惧)
        followUp: [
          {
            type: "narrator",
            text: "“我还不够好，现在开始肯定会失败。”你这样告诉自己。于是你又报名了一个新课程，试图用更多的“输入”来缓解对“输出”的恐惧。",
            textKey: "gameplay.dialogues.inner_03.survival.coward.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（看着屏幕发抖）万一做出来没人看怎么办？万一被专家嘲笑怎么办？还是稳妥点好。",
            textKey: "gameplay.dialogues.inner_03.survival.coward.2" 
          },
          {
            type: "failure",
            text: "你变成了一个“道理都懂”的理论家。这种无休止的准备成了你逃避现实的避难所。你的梦想，最终窒息在了你为它精心准备的摇篮里。",
            textKey: "gameplay.dialogues.inner_03.survival.coward.3" 
          }
        ]
      },
      {
        id: "performer_choice",
        label: "必须一鸣惊人（完美主义）",
        labelKey: "gameplay.options.inner_03.performer",
        archetype: "演员",
        visualEffect: "yellow", // 太阳神经丛 (骄傲/小我)
        followUp: [
          {
            type: "narrator",
            text: "“要做就要做最好，否则就没有意义。”你盯着空白的文档，写了第一句，删掉；改了第二句，觉得不够惊艳，又删掉。",
            textKey: "gameplay.dialogues.inner_03.survival.performer.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（烦躁地抓头发）这简直是垃圾！我不能允许这种水平的东西代表我。等我状态完美了再写。",
            textKey: "gameplay.dialogues.inner_03.survival.performer.2" 
          },
          {
            type: "failure",
            text: "因为怕画歪第一笔，你迟迟不敢动笔。你的完美主义成了一把枷锁，将你的才华牢牢锁死。最终，你交出的只有一张完美的白卷。",
            textKey: "gameplay.dialogues.inner_03.survival.performer.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：允许一个“烂开始”",
      titleKey: "gameplay.directorNote.inner_03.title",
      contentKey: "gameplay.directorNote.inner_03.content",
      content: `亲爱的导演，你是否也在等红绿灯全部变绿才肯出门？

这一幕是所有梦想家的噩梦：拖延。
在这里阻挡你的，通常是两位重量级的“求生演员”。

第一位是“懦夫”（恐惧，能量 100） 。他通过灾难化联想（“万一失败了怎么办？”）来恐吓你。为了安抚这种恐惧，你陷入了“伪工作”（Busy Work）——不停地收集资料、整理桌面。这让你感觉自己在努力，其实你只是在原地踏步，用战术上的勤奋掩盖战略上的懒惰。

第二位是更隐蔽的“演员”（骄傲，能量 175） 。他戴着“完美主义”的面具。他告诉你：“你可是个天才，你的第一次亮相必须完美无缺。” 这种沉重的偶像包袱让你寸步难行。因为在“演员”的剧本里，过程中的丑陋是不可接受的，然而任何伟大的作品，初稿都是狗屎。

现在，请按下【暂停的锚点】。
看着那个空白文档，深呼吸。
对自己说：“看见你们了。谢谢懦夫想保护我不受伤害，谢谢演员想维护我的形象。”

然后，请邀请“实干家”（意愿，能量 250/310） 登场。
实干家有一个核心咒语：Start Small（从小处开始）。
他不在乎完美，他只在乎“流动”。
如果不流动，水就会变臭。如果流动，哪怕是浑水，最终也会澄清。

把你宏大的目标（写一本书），缩小到微不足道的一步（写50个字，甚至只是打开文档写下标题）。
允许自己做一个“烂开始”。告诉自己：“现在的目标不是完美，而是完成。”
当你允许自己写出一堆垃圾时，你就自由了。而往往在那堆“垃圾”里，藏着金子的种子。
先开枪，再瞄准。行动本身，就是消除恐惧最好的解药。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "先做5分钟（允许糟糕）",
      labelKey: "gameplay.options.inner_03.creative",
      archetype: "实干家",
      visualEffect: "green", // 心轮 (意愿/行动)
      followUp: [
        {
          type: "narrator",
          text: "你关掉了那些完美的教程和计划表，只留下了最简陋的工具。你对自己说：“哪怕写出一坨狗屎，我也要写满5分钟。”",
          textKey: "gameplay.dialogues.inner_03.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（深吸一口气，开始敲键盘）不管好坏，先让它存在。行动是治愈恐惧的唯一良药。",
          textKey: "gameplay.dialogues.inner_03.creative.2"
        },
        {
          type: "narrator",
          text: "当你敲下第一个字时，那种巨大的阻力神奇地消失了。5分钟变成了10分钟，10分钟变成了半小时。虽然初稿很粗糙，但它是真实的、有生命力的。",
          textKey: "gameplay.dialogues.inner_03.creative.3"
        },
        {
          type: "success",
          text: "看着屏幕上那虽然不完美但实实在在的几百字，你感到了一种前所未有的踏实感。你打破了冻结的魔咒，这一刻，你不再是一个梦想家，你是一个践行者。",
          textKey: "gameplay.dialogues.inner_03.creative.4"
        }
      ]
    }
  }
};

// 44. 减肥失败 (Inner 04)
export const innerDietFailScript: ScenarioScript = {
  id: "inner_04",
  title: "火锅后的罪恶感",
  titleKey: "gameplay.sceneTitles.inner_04",
  sceneImage: "/scenarios/inner_04.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "坚持了整整三天的“吃草”生活，在今晚彻底崩塌。朋友的一个聚餐邀请，让你没能守住防线。",
      textKey: "gameplay.dialogues.inner_04.opening.1"
    },
    {
      type: "narrator",
      text: "红油翻滚的火锅，鲜嫩的肥牛，还有那杯全糖的珍珠奶茶……你像个饿死鬼一样风卷残云。",
      textKey: "gameplay.dialogues.inner_04.opening.2"
    },
    {
      type: "narrator",
      text: "此刻，你瘫坐在椅子上，摸着鼓起来的肚子。味蕾的狂欢已经退去，取而代之的是一种沉重的、几乎让你窒息的罪恶感。",
      textKey: "gameplay.dialogues.inner_04.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "sinner_choice",
        label: "疯狂自责（自我攻击）",
        labelKey: "gameplay.options.inner_04.sinner",
        archetype: "罪人",
        visualEffect: "red", // 海底轮 (内疚)
        followUp: [
          {
            type: "narrator",
            text: "你冲进洗手间，看着镜子里油光满面的自己，恶毒的咒骂在脑海里炸开。",
            textKey: "gameplay.dialogues.inner_04.survival.sinner.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（捏着肚子上的肉）你就是头猪！这点毅力都没有，活该你是个死胖子！明天必须绝食一天来惩罚自己。",
            textKey: "gameplay.dialogues.inner_04.survival.sinner.2" 
          },
          {
            type: "failure",
            text: "你在极度的自我厌恶中入睡。这种通过“自我惩罚”来维持的自律是极其脆弱的，它只会让你更加渴望食物的抚慰，为下一次更大的报复性暴食埋下伏笔。",
            textKey: "gameplay.dialogues.inner_04.survival.sinner.3" 
          }
        ]
      },
      {
        id: "addict_choice",
        label: "破罐破摔（彻底放纵）",
        labelKey: "gameplay.options.inner_04.addict",
        archetype: "瘾君子",
        visualEffect: "orange", // 脐轮 (欲望)
        followUp: [
          {
            type: "narrator",
            text: "“反正已经破戒了，今天的减肥计划彻底废了。”一种报复性的快感涌上心头。",
            textKey: "gameplay.dialogues.inner_04.survival.addict.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（打开外卖软件）既然都吃了，不如吃个够！再来份炸鸡当夜宵，减肥那是明天的事。",
            textKey: "gameplay.dialogues.inner_04.survival.addict.2" 
          },
          {
            type: "failure",
            text: "你陷入了“要么完美，要么毁灭”的极端陷阱。今晚的放纵让你不仅身体负荷过重，心理防线也彻底崩溃。明天，那个“重新开始”的明天，似乎永远不会到来。",
            textKey: "gameplay.dialogues.inner_04.survival.addict.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：爱才是最高级的自律",
      titleKey: "gameplay.directorNote.inner_04.title",
      contentKey: "gameplay.directorNote.inner_04.content",
      content: `亲爱的导演，请把手放在你此刻感到胀痛的胃部。

这真是一个经典的“滑铁卢”时刻。在这个场景里，你的“求生剧组”正在对你的身体进行一场残酷的审判。

首先登场的是“罪人”（内疚，能量 30）。他手里拿着鞭子，相信“惩罚”是改变的唯一动力。他告诉你：“你是个失败者，你没有毅力。” 他试图通过让你感到羞耻，来逼迫你变好。但这是一个谎言。羞耻只会消耗你的能量，让你在下一次面对诱惑时更加虚弱。建立在自我厌恶之上的自律，就像建在沙滩上的城堡，一个浪头打来就会粉碎。

紧接着是“瘾君子”（欲望，能量 125）。他利用你的挫败感，诱导你进入“破罐破摔”的模式。“既然窗户破了，那就把房子拆了吧。”这是他在绝望中寻找的最后一点虚假的控制感。

现在，请按下【暂停的锚点】。
深呼吸，不要把这口气憋在心里。
看着那顿火锅，看着你自己。
这只是一顿饭。它不是一种罪行，也不代表你整个人生的失败。它是你身体的一次真实渴望，也是你生活的一部分。

请邀请“疗愈者”（爱，能量 500）进场。
疗愈者知道，真正的改变，只能发生在你接纳自己的那一刻。
身体不是你的敌人，它是你最忠实的伙伴。你不可能通过虐待你的伙伴，来让他变得更健康。
如果你爱你的孩子，当他摔倒时，你会痛骂他是废物吗？不，你会抱起他，拍拍土，告诉他“没关系，我们要继续走了”。
对待你的身体，也请如此。
原谅你的每一次跌倒。这种原谅不是纵容，而是一种温柔的坚定。它让你能迅速从情绪的泥潭中拔腿，轻装上阵，回到正轨。
告诉自己：“谢谢这顿饭带给我的快乐。我的身体已经满足了。现在，我准备好继续前行了。”`
    },
    creativeOption: {
      id: "healer_choice",
      label: "原谅并接纳（温柔回归）",
      labelKey: "gameplay.options.inner_04.creative",
      archetype: "疗愈者",
      visualEffect: "indigo", // 眉心轮 (爱/疗愈)
      followUp: [
        {
          type: "narrator",
          text: "你停下了脑海中的自我攻击，把手温柔地放在肚子上，感受着那里的起伏。你没有感受到“肥肉”，你感受到了生命的温度。",
          textKey: "gameplay.dialogues.inner_04.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（温柔地对自己说）没关系。这只是一顿快乐的晚餐，我的身体也许真的需要这点热量和安慰。谢谢你，小肚腩。",
          textKey: "gameplay.dialogues.inner_04.creative.2"
        },
        {
          type: "narrator",
          text: "你决定不再纠结于已经吞下的食物。你站起来，去泡了一杯助消化的热茶，并在心里默默规划明天的早餐——一份清淡的燕麦。",
          textKey: "gameplay.dialogues.inner_04.creative.3"
        },
        {
          type: "success",
          text: "当你放下了心理负担，身体反而轻松了。你没有因为一次跌倒就躺在地上哭泣，而是拍拍土站了起来。你发现，原来爱自己，比恨自己更能让你坚持下去。",
          textKey: "gameplay.dialogues.inner_04.creative.4"
        }
      ]
    }
  }
};

// 45. 周日晚上焦虑症 (Inner 05)
export const innerSundayBluesScript: ScenarioScript = {
  id: "inner_05",
  title: "周日晚上的心慌时刻",
  titleKey: "gameplay.sceneTitles.inner_05",
  sceneImage: "/scenarios/inner_05.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "周日傍晚 18:00。夕阳西下，原本美好的周末余晖，此刻在你眼里却变成了“末日倒计时”。",
      textKey: "gameplay.dialogues.inner_05.opening.1"
    },
    {
      type: "narrator",
      text: "明明此时此刻你还在家里，并没有人在骂你，也没有任务在追你。但只要一想到明天早上的闹钟、那个严肃的早会、还有那个还没达标的KPI，你的胃就开始隐隐作痛。",
      textKey: "gameplay.dialogues.inner_05.opening.2"
    },
    {
      type: "narrator",
      text: "这种莫名的恐慌像一张网，把你还没过完的最后几个小时周末彻底勒死了。你的心跳在加速，呼吸变得短浅。",
      textKey: "gameplay.dialogues.inner_05.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "bystander_choice",
        label: "不想面对（麻痹逃避）",
        labelKey: "gameplay.options.inner_05.bystander",
        archetype: "旁观者",
        visualEffect: "red", // 海底轮 (冷漠/放弃)
        followUp: [
          {
            type: "narrator",
            text: "“上班如上坟，人生真没劲。”你瘫在沙发上，感觉身体像灌了铅一样重。",
            textKey: "gameplay.dialogues.inner_05.survival.bystander.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（眼神呆滞）不想动，不想洗澡，不想说话。最好明天永远别来，让我就在这里石化吧。",
            textKey: "gameplay.dialogues.inner_05.survival.bystander.2" 
          },
          {
            type: "failure",
            text: "你开启了“行尸走肉”模式，用一种低能量的对抗消耗了所有生机。周一早上，你是被闹钟“拖”起来的，还没开始工作，你的灵魂就已经累了。",
            textKey: "gameplay.dialogues.inner_05.survival.bystander.3" 
          }
        ]
      },
      {
        id: "coward_choice",
        label: "脑补灾难（恐惧焦虑）",
        labelKey: "gameplay.options.inner_05.coward",
        archetype: "懦夫",
        visualEffect: "red", // 海底轮 (恐惧)
        followUp: [
          {
            type: "narrator",
            text: "你的大脑开始自动播放一部名为《明天完蛋了》的恐怖片。",
            textKey: "gameplay.dialogues.inner_05.survival.coward.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（来回踱步，咬指甲）老板明天肯定会问那个数据，我还没整理好……万一答不上来，他会不会当众骂我？万一这月绩效垫底，我会不会被裁员？",
            textKey: "gameplay.dialogues.inner_05.survival.coward.2" 
          },
          {
            type: "failure",
            text: "你在这种灾难性的想象中瑟瑟发抖，导致严重的失眠。你是在用今天的安宁，去预支明天的烦恼，而且还是加倍偿还。",
            textKey: "gameplay.dialogues.inner_05.survival.coward.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：哪怕是为了那杯免费咖啡",
      titleKey: "gameplay.directorNote.inner_05.title",
      contentKey: "gameplay.directorNote.inner_05.content",
      content: `亲爱的导演，你现在是不是觉得自己正坐在刑场上等待行刑？

这就是著名的“周日焦虑症”。
在这个剧本里，你的“懦夫”（恐惧，能量 100）是一个糟糕的时间旅行者。他强行把你从安全的“现在”，拖到了充满了未知的“未来”。他在你的脑海里构建了一个虚拟的审判庭，而你已经提前判了自己死刑。焦虑，就是你为尚未发生的麻烦，预付的高额利息。

另一边的“旁观者”（冷漠，能量 50）则试图通过“装死”来逃避痛苦。他让你觉得工作是牢笼，而你无力改变，只能混吃等死。

但请按下【暂停的锚点】。
环顾四周。此时此刻，有人在骂你吗？没有。天塌了吗？没有。
你的身体是安全的，你坐在自己柔软的沙发上。

现在，请邀请“庆祝者”（喜悦，能量 540） 登场。
庆祝者有一个神奇的遥控器，叫“感恩”。
恐惧关注的是“我可能会失去什么”，而感恩关注的是“我现在拥有什么”。
当你的聚光灯打在“恐惧”上时，阴影就会无限放大。现在，我们要强行切换频道。
即使工作再烂，里面也一定藏着哪怕微小的礼物。
也许是茶水间那台昂贵的咖啡机？也许是那个总给你带零食的同事？也许仅仅是这份薪水支撑了你热爱的一顿晚餐？
只要你能找出三个值得庆祝的点，恐惧就会在感恩的光芒下无处遁形。
因为大脑无法同时处理“感激”和“恐惧”。当你开始数算恩典，你就赢了。`
    },
    creativeOption: {
      id: "celebrator_choice",
      label: "寻找小确幸（转换视角）",
      labelKey: "gameplay.options.inner_05.creative",
      archetype: "庆祝者",
      visualEffect: "indigo", // 眉心轮 (喜悦/感恩)
      followUp: [
        {
          type: "narrator",
          text: "你强行打断了大脑里的恐怖片放映，深吸一口气，开始玩一个名为“寻找礼物”的游戏。",
          textKey: "gameplay.dialogues.inner_05.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（微笑）好吧，虽然明天有压力，但至少公司的空调很足，楼下的便当很好吃，还有小王讲的笑话真的很烂很好笑。",
          textKey: "gameplay.dialogues.inner_05.creative.2"
        },
        {
          type: "narrator",
          text: "当你开始列举这些微小的“拥有”时，紧绷的胃部神奇地舒展开了。你把聚光灯从“未知的恐惧”移向了“确定的拥有”。",
          textKey: "gameplay.dialogues.inner_05.creative.3"
        },
        {
          type: "success",
          text: "焦虑是对未来的预支，感恩是把能量拉回当下。今晚，你不再是那个等待受审的囚犯，你是那个享受当下安宁的普通人。晚安，明天又是新的一天。",
          textKey: "gameplay.dialogues.inner_05.creative.4"
        }
      ]
    }
  }
};

// 46. 容貌焦虑（照镜子） (Inner 06)
export const innerBodyImageScript: ScenarioScript = {
  id: "inner_06",
  title: "镜子里的陌生人",
  titleKey: "gameplay.sceneTitles.inner_06",
  sceneImage: "/scenarios/inner_06.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "浴室里惨白的顶灯打在镜子上，像是一台无情的显微镜。",
      textKey: "gameplay.dialogues.inner_06.opening.1"
    },
    {
      type: "narrator",
      text: "你准备洗澡，脱下衣服的瞬间，目光被镜子里的某个细节刺痛了：也许是眼角新多出的一道细纹，也许是腰间松弛的一圈赘肉，或者是发际线后退的痕迹。",
      textKey: "gameplay.dialogues.inner_06.opening.2"
    },
    {
      type: "narrator",
      text: "那一刻，曾经那个年轻、紧致的形象在你脑海中崩塌。你看着镜子里的人，感到陌生、恐慌，甚至有一丝厌恶。",
      textKey: "gameplay.dialogues.inner_06.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "嫌弃回避（羞愧掩藏）",
        labelKey: "gameplay.options.inner_06.invisible",
        archetype: "隐形人",
        visualEffect: "red", // 海底轮 (羞愧/生存)
        followUp: [
          {
            type: "narrator",
            text: "你下意识地用手捏住那块赘肉，仿佛那是长在你身上的肿瘤，恨不得把它割掉。",
            textKey: "gameplay.dialogues.inner_06.survival.invisible.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（迅速关掉顶灯，只留昏暗的灯带）太丑了，真的太丑了。我怎么变成这副鬼样子了？没法看了。",
            textKey: "gameplay.dialogues.inner_06.survival.invisible.2" 
          },
          {
            type: "failure",
            text: "你在黑暗中匆匆洗完澡，甚至不敢触碰自己的身体。这种深深的羞耻感让你与自己的身体彻底断联，你把它当成了一个让你丢脸的累赘，而不是承载灵魂的殿堂。",
            textKey: "gameplay.dialogues.inner_06.survival.invisible.3" 
          }
        ]
      },
      {
        id: "coward_choice",
        label: "疯狂搜医美（恐惧衰老）",
        labelKey: "gameplay.options.inner_06.coward",
        archetype: "懦夫",
        visualEffect: "red", // 海底轮 (恐惧)
        followUp: [
          {
            type: "narrator",
            text: "恐慌瞬间攫住了你的心脏。“如果我老了，是不是就没人爱了？是不是就失去价值了？”",
            textKey: "gameplay.dialogues.inner_06.survival.coward.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（抓起手机疯狂搜索）抗皱精华、热玛吉、抽脂手术……不管多少钱，我都要把青春买回来！",
            textKey: "gameplay.dialogues.inner_06.survival.coward.2" 
          },
          {
            type: "failure",
            text: "你试图用金钱和技术来对抗自然规律。这种源于恐惧的“保养”，本质上是一种焦虑的挣扎。你依然无法接受当下的自己，你的美丽建立在摇摇欲坠的玻尿酸之上。",
            textKey: "gameplay.dialogues.inner_06.survival.coward.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：身体是你的圣殿，不是展品",
      titleKey: "gameplay.directorNote.inner_06.title",
      contentKey: "gameplay.directorNote.inner_06.content",
      content: `亲爱的导演，请看着镜子，别移开目光。

此时此刻，在这个狭小的浴室里，你的“隐形人”（羞愧，能量 20）正在对你的身体进行最恶毒的霸凌。他觉得如果不完美，就没有存在的权利。
而“懦夫”（恐惧，能量 100）正在尖叫着试图逃离时间的追捕。他相信你的价值只停留在表皮层，一旦胶原蛋白流失，爱也会随之流失。

但这是真的吗？
这具身体，陪你熬过大夜，陪你跑过长跑，在你生病时拼命修复，在你心碎时默默承载。它是你在这个物质世界唯一的战友，唯一的家。
而你，作为它的主人，却因为一点点岁月的痕迹而嫌弃它、攻击它。想想看，如果你的细胞能听懂你的念头，它们该有多伤心？

只有当你自己嫌弃自己的时候，别人的眼光（甚至是镜子的反光）才会刺痛你。
任何对抗都会留下痕迹，唯有爱能抚平一切。
美不是没有瑕疵的塑料模特，美是生机勃勃，是阅历，是真实。

现在，请按下【暂停的锚点】。
不要关灯，不要躲避。
走近镜子，直到你能看清自己的瞳孔。
那是“疗愈者”（爱，能量 500）居住的地方。
把你的手放在那道皱纹上，或者是那块柔软的肉上。感受它的温度。
对自己说：“谢谢你。谢谢你保护我。我爱你本来的样子。”
当你的身体被爱充满，它会回报你一种化妆品无法给予的光彩。`
    },
    creativeOption: {
      id: "healer_choice",
      label: "凝视并感谢身体（爱与接纳）",
      labelKey: "gameplay.options.inner_06.creative",
      archetype: "疗愈者",
      visualEffect: "indigo", // 眉心轮 (爱/疗愈)
      followUp: [
        {
          type: "narrator",
          text: "你没有移开视线，而是往前走了一步，直到鼻尖几乎碰到镜子。你看着那道细纹，就像看着一本书的折痕。",
          textKey: "gameplay.dialogues.inner_06.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（轻抚眼角，温柔地）这条纹路，好像是那年笑得太开心留下的。这肚子上的肉，是因为最近吃得太好了吧。嘿，谢谢你们陪着我。",
          textKey: "gameplay.dialogues.inner_06.creative.2"
        },
        {
          type: "narrator",
          text: "你看着镜子里的眼睛，认真地说了一句：“我爱你。” 就在那一瞬间，镜子里的人仿佛变得柔和了，那种紧绷的敌意消融了。",
          textKey: "gameplay.dialogues.inner_06.creative.3"
        },
        {
          type: "success",
          text: "你开始享受洗澡的过程，感受水流滑过皮肤的触感。你不再把身体看作一个需要修补的破损物件，而是一座神圣的殿堂。今晚，你在爱中沐浴。",
          textKey: "gameplay.dialogues.inner_06.creative.4"
        }
      ]
    }
  }
};

// 47. 无聊/无意义感 (Inner 07)
export const innerBoredomScript: ScenarioScript = {
  id: "inner_07",
  title: "午后的灰色真空",
  titleKey: "gameplay.sceneTitles.inner_07",
  sceneImage: "/scenarios/inner_07.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "这是一个没有什么特别安排的周末午后。阳光虽然很好，但照不进你心里的那层雾。",
      textKey: "gameplay.dialogues.inner_07.opening.1"
    },
    {
      type: "narrator",
      text: "你躺在沙发上，盯着天花板上的一个黑点发呆。书架上有书，你不想看；手机里有消息，你不想回；窗外有风景，你不想动。",
      textKey: "gameplay.dialogues.inner_07.opening.2"
    },
    {
      type: "narrator",
      text: "一种沉重的、粘稠的无意义感像沼泽一样包裹着你。你感觉自己像是一个被抽走了灵魂的行尸走肉，脑海里不断盘旋着那个致命的问题：“活着到底是图什么？反正最后都是一场空。”",
      textKey: "gameplay.dialogues.inner_07.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "bystander_choice",
        label: "就这样吧（彻底躺平）",
        labelKey: "gameplay.options.inner_07.bystander",
        archetype: "旁观者",
        visualEffect: "red", // 海底轮 (冷漠/能量阻滞)
        followUp: [
          {
            type: "narrator",
            text: "“算了，动了也没用，反正干什么都没劲。”你任由身体沉入沙发的深处，仿佛要融化在那片灰色的虚无里。",
            textKey: "gameplay.dialogues.inner_07.survival.bystander.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（双眼无神）人类就是地球上的寄生虫，我这种废物还是别折腾了，就这样烂着吧。",
            textKey: "gameplay.dialogues.inner_07.survival.bystander.2" 
          },
          {
            type: "failure",
            text: "你切断了与生命源头的所有连接，把自己锁进了一个名为“冷漠”的安全屋。虽然你避免了失败和痛苦，但也成功屏蔽了阳光和氧气。你的生命力正在以一种肉眼不可见的速度枯萎。",
            textKey: "gameplay.dialogues.inner_07.survival.bystander.3" 
          }
        ]
      },
      {
        id: "addict_choice",
        label: "找点刺激（麻痹感知）",
        labelKey: "gameplay.options.inner_07.addict",
        archetype: "瘾君子",
        visualEffect: "orange", // 脐轮 (欲望/刺激)
        followUp: [
          {
            type: "narrator",
            text: "这种安静让你感到恐慌，你必须弄出点动静来填满这个真空。",
            textKey: "gameplay.dialogues.inner_07.survival.addict.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（抓起游戏手柄，打开啤酒）太无聊了，杀两盘游戏，喝两口酒，只要脑子不转就不难受了。",
            textKey: "gameplay.dialogues.inner_07.survival.addict.2" 
          },
          {
            type: "failure",
            text: "你成功地用感官的强刺激掩盖了心灵的空洞。但在游戏结束、酒精退去的那一刻，那份空虚感会像回旋镖一样，以加倍的力量击中你。你依然没有找到活着的实感。",
            textKey: "gameplay.dialogues.inner_07.survival.addict.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：无聊是因为你与生命失联了",
      titleKey: "gameplay.directorNote.inner_07.title",
      contentKey: "gameplay.directorNote.inner_07.content",
      content: `亲爱的导演，请不要轻视这种“百无聊赖”的感觉。这其实是一个非常关键的信号灯。

当你觉得“无聊”或“没意思”时，通常意味着你内在的“旁观者”（冷漠，能量 50）正在掌镜。他将世界的色彩调成了黑白，拉下了心灵的百叶窗，告诉你：“外面没什么好看的，你也做不了什么。” 这是一种极低能量的自我保护机制——通过降低对生命的期待，来避免可能的失望。
而为了对抗这种死寂，“瘾君子”（欲望，能量 125）会试图把你拉向另一个极端——通过高分贝的噪音、酒精或游戏，来制造一种“我还活着”的假象。

但这两种方式，都是在逃避“当下”。
无聊的本质，不是因为没事可做，而是因为你与生命失去了“连接”。你人在此时此地，但你的心却关闭了接收器。
当连接断裂时，哪怕你站在巴黎铁塔下也会觉得无聊；当连接建立时，哪怕只是看着一粒灰尘在阳光下飞舞，你也会感动得热泪盈眶。

现在的解药，不是去找更多的事做（Doing），而是去练习“存在”（Being）。
请按下【暂停的锚点】。
不需要宏大的意义，不需要拯救世界。
只需要去重新建立一个微小的连接。

请邀请“庆祝者”（喜悦，能量 540） 登场。
庆祝者知道，生命力不藏在远方，它藏在细节里。
神性就藏在微尘之中。
从沙发上起来，不是为了去完成什么任务，而是去进行一次微型的朝圣。
去给自己煮一杯咖啡，不是为了喝，而是去全神贯注地闻那个香气，听水沸腾的声音。
去楼下公园，不是为了锻炼，而是去找一朵你从来没注意过的小花，蹲下来，仔细看它的花瓣纹理，看它如何在风中颤抖。
在这个凝视的瞬间，你会突然发现，那朵花是活的，你也是活的。你们共享着同一个生命。
这种“看见”，就是庆祝。这种“临在”，就是意义。
活着本身就是意义，不需要额外的注脚。当你开始庆祝呼吸，无聊就变成了静谧的狂喜。`
    },
    creativeOption: {
      id: "celebrator_choice",
      label: "庆祝微小的存在（重建连接）",
      labelKey: "gameplay.options.inner_07.creative",
      archetype: "庆祝者",
      visualEffect: "indigo", // 眉心轮 (喜悦/连接)
      followUp: [
        {
          type: "narrator",
          text: "你没有继续躺着，也没有去抓手机。你深吸一口气，站了起来，决定去“看”点什么。",
          textKey: "gameplay.dialogues.inner_07.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（走到窗前，看着一棵树）嘿，原来你已经长出新芽了啊。阳光照在你叶子上的样子，真好看。",
          textKey: "gameplay.dialogues.inner_07.creative.2"
        },
        {
          type: "narrator",
          text: "你给自己泡了一杯茶，全神贯注地感受茶杯的温度，嗅着茶香，看着热气在光线中缭绕。你突然觉得，这一刻好安静，好丰富。",
          textKey: "gameplay.dialogues.inner_07.creative.3"
        },
        {
          type: "success",
          text: "那层灰色的膜消失了。你发现世界一直都很精彩，只是你之前忘了打开开关。你在这个简单的午后，通过一杯茶、一片叶子，重新爱上了生活。",
          textKey: "gameplay.dialogues.inner_07.creative.4"
        }
      ]
    }
  }
};

// 48. 对未来的恐惧 (Inner 08)
export const innerFutureFearScript: ScenarioScript = {
  id: "inner_08",
  title: "午夜的未来审判",
  titleKey: "gameplay.sceneTitles.inner_08",
  sceneImage: "/scenarios/inner_08.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "万籁俱寂的深夜，你原本已经有了睡意，却被大脑中突然弹出的一个念头惊醒。",
      textKey: "gameplay.dialogues.inner_08.opening.1"
    },
    {
      type: "narrator",
      text: "“如果行业风向变了，我失业了怎么办？”这个念头就像第一块倒下的多米诺骨牌，引发了一连串的灾难性联想：“如果生了重病没钱治怎么办？如果最后我也像新闻里那样孤独终老怎么办？”",
      textKey: "gameplay.dialogues.inner_08.opening.2"
    },
    {
      type: "narrator",
      text: "未来的不确定性像一只巨大的黑手，死死扼住了你的喉咙。你在温暖的被窝里，却感到全身发冷，心跳如雷。",
      textKey: "gameplay.dialogues.inner_08.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "coward_choice",
        label: "越想越怕（灾难化联想）",
        labelKey: "gameplay.options.inner_08.coward",
        archetype: "懦夫",
        visualEffect: "red", // 海底轮 (恐惧)
        followUp: [
          {
            type: "narrator",
            text: "恐惧劫持了你的杏仁核。你开始疯狂搜索“裁员赔偿标准”、“重疾险条款”和“孤独死的征兆”。",
            textKey: "gameplay.dialogues.inner_08.survival.coward.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（全身紧绷，冷汗直流）完了，感觉每一条都对上了。我的未来一片黑暗，根本没有出路。",
            textKey: "gameplay.dialogues.inner_08.survival.coward.2" 
          },
          {
            type: "failure",
            text: "直到天亮，你都没有合眼。你被并没有发生的未来吓得魂飞魄散，不仅没有找到解决办法，还透支了应对现实的精力。你亲手制造了一个名为“绝望”的地狱。",
            textKey: "gameplay.dialogues.inner_08.survival.coward.3" 
          }
        ]
      },
      {
        id: "victim_choice",
        label: "听天由命（无力感）",
        labelKey: "gameplay.options.inner_08.victim",
        archetype: "受害者",
        visualEffect: "red", // 海底轮 (悲伤/无力)
        followUp: [
          {
            type: "narrator",
            text: "一种深深的无力感席卷了你。你觉得在大时代的浪潮下，自己就像一片浮萍，毫无掌控力。",
            textKey: "gameplay.dialogues.inner_08.survival.victim.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（叹气，把自己裹紧）既然命运不可控，那就这样吧。反正努力也没用，这就是命苦。",
            textKey: "gameplay.dialogues.inner_08.survival.victim.2" 
          },
          {
            type: "failure",
            text: "你放弃了主观能动性，躺在床上等待“审判”降临。这种消极的自我暗示会真的削弱你的气场，让你更容易吸引来你所恐惧的那些负面结果。",
            textKey: "gameplay.dialogues.inner_08.survival.victim.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：恐惧是对未来的预支",
      titleKey: "gameplay.directorNote.inner_08.title",
      contentKey: "gameplay.directorNote.inner_08.content",
      content: `亲爱的导演，请看看窗外。
现在是深夜，外面没有洪水猛兽，没有失业通知单，没有病危通知书。
在这个房间里，只有你，和你平稳的呼吸。
那个让你瑟瑟发抖的“地狱”，并不存在于现实中，它只存在于你的想象里。

这就是“懦夫”（恐惧，能量 100）最擅长的把戏。他是一个极具天赋的恐怖片编剧。他利用信息的不确定性，为你编织了一个最糟糕的剧本，并强迫你一遍遍观看。他告诉你：“如果不焦虑，灾难就会降临。”
而“受害者”（悲伤，能量 75）则在旁边煽风点火，让你相信你是一片无助的树叶，只能等待暴风雨的摧残。

但请记住这句话：恐惧，是对不存在之事的相信。
焦虑，是你为尚未发生的麻烦，提前支付的高昂利息。
你之所以感到无力，是因为你试图用现在的头脑，去解决未来十年的问题。这在物理上是不可能的。

现在，请按下【暂停的锚点】。
把手放在胸口，感受心脏的跳动。
问自己一个极其重要的问题：“此时此刻，我安全吗？”
答案是肯定的。此时此刻，你很安全。被子是暖的，空气是流通的。

然后，请邀请“实干家”（意愿，能量 250/310）进场。
实干家是对抗焦虑最强大的解药，因为行动能杀死恐惧。
实干家不会去思考“十年后怎么办”，他只思考“明天早上我能做的最小的一件事是什么？”
如果是担心健康，那么最小的事是“明天早起喝一杯水”或“预约一个体检”。
如果是担心失业，那么最小的事是“明天整理一下简历”或“存入一笔备用金”。
当你把巨大的、虚幻的“未来恐惧”，拆解为具体的、当下的“微小行动”时，掌控感就回来了。
只要你照顾好每一个“当下”，未来自然会照顾好它自己。
做你能做的，剩下的，交给宇宙。`
    },
    creativeOption: {
      id: "doer_choice",
      label: "回归当下做计划（具体行动）",
      labelKey: "gameplay.options.inner_08.creative",
      archetype: "实干家",
      visualEffect: "green", // 心轮 (意愿/行动)
      followUp: [
        {
          type: "narrator",
          text: "你猛地坐起来，打断了大脑里的恐怖循环。你打开床头灯，拿出了笔记本。",
          textKey: "gameplay.dialogues.inner_08.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（眼神清明）恐惧解决不了问题，但行动可以。既然担心财务，那我从明天开始每月多存10%；既然担心健康，明天就开始晨跑。",
          textKey: "gameplay.dialogues.inner_08.creative.2"
        },
        {
          type: "narrator",
          text: "你在纸上写下了三条明天可以立即执行的具体行动。哪怕只是很小的一步，当你写下它们时，那团巨大的黑影瞬间消散了。",
          textKey: "gameplay.dialogues.inner_08.creative.3"
        },
        {
          type: "success",
          text: "你重新躺回床上，这次感到的是一种脚踏实地的安全感。你知道未来依然充满未知，但你已经握住了应对未知的剑——那就是当下的行动。你安然入睡。",
          textKey: "gameplay.dialogues.inner_08.creative.4"
        }
      ]
    }
  }
};

// 49. 过去的回忆攻击 (Inner 09)
export const innerMemoryAttackScript: ScenarioScript = {
  id: "inner_09",
  title: "午夜的回忆子弹",
  titleKey: "gameplay.sceneTitles.inner_09",
  sceneImage: "/scenarios/inner_09.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "你正在洗碗，或者在路上走着，毫无预兆地，一段来自五年前的记忆像一颗子弹一样击中了你。",
      textKey: "gameplay.dialogues.inner_09.opening.1"
    },
    {
      type: "narrator",
      text: "那是你在一次重要聚会上说错的一句蠢话，或者是那次让你甚至想换个星球生活的尴尬失败。那个场景如此清晰，仿佛就发生在刚才。",
      textKey: "gameplay.dialogues.inner_09.opening.2"
    },
    {
      type: "narrator",
      text: "一种滚烫的羞耻感瞬间从脚底直冲天灵盖。你的身体本能地抽搐了一下，甚至忍不住“啊！”地叫出了声，试图用声音把那个画面从脑海里物理驱赶出去。",
      textKey: "gameplay.dialogues.inner_09.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "invisible_choice",
        label: "恨不得消失（极度羞愧）",
        labelKey: "gameplay.options.inner_09.invisible",
        archetype: "隐形人",
        visualEffect: "red", // 海底轮 (羞愧)
        followUp: [
          {
            type: "narrator",
            text: "你僵在原地，全身肌肉紧绷，恨不得立刻找个地缝钻进去，或者拥有时光机穿越回去掐死当年的自己。",
            textKey: "gameplay.dialogues.inner_09.survival.invisible.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（抱头蹲下）太丢人了，太丢人了！所有人肯定都记得那一幕，我这辈子都洗不白了。",
            textKey: "gameplay.dialogues.inner_09.survival.invisible.2" 
          },
          {
            type: "failure",
            text: "羞愧感像强酸一样腐蚀着你的自信。你试图通过“抹杀过去”来保护自己，但越是抗拒，那个画面就越是顽固。你被困在了一个早已不存在的时间点里，无法自拔。",
            textKey: "gameplay.dialogues.inner_09.survival.invisible.3" 
          }
        ]
      },
      {
        id: "sinner_choice",
        label: "疯狂鞭尸（自我攻击）",
        labelKey: "gameplay.options.inner_09.sinner",
        archetype: "罪人",
        visualEffect: "red", // 海底轮 (内疚)
        followUp: [
          {
            type: "narrator",
            text: "你的大脑开始疯狂反刍，像重播一段受刑录像一样，反复播放那个尴尬瞬间。",
            textKey: "gameplay.dialogues.inner_09.survival.sinner.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（咬牙切齿）我真是个蠢货！当时脑子进水了吗？为什么会说那种话？我就是个无可救药的笨蛋。",
            textKey: "gameplay.dialogues.inner_09.survival.sinner.2" 
          },
          {
            type: "failure",
            text: "你对过去的自己进行了残酷的审判和鞭尸。通过这种自我攻击，你似乎获得了一种“我已经知道错了”的虚假安慰，但代价是你的自尊心被打得粉碎，你的能量瞬间跌至谷底。",
            textKey: "gameplay.dialogues.inner_09.survival.sinner.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：那只是一部下档的旧电影",
      titleKey: "gameplay.directorNote.inner_09.title",
      contentKey: "gameplay.directorNote.inner_09.content",
      content: `亲爱的导演，深呼吸。请看看你的四周。
那个尴尬的聚会还在进行吗？那些嘲笑你的人还在眼前吗？
没有。这里只有你，还有也许正在流水的龙头。

刚刚发生的，是一次大脑的“时空错乱”。
你的“隐形人”（羞愧，能量 20）试图通过“消失”来逃避那种被评判的痛楚。他相信，只要把自己藏起来，那个错误就不存在了。
而“罪人”（内疚，能量 30）则是一个严厉的狱卒。他认为，只有通过不断地自我惩罚，才能为过去的错误赎罪。他一遍遍地回放那个镜头，强迫你看着那个“愚蠢”的自己，直到你承认自己一无是处。

但请看清真相：那已经不再是“你”了。
那只是你曾经扮演过的一个角色，穿着五年前的戏服，说着五年前的台词。
那个时刻已经死亡，已经化作了宇宙中的尘埃。唯一让它起死回生、并在此时此刻继续伤害你的，是你现在的“关注”。是你，作为现在的导演，同意了在你的大脑影院里，重映这部名为《尴尬时刻》的恐怖片。

现在，请按下【暂停的锚点】。
回到当下。感受脚底的地面。
告诉自己：“那不是我，那只是一个记忆。我现在在这里，我很安全。”

然后，请邀请“和平的观察者”（和平，能量 600）进场。
观察者拥有一种慈悲的抽离感。他坐在观众席的最后排，看着屏幕上那个手足无措的年轻人。
他不会嘲笑，也不会评判。他只会看到一个正在努力学习、正在经历成长的灵魂。
试着用观察者的眼光看着那个过去的自己，对他/她说一句：“嘿，谢谢你当时的表演。我知道你那时尽力了，你也只是想被爱、被认可。没关系，戏演完了，你可以下台了。”
不要试图去修改那部电影，也不要试图去销毁它。只是看着它，允许它存在，然后——切断电源。
不再给它输送情绪的能量，屏幕自然会黑下去。
你不再是那个拙劣的演员，你是现在这位成熟、宽容的导演。不要让早已下档的旧电影，占据你现在的黄金排片表。`
    },
    creativeOption: {
      id: "observer_choice",
      label: "像看老电影一样观看（慈悲抽离）",
      labelKey: "gameplay.options.inner_09.creative",
      archetype: "和平的观察者",
      visualEffect: "violet", // 顶轮 (和平/超脱)
      followUp: [
        {
          type: "narrator",
          text: "你没有把记忆推开，也没有陷进去。你深吸一口气，像是退后了一步，站在了一个旁观者的位置。",
          textKey: "gameplay.dialogues.inner_09.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（嘴角带着一丝宽容的微笑）啊，是那场戏啊。那个年轻的我真是太紧张了，但他当时真的尽力想表现得好了。",
          textKey: "gameplay.dialogues.inner_09.creative.2"
        },
        {
          type: "narrator",
          text: "你看着那个尴尬的画面，就像看着一部年代久远的黑白默片。那里的情绪无法再穿透屏幕刺痛你。你对着那个过去的影像挥了挥手：“谢谢你，再见。”",
          textKey: "gameplay.dialogues.inner_09.creative.3"
        },
        {
          type: "success",
          text: "那个画面闪烁了一下，慢慢淡去。羞耻感消散了，取而代之的是一种深深的宁静。你意识到，过去定义不了你，除非你允许它这么做。你继续洗碗，哼起了一首轻快的歌。",
          textKey: "gameplay.dialogues.inner_09.creative.4"
        }
      ]
    }
  }
};

// 50. 不知道自己是谁 (Inner 10)
export const innerIdentityCrisisScript: ScenarioScript = {
  id: "inner_10",
  title: "面具碎裂的时刻",
  titleKey: "gameplay.sceneTitles.inner_10",
  sceneImage: "/scenarios/inner_10.jpg",
  openingDialogues: [
    {
      type: "narrator",
      text: "这是一个寻常的深夜，或者一个喧闹聚会后的瞬间。你突然停了下来，就像一台高速运转的机器突然被切断了电源。",
      textKey: "gameplay.dialogues.inner_10.opening.1"
    },
    {
      type: "narrator",
      text: "你看着镜子里的自己，或者看着名片上的头衔，一种巨大的陌生感和荒谬感袭来。你是谁？是那个优秀的员工？是那个尽职的父母？还是那个体贴的伴侣？",
      textKey: "gameplay.dialogues.inner_10.opening.2"
    },
    {
      type: "narrator",
      text: "如果你剥离掉这些角色，剥离掉名字、职业、关系……还剩下什么？一个巨大的、空洞的问号悬浮在空气中：“我是谁？我真正想要什么？”这阵眩晕感让你感到脚下的地板都在消失。",
      textKey: "gameplay.dialogues.inner_10.opening.3"
    }
  ],
  options: {
    survivalOptions: [
      {
        id: "performer_choice",
        label: "抓取更多标签（恐慌修补）",
        labelKey: "gameplay.options.inner_10.performer",
        archetype: "演员",
        visualEffect: "yellow", // 太阳神经丛 (骄傲/小我身份)
        followUp: [
          {
            type: "narrator",
            text: "面具的碎裂让“演员”感到极度恐慌。为了填补这种身份的真空，你试图抓取更多外在的标签来定义自己。",
            textKey: "gameplay.dialogues.inner_10.survival.performer.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（慌乱地翻看日程表）我不能胡思乱想。我要去考那个证，我要去争取那个职位，只要我变得更强，我就知道我是谁了。",
            textKey: "gameplay.dialogues.inner_10.survival.performer.2" 
          },
          {
            type: "failure",
            text: "你试图用更厚重的面具来掩盖内在的虚无。你可能会获得更多的头衔，但那个深夜的疑问会像幽灵一样，永远在后台游荡，让你感到深深的、无法言说的异化。",
            textKey: "gameplay.dialogues.inner_10.survival.performer.3" 
          }
        ]
      },
      {
        id: "invisible_choice",
        label: "觉得自己空心（绝望虚无）",
        labelKey: "gameplay.options.inner_10.invisible",
        archetype: "隐形人",
        visualEffect: "red", // 海底轮 (羞愧/存在危机)
        followUp: [
          {
            type: "narrator",
            text: "你看着剥离了角色的自己，觉得里面空空如也，像一个没有馅的包子。",
            textKey: "gameplay.dialogues.inner_10.survival.invisible.1" 
          },
          {
            type: "npc",
            speaker: "你",
            speakerKey: "gameplay.characters.you",
            text: "（瘫软在地，眼神空洞）原来我什么都不是。我只是在演戏，真正的我根本不存在。这太可悲了。",
            textKey: "gameplay.dialogues.inner_10.survival.invisible.2" 
          },
          {
            type: "failure",
            text: "你陷入了虚无主义的黑洞。你误以为“空”就是“无价值”，这让你感到深深的羞耻和绝望。你不敢面对这个真相，只能把自己藏得更深。",
            textKey: "gameplay.dialogues.inner_10.survival.invisible.3" 
          }
        ]
      }
    ],
    directorNote: {
      title: "导演手记：你是舞台，而非演员",
      titleKey: "gameplay.directorNote.inner_10.title",
      contentKey: "gameplay.directorNote.inner_10.content",
      content: `亲爱的导演，恭喜你。
你可能会觉得奇怪，为什么要恭喜这种令人恐慌的迷茫？
因为，这不仅仅是一次危机，这是一次神圣的“觉醒”。

当你问出“我是谁”的时候，意味着你已经开始从那场沉浸了数十年的大梦中醒来。
在这个舞台上，你的“演员”（骄傲，能量 175）一直在试图通过扮演完美的角色来证明“我存在”。
你的“隐形人”（羞愧，能量 20）一直在恐惧如果角色演砸了，“我”就会消失。
他们都以为，自己就是那个角色。

但此刻，那份迷茫告诉你：你不是他们。
如果那是你，你怎么能观察到他们的碎裂？
如果你是那件衣服，脱下衣服后，你又怎么会还在思考？

这里有一个终极的秘密，也是我们整个旅程的终点：
你不是任何一个“人格”。你不是那个焦虑的员工，不是那个完美的父母，甚至不是那个正在思考“我是谁”的声音。
你是那个 觉察 到这一切的存在。
你是那个看着“焦虑”升起又落下的人。
你是那个看着“面具”戴上又摘下的人。
你是那个让整场戏剧得以发生的、无限的、宁静的“舞台空间”本身。

在这个层面上，我们邀请“开悟者”（开悟，能量 700+）进场。
这是你内在最高维度的智慧。
不要急着去填补那个“空”。那个“空”不是虚无，它是无限的可能性。它是天空，而角色只是飘过的云。
安住于这份“我不知道”的静默之中。不要惊慌，不要抓取。
就在这个“我不知道”里，你终于回到了家。
你不需要成为任何人，因为你已经是万物。
这就是那个“我是”（I AM）。`
    },
    creativeOption: {
      id: "enlightened_choice",
      label: "安住于“我是”（觉知觉醒）",
      labelKey: "gameplay.options.inner_10.creative",
      archetype: "开悟者",
      visualEffect: "violet", // 顶轮 (开悟/合一)
      followUp: [
        {
          type: "narrator",
          text: "你没有逃避这份迷茫，也没有试图用逻辑去解答它。你只是静静地坐着，允许这份“不知道”存在。",
          textKey: "gameplay.dialogues.inner_10.creative.1"
        },
        {
          type: "npc",
          speaker: "你",
          speakerKey: "gameplay.characters.you",
          text: "（闭上眼睛，感受呼吸）我不是这些角色……我是看着这些角色的“那个”。我是此时此刻的呼吸，我是这份宁静的觉知。",
          textKey: "gameplay.dialogues.inner_10.creative.2"
        },
        {
          type: "narrator",
          text: "在这个瞬间，一种超越了喜悦、超越了悲伤的深邃和平（Peace）从你心底升起。你感到自己像天空一样广阔，所有的标签都只是飘过的云彩。",
          textKey: "gameplay.dialogues.inner_10.creative.3"
        },
        {
          type: "success",
          text: "你不需要知道“我是谁”，因为你就是“存在”本身。你重新睁开眼睛，看着这个世界，仿佛第一次看见。你拿起那个角色的面具，微笑着戴上——这次，你知道你在演戏，你是一个自由的玩家。",
          textKey: "gameplay.dialogues.inner_10.creative.4"
        }
      ]
    }
  }
};

// ========== 场景导出 (Export) ==========

export const scenarios: Record<string, ScenarioScript> = {
  // Office
  office_01: officeBlameScript,
  office_02: officeSalaryScript,
  office_03: officeSickLeaveScript,
  office_04: officeCreditScript,
  office_05: officeOvertimeScript,
  office_06: officeMistakeScript,
  office_07: officeGossipScript,
  office_08: officePublicSpeakingScript,
  office_09: officeMicromanageScript,
  office_10: officePromotionJealousyScript,
  
  // Home
  home_01: homeHouseworkScript,
  home_02: homeAnniversaryScript,
  home_03: homeListeningScript,
  home_04: homeFinancialScript,
  home_05: homeTrustScript,
  home_06: homeInLawConflictScript,
  home_07: homeIntimacyScript,
  home_08: homeControlFreakScript,
  home_09: homeLateScript,
  home_10: homeEmotionalBlackmailScript,
  
  // Parent
  parent_01: parentHomeworkScript,
  parent_02: parentTantrumScript,
  parent_03: parentScreenAddictionScript,
  parent_04: parentComparisonScript,
  parent_05: parentAdolescentRebellionScript,
  parent_06: parentChildLyingScript,
  parent_07: parentPickyEaterScript,
  parent_08: parentSeparationAnxietyScript,
  parent_09: parentInterestClassScript,
  parent_10: parentBusyWorkScript,
  
  // Social
  social_01: socialLendingScript,
  social_02: socialShowOffScript,
  social_03: socialStoodUpScript,
  social_04: socialMediaAnxietyScript,
  social_05: socialDebateScript,
  social_06: socialEmotionalDumpsterScript,
  social_07: socialWallflowerScript,
  social_08: socialBodyShamingScript,
  social_09: socialConformityScript,
  social_10: socialLeftOnReadScript,
  
  // Inner
  inner_01: innerDoomscrollingScript,
  inner_02: innerRevengeSpendingScript,
  inner_03: innerDreamProcrastinationScript,
  inner_04: innerDietFailScript,
  inner_05: innerSundayBluesScript,
  inner_06: innerBodyImageScript,
  inner_07: innerBoredomScript,
  inner_08: innerFutureFearScript,
  inner_09: innerMemoryAttackScript,
  inner_10: innerIdentityCrisisScript,
};

export function getScenarioById(id: string): ScenarioScript | undefined {
  return scenarios[id];
}